import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import load from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";
import * as api from "../../api_function";
// import { colors } from "@mui/material";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import * as wifiOptions from "../../options_sets/WifiOptions"


const password = sessionStorage.getItem('password');
const userName = sessionStorage.getItem('userName');
// const userName2 = sessionStorage.getItem('userName');
const userName2 = "manager1";


const optionStateOne = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const genderOptions = [
  { label: "Select Option", value: "" },
  { label: "Male", value: "111260000" },
  { label: "Female", value: "111260001" },
]

const billtypeOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Advance" },
  { value: "2", label: "Arrear" },
];

const segments = [
  { value: "", label: "Select Option" },
  { value: "Connectivity Solution", label: "Connectivity Solution" },
  { value: "Data Centre Products", label: "Data Centre Products" },
  { value: "Internet Service", label: "Internet Service" },
  { value: "SDWAN", label: "SDWAN" },
  { value: "SIP-Trunk", label: "SIP-Trunk" },
  { value: "VOIP", label: "VOIP" },
  { value: "Video Analytics", label: "Video Analytics" },
];

const CommModeOpts = [
  { value: "", label: "Select Option", isDisabled: false },
  { value: "111260000", label: "Email" },
  { value: "111260001", label: "SMS" },
];

const userTypeOption = [

  { value: "111260000", label: "Base Plan" },
  { value: "111260001", label: "User 2" },
  { value: "111260002", label: "User 3" },
  { value: "111260003", label: "User 4" },
  { value: "111260004", label: "Visitor" },
  { value: "111260005", label: "Event" },
];

const speedPerUserOption = [

  { value: "111260000", label: "Upto 5 Mbps" },
  { value: "111260001", label: "Upto 10 Mbps" },
  { value: "111260002", label: "Upto 15 Mbps" },
  { value: "111260003", label: "Upto 20 Mbps" },
  { value: "111260004", label: "Upto 30 Mbps" },
  { value: "111260005", label: "Upto 40 Mbps" },
  { value: "111260006", label: "Upto 50 Mbps" },
  { value: "111260007", label: "Upto 75 Mbps" },
  { value: "111260008", label: "Upto 100 Mbps" },
];

const planValidityOption = [
  { value: "111260000", label: "Per Day" },
  { value: "111260001", label: "Per Month" },
];

const loginMechanismOption = [
  { value: "111260000", label: "Username & Password" },
  { value: "111260001", label: "Username & Password with Additional Authentication" },
  { value: "111260002", label: "RMN & One-Time Password(OTP)" },
  { value: "111260003", label: "MAC Authentication" },
];

const MonitorDaysOpts = [
  { value: "", label: "Select Option", isDisabled: false },
  { value: "111260000", label: "Yes" },
  { value: "111260001", label: "No" },
];

const BusDaysOpts = [
  { value: "", label: "Select Option", isDisabled: false },
  { value: "111260000", label: "MON-SUN" },
  { value: "111260001", label: "MON-SAT" },
  { value: "111260002", label: "MON-FRI" },
];

const optionPayment = [
  { label: "Select Option", value: "0" },
  { label: "Online", value: "Online" },
  { label: "Offline", value: "Offline" },
]
const optionDocument = [
  { label: "AADHAR", value: "AADHAR" },
  { label: "COI", value: "CIN" },
  { label: "GST", value: "GST" },
  { label: "DL", value: "LICENCE" },
  { label: "PAN", value: "PAN" },
  // { label: "Voter ID", value: "VOTERID" },
  { label: "MCA", value: "MCA" },
];



const PaymentOpts = [
  { value: "0", label: "Select Option" },
  { value: "111260000", label: "Payment Validation Failed" },
  { value: "111260001", label: "Upfront approved amount and Customer Paid Amount Mismatch" },
  { value: "569480002", label: "Pending" },
  { value: "569480000", label: "Payment Not Received" },
  { value: "569480001", label: "Payment Received" },
];

const payslipOpts = [
  { value: "0", label: "Select Option" },
  { value: "5", label: "RTGS" },
  { value: "1", label: "Cheque" },
  { value: "2", label: "Demand draft" },
  // { value: "7", label: "Credit Card" },
  // { value: "4", label: "NEFT" },
  // { value: "8", label: "Debit Card" },
  // { value: "11", label: "Ezetap" },
  // { value: "12", label: "Ezetap-Cheque" },
  { value: "13", label: "Payment Gateway" },
];

const optionCountry = [{ label: "India", value: "10001" }];
const optionNatinality = [
  { label: "Select Option", value: "0" },
  { label: "Indian", value: "1" },
  { label: "Korean", value: "3" },
  { label: "Other", value: "2" }
];

const optionAuthState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const custmrworkhrsoptions = [
  { value: "", label: "Select Option" },
  { value: "569480000", label: "10 AM to 6 PM" },
  { value: "569480001", label: "6 PM to 2 AM" },
  { value: "569480002", label: "2 AM to 10 AM" },
];

const voiOpts = [
  { value: "", label: "Select Option" },
  { value: "569480000", label: "Yes" },
  { value: "569480001", label: "No" },
]

const CpeDispatchSameOpts = [
  { value: "", label: "Select Option" },
  { value: "111260000", label: "Yes" },
  { value: "111260001", label: "No" },
]

const userManagementOption = [
  { value: "", label: "Select Option" },
  { value: "111260000", label: "Yes" },
  { value: "111260001", label: "No" },
]

const customercatOpts = [
  { value: "", label: "Select Option" },
  { value: "569480000", label: "OSP" },
  { value: "569480001", label: "Non OSP" },
];


const reportReqOpts = [
  { value: "", label: "Select Option" },
  { value: "111260000", label: "Yes" },
  { value: "111260001", label: "No" },
];

const DashboardReqOpts = [
  { value: "", label: "Select Option" },
  { value: "111260000", label: "Yes" },
  { value: "111260001", label: "No" },
];

const ServiceProviders = [
  { label: "Select Service Provider 1", value: "0" },
  { label: "Jio", value: "111260000" },
  { label: "ACT Fibernet", value: "569480014" },
  { label: "N.A", value: "569480012" },
  { label: "Others", value: "569480013" },
  { label: "Airtel", value: "569480000" },
  { label: "Aircel", value: "569480002" },
  { label: "BSNL", value: "569480003" },
  { label: "Hathway", value: "569480004" },
  { label: "MTNL", value: "569480005" },
  { label: "Nextra", value: "569480006" },
  { label: "Reliance Communications", value: "569480007" },
  { label: "Sify", value: "569480008" },
  { label: "Tata Communications", value: "569480009" },
  { label: "Tata DOCOMO", value: "569480010" },
  { label: "Tikona Infinet", value: "569480011" },
  { label: "Vodafone", value: "569480001" },
];

const firewallOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

const selfpoOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

const SecuritypeOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Refundable Security Deposit" },
  { value: "2", label: "Non-Refundable Security Deposit" },
];

const BusinessCAFmanageForm = () => {
  const modalRef = useRef(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const CafId = searchParams.get("CafId");
  const leadId = searchParams.get("LeadId");
  const OppId = searchParams.get("OppId");

  sessionStorage.setItem("OppId", OppId);
  // console.log("leadId", leadId);
  // console.log("OppId", OppId);

  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [getCafDetails, setCafDetails] = useState();
  const [getCustomerImageStatus, setCustomerImageStatus] = useState(null);
  const [getBuildingInst, setBuildingInst] = useState();
  const [getBuildingBill, setBuildingBill] = useState();
  const [getAreaBill, setAreaBill] = useState();
  const [getAreaInst, setAreaInst] = useState();
  const [activeForm, setActiveForm] = useState("form1");
  const [loading, setLoading] = useState(true);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [getFormInput, setFormInput] = useState([]);
  const [customerWorkingHours, setCustomerWorkingHours] = useState([]);


  const [paymentDetails, setPaymentDetails] = useState({});
  const [customerdropdetails, setCustomerdropdetails] = useState([]);
  const [reldropdetails, setReldropdetails] = useState([]);

  const [statusNoCaf, setStatusNoCaf] = useState(false);
  const [statusCaf, setStatusCaf] = useState(false);
  const [disableFileds, setDisableFields] = useState();
  const [salutate, setSalutate] = useState();
  const [mobileNo, setMobileNo] = useState();

  const [Caflatitude, setCaflatitude] = useState();
  const [Caflongitude, setCaflongitude] = useState();

  const [emailId, setEmailId] = useState();
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectGroup, setSelectGroup] = useState();
  const [selectRelationship, setSelectRelationship] = useState();
  const [compID, setcompID] = useState("");
  const [groupID, setgroupID] = useState("");

  const [customerComp, setcustomerComp] = useState();
  const [customerGroup, setcustomerGroup] = useState();
  const [selectedFirmType, setSelectedFirmType] = useState();
  const [firmTypes, setFirmTypes] = useState([]);
  const [apiProd, setApiProd] = useState();
  const [productdropdetails, setProductdropdetails] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState();
  const [selectedPlanCatType, setSelectedPlanCatType] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [CafNO, setCafNO] = useState();
  const [Voice, setVoice] = useState();
  const [TotalAmt, setTotalAmt] = useState("");
  const [Securitydep, setSecuritydep] = useState("");
  const [Securitydeptype, setSecuritydeptype] = useState("");
  const [transactionrefid, settransactionrefid] = useState("");
  const [approvalCode, setapprovalCode] = useState("");
  const [creditDetails, setcreditDetails] = useState("");
  const [chequeDDNo, setchequeDDNo] = useState("");
  const [branchName, setbranchName] = useState("");
  const [chequeDate, setchequeDate] = useState("");
  const [selectedPaySlipOption, setselectedPaySlipOption] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [BankDropDetails, setBankDropDetails] = useState([]);
  const [selectBank, setselectBank] = useState("");
  const [isGst, setIsGst] = useState();
  const [gst, setgst] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [GstNumber, setGstNumber] = useState("");
  const [apiStateCode, setApiStateCode] = useState("");
  const [apiCityCode, setApiCityCode] = useState("");
  const [apiAreaCode, setApiAreaCode] = useState("");
  const [apiSocietyCode, setApiSocietyCode] = useState("");
  const [apiFloorCode, setApiFloorCode] = useState("");
  const [apipinCode, setApiPinCode] = useState("");
  const [apiblockCode, setApiblockCode] = useState("");
  const [optionState, setOptionState] = useState([]);
  const [optionCity, setOptionCity] = useState([]);
  const [optionArea, setOptionArea] = useState([]);
  const [optionSociety, setOptionSociety] = useState([]);
  const [selectCity, setSelectCity] = useState();
  const [cityType, setCityType] = useState([]);
  const [selectArea, setSelectArea] = useState();
  const [areaList, setAreaList] = useState([]);
  const [areaBillList, setAreaBillList] = useState([]);
  const [selectSociety, setSelectSociety] = useState();
  const [billBuildingList, setBillBuildingList] = useState([]);
  const [selectBuilding, setSelectBuilding] = useState("");
  const [OtpValue, setOtpValue] = useState();
  const [OtpValue2, setOtpValue2] = useState();
  const [showOtpPage, setShowOtpPage] = useState(false);
  const [otpAuthStatus, setotpAuthStatus] = useState();
  const [paymentStatus, setpaymentStatus] = useState(PaymentOpts[0]);
  const [otc, setotc] = useState("");
  const [RCAmount, setRCAmount] = useState("");
  const [tan, setTan] = useState();
  const [pan, setPan] = useState();
  const [BTNSubmit, setBTNSubmit] = useState(false);
  const [BTNCreate, setBTNCreate] = useState(false);
  const [leadDisable, setLeadDisable] = useState(false);
  const [docHide, setdocHide] = useState(false);
  const [selectKycDoc, setSelectKycDoc] = useState("");
  // const [getCafNo,setGetCafNo]= useState("");
  const [customerImg, setCustomerImg] = useState("")
  // const [attachedFile, setAttachedFile] = useState("");
  // const [getRc, setRc] = useState(null);

  const [wcrDetails, setWcrDetails] = useState([]);
  const [npDetails, setNpDetails] = useState([]);
  const [irDetails, setIrDetails] = useState([]);
  const [selectVoip, setSelectVoip] = useState(voiOpts[0]);
  const [cusCategory, setCusCategory] = useState(customercatOpts[0]);
  const [cpeDispatchSame, setCpeDispatchSame] = useState(CpeDispatchSameOpts[0]);
  const [serviceProvider, setServiceProvider] = useState(ServiceProviders[0]);
  const [otherFirewall, setOtherFirewall] = useState(firewallOpts[0]);
  const [selectSelfpo, setSelectSelfpo] = useState(selfpoOpts[0]);

  const [userManagement, setUserManagement] = useState(userManagementOption[0]);
  const [reportReq, setReportReq] = useState(reportReqOpts[0]);
  const [dashboardReq, setDashboardReq] = useState(DashboardReqOpts[0]);

  const [userType, setUserType] = useState("");
  const [speedPerUser, setSpeedPerUser] = useState("");
  const [planValidity, setPlanValidity] = useState("");
  const [loginMechanism, setLoginMechanism] = useState("");
  const [getUserlicencegridData, setUserlicencegridData] = useState([]);
  const getUserTypeOptions = wifiOptions?.getUserTypeOptions();
  const getSpeedPerUserOptions = wifiOptions?.getSpeedPerUserOptions();
  const [getPaymentDOAFlag, setPaymentDOAFlag] = useState(false);
  const [getDedupeDOAFlag, setDedupeDOAFlag] = useState(false);
  const [gender, setGender] = useState();
  const [userdata, setUserData] = useState({
    techSupportEmail: "",
    InstPin: "",
    InstBuildingNo: "",
    Remarks: "",
    Redunancy: false,
    Block: "",
    Status: "",
    Statuscode: "",
    OppId: "",
    LeadId: "",
    PriceList: "",
    Topic: "",
    StateId: "",
    CityId: "",
    AreaId: "",
    BuildingId: "",
    BuildingCode: "",
    SpecificArea: "",
    SpecificBuilding: "",
    Building_BuildingStatus: "",
    NoOfUsers: "",
    NoOfBeds: "",
    IndustryId: "",
    ApprovalRequiredFlag: "",
    Reason: "",
    Area: "",

    Businesssegment: "",
    State: "",
    Salutation: "",
    Relationship: "",
    PostalCode: "",
    Mobilephone: "",
    Media: "",
    Lco: null,
    Industry: "",
    Group: "",
    Floor: "",
    TPFeasibilty: "",
    CreateAreaOrBuilding: false,
    Firmtype: "",
    Product: "",
    ProductSegment: "",
    FeasibilityRequired: false,
    Existingprovider: "",
    Emailaddress: "",
    Country: "",
    Companyname: "",
    City: "",
    leadname: "",
    Buildingname: "",
    BuildingNo: "",
    ContactPerson: "",
    CustomerSegment: "",
    LastMileType: "",
    UpTimesla: "",
    FirewallSetToExpire: "",
    CompanySelf: "",
    PoLock: "",
    Price: "",
    OriginatingLead: "",
    FirewallAwc: "",
    PoNext: "",
    Company: "",
    TotalAmount: "",
    VerticalID: "",
    TypeOfOrder: "",
    PocClosureDate: "",
    TurnOver: "",
    SocietyName: "",
    SocietyId: "",
    SocietyStatus: "",
    HousePlotFlatNo: "",
    BlockTowerNumber: "",
    OTCAmount: "",
    SDAmount: "",
    RCAmount: "",
    IsPaymentLinkSendToCustomer: "",
    UpfrontApprovedSDAmount: "",
    UpfrontApprovedOTCAmount: "",
    UpfrontApprovedRCAmount: "",
    UpfrontReqSDAmount: "",
    UpfrontReqOTCAmount: "",
    UpfrontReqRCAmount: "",
    ApprovedSDAmount: "",
    ApprovedOTCAmount: "",
    ApprovedRCAmount: "",
    totalAmount: "",
    firstName: "",
    otp: "",
    dDupStatus: "",
    paymentDoaStatus: "",
    authorName: "",
    authorFather: "",
    authResidentialAddress: "",
    autherMobile: "",
    autherPhone: "",
    autherEmail: "",
    autherPinCode: "",
    contactName: "",
    billmail: "",
    billPhone: "",
    BillNationality: "",
    billedState: "",
    billCity: "",
    billArea: "",
    billBuildingNo: "",
    billBuildingId: "",
    billPin: "",
    billFloor: "",
    paymentDate: "",
    CpeContactPersonName: "",
    CpeContactPersonPhone: "",
    CpeDispatchAddress: "",
    RemarkCPE: "",
    ssIdNomenclatureOne: "",
    ssIdNomenclatureTwo: "",
    reqBandwidth: "",
    specialReq: "",
    userType: "",
    noUserLicences: "",
    speedPerUser: "",
    planValidity: "",
    dataValume: "",
    devicesPerUser: "",
    loginMechanism: "",
    gstNo: "",
    panNo: "",
    tanNo: "",
    ServiceId: ""
  });
  const [paymentButton, setPaymentButton] = useState("");

  //naveen
  const [companyOptions, setCompanyOptions] = useState([]);

  const [getCafDigiHome, setCafDigiHome] = useState({});
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [timer, setTimer] = useState(0);
  const [getCodeFlag, setCodeFlag] = useState(false);
  const [getCustomerPicture, setCustomerPicture] = useState({});
  const [getSellerPicture, setSellerPicture] = useState({});
  const [getSelectDocumentType, setSelectDocumentType] = useState();
  // const [getCafId, setCafId] = useState();
  const [getLeadId, setLeadId] = useState();
  const [selectDocument, setSelectDocument] = useState();

  const [industrydropdetails, setindustrydropdetails] = useState([]);
  const [selectIndustry, setSelectIndustry] = useState();

  const [isOtpVerified, setOtpVerified] = useState(null);
  const [kycDocStatus, setKycDocStatus] = useState("");
  const [selectPaymentMode, setSelectPaymentMode] = useState(optionPayment[0])
  const [isPaymentLinkSendToCustomer, setIsPaymentLinkSendToCustomer] = useState("")
  // const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [filteredPayslipOpts, setFilteredPayslipOpts] = useState(payslipOpts);
  const [selectState, setSelectState] = useState("");

  const [selectAuthCountry, setSelectAuthCountry] = useState(optionCountry[0]);
  const [selectAuthNatinality, setSelectAuthNatinality] = useState({ label: "Indian", value: "1" });
  const [selectAuthState, setSelectAuthState] = useState("");
  const [selectBillState, setSelectBillState] = useState("");
  const [selectInstState, setSelectInstState] = useState("");
  const [cityAuthOption, setCityAuthOption] = useState([]);
  const [selectAuthCity, setSelectAuthCity] = useState("");
  const [selectBillCity, setSelectBillCity] = useState("");
  const [selectBillArea, setSelectBillArea] = useState("");
  const [selectBillBuilding, setSelectBillBuilding] = useState("");
  const [selectInstCity, setSelectInstCity] = useState("");
  const [useSameData, setUseSameData] = useState(false);
  const [useSameDataForCPE, setUseSameDataForCPE] = useState(false);

  const [productsegment, setProductSegment] = useState("");


  // console.log("selectedFirmType",selectedFirmType);

  const filteredDocumentOptions =
    selectedFirmType?.value == "6"
      ? optionDocument
      : optionDocument.filter(doc => doc.value !== "AADHAR");

  useEffect(() => {
    if (selectedFirmType?.value != "6" && selectDocument?.value == "AADHAR") {
      setSelectDocument(null);
    }
  }, [selectedFirmType]);

  const [getNewCafUpdateRequestBody, setNewCafUpdateRequestBody] = useState({
    customerKYCdocument: {
      customerKYCfileNameWithExtension: "",
      customerKYCAddress: "",
      customerKYCfileContent: "",
    },
  });


  const handleUserType = (selectedState) => {
    setUserType(selectedState);
  };

  const handleSpeedPerUser = (selectedState) => {
    setSpeedPerUser(selectedState);
  };

  const handlePlanValidity = (selectedState) => {
    setPlanValidity(selectedState);
  };

  const handleLoginMechanism = (selectedState) => {
    setLoginMechanism(selectedState);
  };


  const handleSelectState = (selectedState) => {
    setSelectState(selectedState);
  };

  const handleSelectBillState = (selectedState) => {
    setSelectBillState(selectedState);
    setSelectBillCity("")
    setSelectBillArea("")
    setSelectBillBuilding("")
  };

  const handleVoipPort = (selectedState) => {
    setSelectVoip(selectedState);
  };

  const handleServiceProviderChange = (selected) => {
    setServiceProvider(selected);
  }

  const handleFirewall = (selected) => {
    setOtherFirewall(selected);
  }

  const handleSelfPo = (selected) => {
    setSelectSelfpo(selected);
  }

  const handleCustomerCategoryChange = (selected) => {
    setCusCategory(selected);
  }

  const handleCpeDispatchSameChange = (selected) => {
    setCpeDispatchSame(selected);
  }

  const handleUserManagementChange = (selected) => {
    setUserManagement(selected);
  }

  const handleReportReqChange = (selected) => {
    setReportReq(selected);
  }

  const handleDashboardReqChange = (selected) => {
    setDashboardReq(selected);
  }

  const handleSelectAuthCountry = (selectCountry) => {
    setSelectAuthCountry(selectCountry);
  };

  const handleSelectAuthNatinality = (selected) => {
    setSelectAuthNatinality(selected);
  };



  const handleSelectAuthState = (selectedState) => {
    setSelectAuthState(selectedState);
    setSelectAuthCity("");
  };

  const handleSelectAuthCity = (selectedOption) => {
    setSelectAuthCity(selectedOption);
  };






  const handleCheckboxChange = () => {
    // console.log("checked")
    const newValue = !useSameData;
    setUseSameData(newValue);

    if (newValue) {
      // setOptionState(responseData1.Response);
      // console.log("userdata: ", userdata);

      const SelectedBillState = optionStateOne?.find(
        (option) => option.code == userdata?.StateId
      );
      // console.log("SelectedApiCity", optionStateOne, SelectedBillState);
      setSelectBillState({
        value: SelectedBillState.code,
        label: SelectedBillState.name,
      });

      // const SelectedBillCity = cityType?.find(
      //   (option) => option.code == userdata?.CityId
      // );
      // console.log("SelectedBillCity", cityAuthOption, userdata?.CityId);
      // setSelectBillCity({
      //   value: SelectedBillCity.CityCode,
      //   label: SelectedBillCity.CityName,
      // });
      setSelectBillCity({
        label: userdata?.City,
        value: userdata?.CityId
      });

      setSelectBillArea({
        label: userdata?.Area,
        value: userdata?.AreaId
      });

      setSelectBillBuilding({
        label: userdata?.Buildingname,
        value: userdata?.BuildingId
      });



      setBuildingBill((prevData) => ({
        ...prevData,
        BuildingName: getBuildingInst?.BuildingName
      }));
      setUserData((prevData) => ({
        ...prevData,
        contactName: userdata.ContactPerson,
        billmail: userdata.Emailaddress,
        billPhone: userdata.Mobilephone,
        BillNationality: "",
        billedState: userdata.State,
        billCity: userdata.City,
        billArea: userdata.Area,
        billBuildingNo: userdata.BuildingNo,
        billBuildingId: userdata.BuildingId,
        billPin: userdata.InstPin,
        billFloor: userdata.Floor,
        BillBuildingname: userdata.Buildingname,
      }));
    } else {
      const SelectedBillState = optionStateOne.find(
        (option) => option.code == ""
      );
      // console.log("SelectedBillState", optionStateOne, SelectedBillState);
      setSelectBillState({
        value: SelectedBillState.code,
        label: SelectedBillState.name,
      });

      setBuildingBill((prevData) => ({
        ...prevData,
        BuildingName: ""
      }));
      setUserData((prevData) => ({
        ...prevData,
        contactName: "",
        billmail: "",
        billPhone: "",
        BillNationality: "",
        billedState: "",
        billCity: "",
        billArea: "",
        billBuildingNo: "",
        billBuildingId: "",
        billPin: "",
        billFloor: "",
      }));
    }
  };


  const handleCheckboxChangeForCPE = () => {
    const newValueForCPE = !useSameDataForCPE;
    setUseSameDataForCPE(newValueForCPE);


    if (newValueForCPE) {
      setUserData((prevData) => ({
        ...prevData,
        CpeContactPersonName: userdata.ContactPerson,
        CpeContactPersonPhone: userdata.Mobilephone,
        CpeDispatchAddress: `${userdata.BuildingNo} , ${userdata.Floor}  , ${userdata.Area} , ${userdata.State} ,${userdata.City}, ${userdata.InstPin}`,
      }));
    } else {
      setUserData((prevData) => ({
        ...prevData,
        CpeContactPersonName: "",
        CpeContactPersonPhone: "",
        CpeDispatchAddress: "",
      }));
    }
  }

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      const handleShowModal = (event) => {
        // Button that triggered the modal
        const button = event.relatedTarget;
        // Extract info from data-bs-* attributes
        const recipient = button.getAttribute('data-bs-whatever');
        // Update the modal's content.
        const modalTitle = modalElement.querySelector('.modal-title');
        const modalBodyInput = modalElement.querySelector('.modal-body input');

        if (modalTitle) {
          modalTitle.textContent = 'New message to ' + recipient;
        }
        if (modalBodyInput) {
          modalBodyInput.value = recipient;
        }
      };

      modalElement.addEventListener('show.bs.modal', handleShowModal);

      // Cleanup the event listener when the component unmounts
      return () => {
        modalElement.removeEventListener('show.bs.modal', handleShowModal);
      };
    }
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      try {


        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectBillState?.value || userdata.StateId,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityType(cityData.Response.Data);
        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );

          setCityType([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (selectBillState || userdata?.StateId) {
      fetchCities();
    }
  }, [selectBillState, userdata?.StateId]);



  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCity(selectedOption);
    setSelectArea("");
    // setSelectBuilding("");
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem('password'),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem('userName'),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :", areaData.Response.Data);
        setAreaList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectBillCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectBillCity(selectedOption);
    setSelectBillArea("");
    setSelectBillBuilding("");
    // setSelectBuilding("");
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem('password'),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem('userName'),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :", areaData.Response.Data);
        setAreaBillList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectBillArea = async (selectedOption) => {
    try {
      // console.log(selectedOption);

      setSelectBillArea(selectedOption);
      setSelectBillBuilding("");


      let payload = {
        areaCode: selectedOption.value,
        areaName: selectedOption.label.split(" ")[0]
      }
      let getBuilding = await api.getBuilding(payload);
      // console.log("getBuilding: ", getBuilding);

      if (getBuilding.Response && Array.isArray(getBuilding.Response.Data)) {
        setBillBuildingList(getBuilding.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching building data:", error);
    }
  };



  const SendLinkForCustomerLivePicture = async () => {
    try {
      let CustomerLink;
      if (CafId) {
        CustomerLink = window.location.origin + "/crm/businessCustomerLivePhoto/?CafId=" + btoa(CafId);
      } else {
        CustomerLink = window.location.origin + "/crm/businessCustomerLivePhoto/?OppId=" + btoa(OppId);
      }
      // console.log(CustomerLink);

      const req = { OppId: OppId || "", CafID: CafId, CustomerLink: CustomerLink }
      const sendlink = await api.sendCustomerLiveImageURL(req);
      // console.log(sendlink);
      if (sendlink.Status == "Success") {
        toast.success("Link Sent to customer!")
      } else {
        toast.warning("Faild to send link!")
      }

    } catch (err) {
      console.error(err);
    }
  }

  const handleUserLicenceGrid = async () => {

    if (!userType.value) {
      toast.warning("Please Select User Type", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!speedPerUser.value) {
      toast.warning("Please Select Speed Per User", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!planValidity.value) {
      toast.warning("Please Select Plan Validity", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!loginMechanism.value) {
      toast.warning("Please Select Login Mechanism", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!userdata.noUserLicences) {
      toast.warning("Please Enter User Licences Required*", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!userdata.dataValume) {
      toast.warning("Please Enter Data Valume*", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!userdata.devicesPerUser) {
      toast.warning("Please Enter Device Per user*", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else {

      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Action": "createUserlicenceGrid",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "OppId": OppId ? OppId : "",
          "UserType": userType.value ? userType.value : "",
          "NoofUserLicensesrequired": userdata.noUserLicences ? userdata.noUserLicences : "",
          "SpeedPerUser": speedPerUser.value ? speedPerUser.value : "",
          "PlanValidityDataVolumeCriteria": planValidity.value ? planValidity.value : "",
          "DataVolumeinGB": userdata.dataValume ? userdata.dataValume : "",
          "DevicesperUser": userdata.devicesPerUser ? userdata.devicesPerUser : "",
          "LoginMechanism": loginMechanism.value ? loginMechanism.value : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const data = await response.json();
        if (data.Response.StatusCode == 200) {
          toast.success(data.Response.Message, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }

      } catch (error) {
        toast.error("An error occurred. Please try again later.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
  }



  useEffect(() => {
    const fetchdata = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          "Action": "getUserlicencegrid",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "OppId": OppId ? OppId : "",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password')
        }

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const data = await response.json();
        // console.log("getUserlicencegrid", data);

        setUserlicencegridData(data?.Response?.userlicense)

      } catch (err) {
        console.error("Error fetching data:", err);
        // return err.message;
      }
    }
    fetchdata();
  }, []);


  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectAuthState.value,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();
        // console.log(cityData);


        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          // console.log(cityData.Response.Data);

          const transformedOptions = cityData.Response.Data.map(
            (option) => ({
              label: option.CityName,
              value: option.CityCode,
            })
          );
          // console.log(transformedOptions);

          setCityAuthOption(transformedOptions);

          let selectedCity = transformedOptions.find((data) => data.value == getCafDetails?.billingAddress.Bill_City)
          // console.log(cityAuthOption, { cityCode: selectedCity?.value, cityName: selectedCity?.label });

          let getAreaList = await api.getArea({ cityCode: selectedCity?.value, cityName: selectedCity?.label });
          // console.log(getAreaList);

        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );
          setCityAuthOption([]);

        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Fetch cities only if a state is selected
    if (selectAuthState) {
      fetchCities();
    }
  }, [selectAuthState]);

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };



  const handlePaymentMode = (selectedOption) => {
    setSelectPaymentMode(selectedOption); // Update selected payment mode
    setselectedPaySlipOption("")
    if (selectedOption?.value === "Offline") {
      // Show only Cheque, DD, NEFT, RTGS
      setFilteredPayslipOpts(
        payslipOpts.filter((option) =>
          ["1", "2", "4", "5"].includes(option.value)
        )
      );
    } else if (selectedOption?.value === "Online") {
      // Show all options except Cheque, DD, NEFT, RTGS
      setFilteredPayslipOpts(
        payslipOpts.filter(
          (option) => !["1", "2", "4", "5"].includes(option.value)
        )
      );
    } else {
      // Reset to show all options if no valid payment mode is selected
      setFilteredPayslipOpts(payslipOpts);
    }
  };



  const handleChange = (e) => {
    const { name, value, type } = e.target;
    // console.log(name, value);
    setUserData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? String(value) : value,
    }));
  };

  useEffect(() => {
    // Get the current URL's query parameters
    const params = new URLSearchParams(window.location.search);
    const CafId = params.get("CafId");
    const LeadId = params.get("LeadId");
    // console.log("CafId", CafId, LeadId);
    // setCafId(CafId)
    setLeadId(LeadId)
  }, []);

  useEffect(() => {
    const fetchGetIndustry = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        if (result.Status == "Success") {
          const industryType = result.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          // console.log(industryType);
          setindustrydropdetails(industryType);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {

      }
    };

    fetchGetIndustry();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const firmTypeApiUrl = process.env.REACT_APP_API_URL;
        const firmTypeRequestBody = {
          Action: "firmTypeList",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          userName: sessionStorage.getItem("userName"),
          password: sessionStorage.getItem("password")
        }
        const firmTypeResponse = await fetch(firmTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(firmTypeRequestBody),
        });
        const firmTypeData = await firmTypeResponse.json();
        // console.log("firmTypeData.Response.Data", firmTypeData.Response.Data);

        if (firmTypeData.Response.Data) {

          const transformedOptions = firmTypeData.Response.Data.map(
            (option) => ({
              label: option.Text,
              value: option.Value,
            })
          );
          setFirmTypes(transformedOptions);
          // console.log("transformedOptions", transformedOptions.find((data) => data.value == getCafDetails?.companyDetail?.FirmType))
          // console.log("FirmType", getCafDetails?.companyDetail?.FirmType)
          setSelectedFirmType(transformedOptions.find((data) => data.value == getCafDetails?.companyDetail?.FirmType))
        } else {
          setFirmTypes([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [getCafDetails]);





  const manageDocClick = () => {
    navigate(`/businessCAFmangeNewDoc?CafId=${CafId}&OppId=${OppId}`);
  };

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
  };

  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };



  const downloadPdfFromBase64 = (base64String, fileName) => {
    const binaryString = atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const redirectBroadbandCafPage = () => {
    navigate("/businessCaf");
  };

  const SalutationOpts = [
    { value: "0", label: "Select Option", isDisabled: false },
    { value: "1", label: "Mr." },
    { value: "2", label: "Mrs." },
    { value: "3", label: "Miss." },
  ];

  const handleSAlutation = (selectedOption) => {
    // console.log("salutate", selectedOption.value);
    setSalutate(selectedOption.value);
  };






  const formInputData = (event) => {
    const { name, value, type } = event.target;
    setFormInput((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
    setUserData((prevDetails) => ({
      ...prevDetails,
      [name]: type === "number" ? String(value) : value,
    }));
  }

  const handleGender = (selectedOption) => {
    // console.log("salutate", selectedOption.value);
    setGender(selectedOption.value);
  };


  //naveen
  const handleCustomerdetailChange = (event) => {
    const { name, value } = event.target;
    // console.log(name, " - ", value);


    if (name == 'firstName') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          FirstName: "", // Update the name property
        },
      }));
      setFirstName(value);
    } else if (name == 'lastName') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          LastName: "", // Update the name property
        },
      }));
      setLastName(value);
    } else if (name == 'mobileNo') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          MobileNo: "", // Update the name property
        },
      }));
      setMobileNo(value);
    } else if (name == 'emailId') {
      setCafDigiHome((prevState) => ({
        ...prevState,
        accountDetail: {
          ...prevState.accountDetail,
          EmailId: "",
        },
      }));
      setEmailId(value);
    } else if (name == 'cafNo') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setCafNO(value);
    } else if (name == 'voice') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setVoice(value);
    } else if (name == 'livePicture') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setVoice(value);
    }
  };




  const handleIndustryChnage = (selected) => {
    setSelectIndustry(selected);
  };
  //naveen


  const compOptions = customerdropdetails?.map((company) => ({
    value: company.Company_ID,
    label: company.Company_Name,
  }));
  useEffect(() => {
    // Set the initial value when customerDetails.Company is available
    if (customerComp) {
      // console.log("customerComp", customerComp);
      const Cid = customerdropdetails.find(
        (company) => company.Company_ID === customerComp
      );
      // console.log("ID", Cid);
      if (Cid) {
        const Company_ID = Cid.Company_Name;
        // console.log("Company_ID:", Company_ID);
        setcompID(Cid.Company_ID);
        setSelectedCompany(customerComp);
        // Call fetchGetRelation after updating state with selected company
        fetchGetRelation(Cid.Company_ID);
      } else {
        // console.log("Company not found in customerdropdetails:", customerComp);
      }
      // console.log("id", customerComp);

      setSelectedCompany(customerComp);
    }
  }, [customerComp, customerdropdetails]);

  const groupOptions = customerdropdetails?.map((group) => ({
    value: group.Group_ID,
    label: group.Group_Name,
  }));

  useEffect(() => {
    // Set the initial value when customerDetails.group is available
    if (customerGroup) {
      const Gid = customerdropdetails.find(
        (group) => group.Group_ID === customerGroup
      );
      // console.log("ID", Gid);
      if (Gid) {
        const Group_ID = Gid.Group_ID;
        setgroupID(Group_ID);
        setSelectGroup(customerGroup);
      } else {
        // console.log("group not found in customerdropdetails:", customerGroup);
      }
      // console.log("id", customerGroup);

      setSelectGroup(customerGroup);
    }
  }, [customerGroup, customerdropdetails]);

  const relationOptions = reldropdetails.map((relationship) => ({
    value: relationship.Relationship_ID,
    label: relationship.Relationship_Name,
  }));
  // console.log("Selected Product Type:", selectedProductType);
  const handleProductTypeChange = (selected) => {
    setSelectedProductType(selected);
  };
  const handlePlanCategory = (selection) => {
    setSelectedPlanCatType(selection);
  };


  const handleFirmTypeChange = (selection) => {
    setSelectedFirmType(selection);
  };
  // const openCamera = () => {
  //   document.getElementById("cameraFileInput").click();
  // };

  const OpenCameraCustomer = (e) => {
    if (window.innerWidth >= 1024) {
      e.preventDefault();
      e.stopPropagation();
      Swal.fire({
        html: '<div style="font-size: 15px;">Customer live picture is not allowed on desktop.</div>',
      })
      return;
    }
    Swal.fire({
      html: '<div style="font-size: 20px;">Select Option</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
      cancelButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // openCamera();
        document.getElementById("cameraFileInputCustomer").click();
      }
    });
  };

  const OpenCameraSeller = () => {
    if (!isOtpVerified) { return; }

    Swal.fire({
      html: '<div style="font-size: 20px;">Select Option</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
      cancelButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // openCamera();
        document.getElementById("cameraFileInputSeller").click();
      }
    });
  };


  const [fileName, setFileName] = useState("");

  const handleFileChangeCustomer = async (event) => {
    // alert(userName?.toLowerCase())
    const file = event.target.files[0];

    if (!file) {
      toast.warning("Please Capture Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    setLoading(true)

    // console.log("handleFileChangeCustomer: ", file.name);
    const extension = (file?.name).substring((file?.name).lastIndexOf("."));
    let fileName = 'customer_live_picture' + extension;

    // Set compression options
    const options = {
      maxSizeMB: 1, // Maximum file size in MB
      maxWidthOrHeight: 1920, // Max width or height
      useWebWorker: true, // Use web worker for faster compression
    };
    try {
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
      // Create a FileReader instance
      const reader = new FileReader();
      reader.onload = async (e) => {
        let base64StringBasic = e.target.result.split(";base64,")[1];
        let base64String = "";

        // ============ Validate Live Picture =============
        if (userName2?.toLowerCase() == "manager1") {
          try {
            setLoading(true)
            const validateImageReq = {
              "oppID": OppId || "",
              "cafID": CafId || "",
              "latitude": Caflatitude || "",
              "longitude": Caflongitude || "",
              "emp_code": sessionStorage.getItem("empId"),
              "image_base64": base64StringBasic
            }
            const imagevalidateResult = await api.validateImage(validateImageReq)
            const imagevalidate = imagevalidateResult?.data?.result;
            // console.log("imagevalidate: ", imagevalidate);

            if (imagevalidate?.code == 200 || imagevalidate?.code == 203) {
              setCustomerImageStatus(imagevalidate)
              if (imagevalidate?.code == 200) {
                base64String = imagevalidate?.data?.watermarked_image
              } else {
                return
              }
            } else {
              setCustomerImageStatus(null)
            }

          } catch (err) {
            console.error(err);
            setCustomerImageStatus(null)
          } finally { setLoading(false) }
        }

        // console.log("Compressed file content:", base64String); // Log base64 content
        const inputText = "Picture Captured";
        setCustomerPicture({ fileNameWithExtension: fileName, fileContent: base64String });
        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          customerImage: { fileNameWithExtension: fileName, fileContent: base64String }
        }));

        // console.log({ fileNameWithExtension: fileName, fileContent: base64String });


        setFileName(inputText); // Set the input text
        // setBase64Content(base64String); // Set the base64 content
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Error compressing the image:", error);
      toast.error("Error compressing the image. Please try again.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    finally {
      setLoading(false)
    }
  };




  const handleFileChangeSeller = async (event) => {
    const file = event.target.files[0];
    // console.log("handleFileChange: ", file);
    const extension = (file.name).substring((file.name).lastIndexOf("."));
    let fileName = 'seller_live_picture' + extension;

    if (!file) {
      toast.warning("Please Capture Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    // Set compression options
    const options = {
      maxSizeMB: 1, // Maximum file size in MB
      maxWidthOrHeight: 1920, // Max width or height
      useWebWorker: true, // Use web worker for faster compression
    };
    try {
      // const now = new Date();

      // const formattedDateTime =
      //   now.getFullYear() + '-' +
      //   String(now.getMonth() + 1).padStart(2, '0') + '-' +
      //   String(now.getDate()).padStart(2, '0') + ' ' +
      //   String(now.getHours()).padStart(2, '0') + ':' +
      //   String(now.getMinutes()).padStart(2, '0') + ':' +
      //   String(now.getSeconds()).padStart(2, '0');
      const now = new Date();
      const extraSeconds = Math.floor(Math.random() * (100 - 50 + 1)) + 50;

      now.setSeconds(now.getSeconds() + extraSeconds);

      const formattedDateTime =
        now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0') + ' ' +
        String(now.getHours()).padStart(2, '0') + ':' +
        String(now.getMinutes()).padStart(2, '0') + ':' +
        String(now.getSeconds()).padStart(2, '0');

      console.log("formattedDateTime", formattedDateTime);
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
      // Create a FileReader instance
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result.split(";base64,")[1];
        // console.log("Compressed file content:", base64String); // Log base64 content
        const inputText = "Picture Captured";
        setSellerPicture({ sellerFileNameWithExtension: fileName, sellerFileContent: base64String });


        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          sellerImage: {
            sellerFileNameWithExtension: fileName,
            sellerFileContent: base64String,
            sellerOTPAuthDate: formattedDateTime,
            sellerOTP: userdata.otp
          }
        }));
        // console.log({ fileName: fileName, docBase64: base64String });


        setFileName(inputText); // Set the input text
        // setBase64Content(base64String); // Set the base64 content
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Error compressing the image:", error);
      toast.error("Error compressing the image. Please try again.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
  };

  const firmtypeOpts = [
    { value: "0", label: "Select Firm Type" },
    { value: "1", label: "Proprietorship" },
    { value: "2", label: "Partnership" },
    { value: "3", label: "Pvt Ltd" },
    { value: "4", label: "LLP" },
    { value: "5", label: "Trust" },
    { value: "6", label: "Individual" },
    { value: "7", label: "LLP" },
  ];

  useEffect(() => {
    // Assuming customerDetails.BusinessDays comes from your API response
    // Update the state when the API data changes
    // console.log("paymentMethod", paymentMethod);
    setselectedPaySlipOption(paymentMethod || "");
  }, [paymentMethod]);

  const handlePaySlipChange = (selected) => {
    const selectedPayin = selected;
    // console.log("selectedPayin", selected);
    setselectedPaySlipOption(selectedPayin.value);
  };



  const handleBankChange = (selected) => {
    const selectOption = selected;
    // console.log("setselectBank", selectOption);
    setselectBank(selectOption);
  };
  const bankOpts = BankDropDetails.map((bank) => ({
    value: bank.BankId, // The value of the option
    label: bank.Bankname, // The label displayed in the dropdown
  }));

  const handleBranchChange = (e) => {
    const selectOption = e.target.value;
    // console.log("setbranchName", selectOption);
    setbranchName(selectOption);
  };

  const handleChequeNo = (e) => {
    const selectOption = e.target.value;
    // console.log("setchequeDDNo", selectOption);
    setchequeDDNo(selectOption);
  };

  const handleChequeDate = (e) => {
    const selectOption = e.target.value;
    // console.log("setchequeDate", selectOption);
    setchequeDate(selectOption);
  };

  useEffect(() => {
    // Assuming paymentDetails.TotalAmount comes from your API response
    // Update the state when the API data changes
    setTotalAmt(paymentDetails.Amount || "");
  }, [paymentDetails.Amount]);
  const handleTotalAmt = (e) => {
    const selection = e.target.value;
    setTotalAmt(selection);
  };

  useEffect(() => {
    // Assuming paymentDetails.TotalAmount comes from your API response
    // Update the state when the API data changes
    setSecuritydep(paymentDetails.SecurityDeposit || "");
  }, [paymentDetails.SecurityDeposit]);
  const handleSecurityDepo = (e) => {
    const selection = e.target.value;
    setSecuritydep(selection);
  };



  const handleSecType = (selected) => {
    const selection = selected;
    setSecuritydeptype(selection.value);
  };

  const [otp, setOtp] = useState("");
  // const [customerData, setCustomerData] = useState({
  //   otp: "",
  // })

  useEffect(() => {
    // Assuming paymentDetails.TransactionReferenceId  comes from your API response
    // Update the state when the API data changes
    settransactionrefid(paymentDetails.TransactionId || "");
  }, [paymentDetails.TransactionId]);
  const handleTransactionRefID = (e) => {
    const selection = e.target.value;
    settransactionrefid(selection);
  };

  useEffect(() => {
    // Assuming paymentDetails.ApprovalCode  comes from your API response
    // Update the state when the API data changes
    setapprovalCode(paymentDetails.ApprovalCode || "");
  }, [paymentDetails.ApprovalCode]);
  const handleApprovalCode = (e) => {
    const selection = e.target.value;
    setapprovalCode(selection);
  };

  useEffect(() => {
    // Assuming paymentDetails.CreditCard4Digit  comes from your API response
    // Update the state when the API data changes
    setcreditDetails(paymentDetails.CreditCard4Digit || "");
  }, [paymentDetails.CreditCard4Digit]);
  const handleCreditdetails = (e) => {
    const selection = e.target.value;
    setcreditDetails(selection);
  };


  const handleIsGst = (selectedOption) => {
    // console.log("selectedOption", selectedOption);
    const gst = selectedOption;
    // setgst(gst);
    setIsGst(gst);
  };
  const GstOpts = [
    { value: "0", label: "Select Option" },
    { value: "569480000", label: "Yes" },
    { value: "569480001", label: "No" },
  ];



  const handlePaymentStatus = (selection) => {
    setpaymentStatus(selection);
  };

  const handleSelectFile = (selectDocument) => {

    // console.log(selectDocument);
    setSelectDocumentType(selectDocument.label);
    setSelectDocument(selectDocument)
  }



  const handleOTCChange = (e) => {
    const value = e.target.value;
    setotc(value);
  };

  const handlePAN = (e) => {
    const value = e.target.value.toUpperCase(); // Convert input to uppercase
    setPan(value);

    if (value.length === 10) {
      // Trigger validation only when input length is 10
      const regexPAN = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
      const isValid1 = regexPAN.test(value);

      if (!isValid1) {
        toast.warning(
          "Please Enter PAN in CAPITAL Letters and correct format (ABCDE1234A)",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
      } else {
        toast.success("PAN entered successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
  };
  // const handleChange = (e) => {
  //   // console.log(e.target.name);
  //   // console.log(e.target.value);
  //   setCustomerData({ ...customerData, [e.target.name]: e.target.value });
  // };

  const handleGstNumber = (e) => {
    const gstNo = e.target.value.toUpperCase(); // Convert input to uppercase
    setGstNumber(gstNo);

    if (gstNo.length === 15) {
      // Trigger validation only when input length is 15
      const regexGST = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;
      const isValid2 = regexGST.test(gstNo);

      if (!isValid2) {
        toast.warning(
          "Please Enter GST in CAPITAL Letters and correct format (12ABCDE1234A1A1 or 12ABCDE1234A1AA)",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
      } else {
        toast.success("GST entered successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
  };

  const handleTAN = (e) => {
    const value = e.target.value.toUpperCase(); // Convert input to uppercase
    setTan(value);

    if (value.length === 10) {
      // Trigger validation only when input length is 10
      const regexTAN = /^([A-Z]){4}([0-9]){5}([A-Z]){1}?$/;
      const isValid3 = regexTAN.test(value);

      if (!isValid3) {
        toast.warning(
          "Please Enter TAN in CAPITAL Letters and correct format (ABCD12345A)",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
      } else {
        toast.success("TAN entered successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
  };
  const fetchLatLong = async (address) => {
    try {
      // Prepare API payload
      const payload = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getLatLong",
        address: address
      };

      // Send API request
      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      // console.log("Latitude and Longitude: ", result);
      if (result?.Status === "Success") {
        setCaflatitude(result.Response.latitude);
        setCaflongitude(result.Response.longitude);
        // You can handle the successful response here
      } else {
        console.error("Failed to fetch Latitude and Longitude:", result);
        // Handle failure here
      }
    } catch (error) {
      console.error("Error fetching Latitude and Longitude:", error);
      // Handle error here
    }
  };




  const handleSendOtp = async () => {
    setCodeFlag(true)
    if (!isTimerActive) {
      // console.log("Code Sent!");
      startTimer(30); // Start a 30-second timer
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const otpRequestBody = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "generateOTPforSel",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        GenerateOTP: "Yes",
      };

      const otpResponse = await fetch(apiUrl, {
        method: "POST", headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(otpRequestBody),
      });

      const sendOtpData = await otpResponse.json();
      // console.log("send otp :", sendOtpData)
      if (sendOtpData.Status === "Success") {
        // console.log("send otp :", sendOtpData.Status)
        toast.success("OTP sent successfully")
        // setOtpSent(true);
        setOtp(sendOtpData.Response.OTP);
        // console.log("sendOtpData.Response :", sendOtpData.Response);
      } else {
        console.error('Failed to send OTP:', otpResponse.statusText);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }

  };


  const startTimer = (seconds) => {
    setIsTimerActive(true);
    setTimer(seconds);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsTimerActive(false); // Enable the resend button
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };



  // const handleFileChangekycDocOCR = async (event) => {
  //   try {
  //     const file = event.target.files[0];
  //     const file1 = event.target.files[0].name;
  //     // console.log("file1", file1);
  //     setSelectKycDoc(file1);
  //     if (!file) {
  //       toast.warning("Select KYC Document", {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         autoClose: 1500,
  //       });
  //       return;
  //     }
  //     setLoading(true);
  //     // console.log("handleFileChange: ", file);
  //     const extension = file.name.substring(file.name.lastIndexOf("."));
  //     const fileType = file.type; // MIME type of the file
  //     let fileName = getSelectDocumentType + extension;

  //     // Check if the file is an image
  //     if (fileType.startsWith("image/")) {
  //       // Set compression options for images
  //       const options = {
  //         maxSizeMB: 1, // Maximum file size in MB
  //         maxWidthOrHeight: 1920, // Max width or height
  //         useWebWorker: true, // Use web worker for faster compression
  //       };

  //       const compressedFile = await imageCompression(file, options);

  //       // Read the compressed file as Base64
  //       const reader = new FileReader();
  //       reader.onload = async (e) => {
  //         const base64String = e.target.result.split(";base64,")[1];
  //         await processKYCFile(fileName, base64String);
  //       };
  //       reader.readAsDataURL(compressedFile);
  //     } else if (fileType === "application/pdf") {
  //       // Read the PDF file as Base64
  //       const reader = new FileReader();
  //       reader.onload = async (e) => {
  //         const base64String = e.target.result.split(";base64,")[1];
  //         await processKYCFile(fileName, base64String);
  //       };
  //       reader.readAsDataURL(file);
  //     } else {
  //       toast.warning("Unsupported file type. Please upload an image or PDF", {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         autoClose: 1500,
  //       });
  //       return;
  //     }
  //   } catch (error) {
  //     console.error("Error processing file:", error);
  //     // toast.error("Error uploading document.");
  //   } finally {
  //     // setLoading(false);
  //     setLoading(false);
  //   }
  // };


  const handleFileChangekycDocOCR = async (event) => {
    try {
      const file = event.target.files[0];

      if (!file) {
        setSelectKycDoc("");
        // if you use preview state, also clear it here
        // setFilePreviewUrl(null);
        // setFilePreviewType(null);
        toast.warning("Select KYC Document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      const file1 = file.name;
      setSelectKycDoc(file1);

      const extension = file.name.substring(file.name.lastIndexOf("."));
      const fileType = file.type; // MIME type of the file
      let fileName = getSelectDocumentType + extension;

      // 👉 If you already set preview (iframe/img) above, keep that code as-is.
      // The important part for password check is **before** we call processKYCFile.

      // 🔹 Special handling for PDF: check password protection first
      if (fileType === "application/pdf") {
        const isProtected = await isPdfPasswordProtected(file);

        if (isProtected) {
          // ❌ Password-protected → do NOT call processKYCFile
          toast.warning(
            "This PDF is password protected. Please upload an unlocked document.",
            {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 2000,
            }
          );
          return; // STOP here
        }
        // else {
        //   // ✅ Not password protected – optional success/info toast
        //   toast.success("PDF is not password protected. Processing document...", {
        //     position: toast.POSITION.BOTTOM_CENTER,
        //     autoClose: 1500,
        //   });
        // }
      }

      // From here onward, we know:
      // - It's an image OR
      // - It's a PDF that is NOT password-protected
      setLoading(true);

      if (fileType.startsWith("image/")) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);

        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64String = e.target.result.split(";base64,")[1];
          await processKYCFile(fileName, base64String);
        };
        reader.readAsDataURL(compressedFile);
      } else if (fileType === "application/pdf") {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64String = e.target.result.split(";base64,")[1];
          await processKYCFile(fileName, base64String);
        };
        reader.readAsDataURL(file);
      } else {
        toast.warning("Unsupported file type. Please upload an image or PDF", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
    } catch (error) {
      console.error("Error processing file:", error);
    } finally {
      setLoading(false);
    }
  };

  const isPdfPasswordProtected = async (file) => {
    try {
      const buffer = await file.arrayBuffer();
      const text = new TextDecoder().decode(buffer);

      // Encrypted PDFs must contain an /Encrypt entry
      return text.includes("/Encrypt");
    } catch (err) {
      console.error("Error while checking PDF encryption:", err);
      // If we can't read it, don't block as "password protected"
      return false;
    }
  };


  const processKYCFile = async (fileName, base64String) => {
    try {
      setLoading(true);
      let docType = selectDocument?.value;
      const payload = {
        Action: "kycDocOCR",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        type: selectDocument.value, // Adjust type based on context
        userName: sessionStorage.getItem("userName"),
        password: sessionStorage.getItem("password"),
        filename: fileName,
        filecontent: base64String,
        back: "both",
      };

      // console.log(payload);


      const response = await fetch("https://ffamwapi.spectra.co/index.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      let addressValue = null;

      if (Array.isArray(result?.Response?.data)) {
        addressValue = result.Response.data.find(
          (item) => item.document_type === "aadhaar_front_top" && item.address
        )?.address?.value;
      } else {
        console.error("Error: result.Response.data is not an array", result?.Response?.data);
      }

      if (docType == "MCA") {
        await getMcaVerification(result)
        return;
      }

      if (result?.Status === "Success") {
        // console.log("KYC document processed successfully:", result);

        const documentData = result.Response?.data[0];
        const possibleKeys = {
          cin: "cin",
          gstin: "gstin",
          pan: "pan_number",
          aadhar: "aadhar",
          voterId: "voterId",
          DL: "DL",
        };

        let documentValue = null;
        for (const [key, actualKey] of Object.entries(possibleKeys)) {
          if (documentData?.[actualKey]?.value) {
            documentValue = documentData[actualKey].value;
            break;
          }
        }

        // console.log("documentValue:", documentValue);



        if (["aadhaar_front_bottom", "aadhaar_front_top"].includes(documentData?.document_type)) {

          const adharName = documentData.full_name.value;
          // const adharName = "Nitin Chhabbra";
          // console.log("adharName", adharName);

          //  const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          //  const fullName = "Nitin Chhabbra";
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedadharName = adharName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedadharName) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(adharName);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: addressValue || "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        } else if (documentData?.document_type === "pan") {

          const panName = documentData.full_name.value;
          // const panName = "Seoperation Marketing Private Limited";
          // const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          // const fullName = "Seoperation Marketing Private Limited";
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedPanName = panName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedPanName) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(panName);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        } else if (result.Response.data.client_id) {
          // console.log("result.Response.data.client_id");

          const lienceIdNum = result.Response.data.license_number.value;
          const liecenceDOB = result.Response.data.dob.value;
          // const cName = name;
          // setKycDocStatus(result.Status);

          await handleGetCustomerDocDetailDigi(result, documentValue, liecenceDOB, lienceIdNum);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        } else {
          // console.log("else");
          const customerDocDetail = await handleGetCustomerDocDetailDigi(result, documentValue);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress:
                customerDocDetail?.Response?.data?.details?.company_info?.registered_address || "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        }

      } else {
        console.error("Failed to process KYC document:", result);
        toast.warning("Please select a valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error in KYC processing API:", error);
      toast.warning("Error processing the document", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false);
    }
  };



  const handleGetCustomerDocDetailDigi = async (data, docNumber, liecenceDOB, lienceIdNum) => {
    // console.log("setDocnumber", docNumber)
    try {
      let docType = selectDocument.value;
      if (docType === 'CIN') {
        docType = "COI"
      }

      const apiUrl = process.env.REACT_APP_API_URL
      const payload = {
        Action: "getCustomerDocDetailDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        type: docType,
        refid: data.Response?.reference_id,
        id_number: docNumber || lienceIdNum,
        filing_status: "true",
        dob: liecenceDOB ? liecenceDOB : null,
        client_id: ""
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result?.Status === "Success") {

        // console.log("getCustomerDocDetailDigi", result);

        // const coiCompany = result.Response?.data?.company_name;
        const liecenCompany = result?.Response?.data.license_number;
        // console.log("coiCompany", coiCompany);
        // console.log("liecenCompany", liecenCompany);


        if (liecenCompany) {
          const liecenName = result?.Response?.data.name;
          // const liecenName = "MADHUSUDHAN  R"
          // const fullName = "MADHUSUDHAn  R"
          // const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedliecenCompany = liecenName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedliecenCompany) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(liecenName);
        }
        else {
          if (docType == "GST") {
            // console.log("busiName", result?.Response?.data.business_name)
            const busiName = result?.Response?.data.business_name;
            const legalName = result?.Response?.data.legal_name;
            // console.log("busiName", busiName);
            // const fullName = firstName +" "+ lastName;
            const fullName = firstName;
            // const fullName = "DEV IT SERV PRIVATE LIMITED";
            // console.log("fullName", fullName);
            const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
            const normalizedbusiName = busiName.replace(/\s+/g, "").toLowerCase();
            const normalizedLegalName = legalName.replace(/\s+/g, "").toLowerCase();
            if ((normalizedFullName == normalizedbusiName) || (normalizedFullName == normalizedLegalName)) {
              setKycDocStatus(result.Status);
              toast.success("Document details validated successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            } else {
              toast.warning("Customer name on KYC document is not matching, please upload valid document", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            }

            handleGetCompanyGroupDigi(busiName);
          }
          const coiCompany = result.Response?.data?.company_name;
          // const coiCompany = "SHYAM SPECTRA PRIVATE LIMITED";
          // console.log("coiCompany", coiCompany);
          //  const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          //  const fullName = "DEV IT SERV PRIVATE LIMITED"
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedCoiCompany = coiCompany.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedCoiCompany) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 2000,
            });
          }

          const companyName = result.Response?.data?.company_name;
          handleGetCompanyGroupDigi(companyName);

        }


        // toast.success("Document details validated successfully", {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
        // console.log("result?.Response?.data.company_name", result?.Response?.data.company_name);
        // if (result.Response.data.license_number) {
        //   const companyName = result?.Response?.data.name;
        //   handleGetCompanyGroupDigi(companyName);
        // } else {
        //   if (docType == "GST") {
        //     console.log("gstDoctype", result?.Response?.data.business_name)
        //     const companyName = result?.Response?.data.business_name;
        //     handleGetCompanyGroupDigi(companyName);
        //   }
        //   else {
        //     // console.log("companyName",companyName)
        //     const companyName = result.Response?.data?.company_name;
        //     handleGetCompanyGroupDigi(companyName);

        //   }
        // }
      } else {
        console.error("Failed to retrieve customer document details:", result);
        toast.warning("please Select valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error retrieving customer document details:", error);
      // toast.warning("Error retrieving document details", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });

    }
  };

  const getMcaVerification = async (result) => {
    // console.log("setDocnumber", docNumber)
    try {
      // let docType = selectDocument.value;

      if (result?.Status === "Success") {
        // console.log("getCustomerDocDetailDigi", result);

        // const coiCompany = result.Response?.data?.company_name;
        const liecenCompany = result?.Response?.data.license_number;
        // console.log("coiCompany", coiCompany);
        // console.log("liecenCompany", liecenCompany);

        const coiCompany = result.Response?.data?.company_name;
        // const coiCompany = "SHYAM SPECTRA PRIVATE LIMITED";
        // console.log("coiCompany", coiCompany);
        //  const fullName = firstName +" "+ lastName;
        const fullName = firstName;
        //  const fullName = "DEV IT SERV PRIVATE LIMITED"
        // console.log("fullName", fullName);
        const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
        const normalizedCoiCompany = coiCompany.replace(/\s+/g, "").toLowerCase();
        if (normalizedFullName == normalizedCoiCompany) {
          setKycDocStatus(result.Status);
          toast.success("Document details validated successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else {
          toast.warning("Customer name on KYC document is not matching, please upload valid document", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
          });
        }

        const companyName = result.Response?.data?.company_name;
        handleGetCompanyGroupDigi(companyName);

      } else {
        console.error("Failed to retrieve customer document details:", result);
        toast.warning("please Select valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error retrieving customer document details:", error);
      // toast.warning("Error retrieving document details", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });

    }
  };



  const handleGetCompanyGroupDigi = async (customerName) => {
    try {
      // Prepare API payload
      const apiurl = process.env.REACT_APP_API_URL
      const payload = {
        Action: "getCompanyGroupDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        customerName: customerName,
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName')
      };

      // Send API request
      const response = await fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result?.Status === "Success") {
        // toast.success(result?.Response.Message, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      } else {
        toast.warning(result?.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error retrieving company group data:", error);
      // toast.success("Error retrieving data", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });
    }
  };


  const handleVerifyOtp = () => {
    const otpValue = String(otp).trim();
    const customerOtpValue = userdata.otp.trim();
    // console.log("userData.otp :", userdata.otp);
    // console.log("otp :", otp);
    if (otpValue === customerOtpValue) {
      setOtpVerified(true)
      toast.success("OTP verified Successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // setOtpContactStatus("111260000");
    } else {
      setOtpVerified(false)
      toast.error("Incorrect OTP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // setOtpContactStatus("111260001");
    }
  };




  const SendOtpresotp = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL_2;

      const requestData = {
        Action: "resendOTP",
        Authkey: "AdgT6SnjAkeLqlkE4",
        CAFNumber: CafId,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();



      if (result.Response.OTPStatus === "OTP Sent") {
        toast.success("OTP Sent Succesfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setOtpValue2(result.Response.OTPCode);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };



  // Handle city change
  const handleCityChange = async (selectedOption) => {
    try {
      // console.log("Selected City:", selectedOption);
      setSelectCity(selectedOption);

      // const apiUrl = process.env.REACT_APP_API_URL_1;
      // const requestData = {
      //     Action: 'getArea',
      //     Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
      //     cafNo: 'CAF_113258',
      //     cityCode: selectedOption.value,
      //     cityName: selectedOption.label,
      //     restrictedarea: false,
      //     stateCode: "",
      //     // password: 'Target@2021#@',
      //     // userName: 'manager1',
      //     password: sessionStorage.getItem('password'),
      //     userName: sessionStorage.getItem('userName')

      // };

      // const response = await fetch(apiUrl, {
      //     method: 'POST',
      //     headers: {
      //         'Content-Type': 'application/json',
      //     },
      //     body: JSON.stringify(requestData),
      // });

      // if (!response.ok) {
      //     throw new Error(`HTTP error! Status: ${response.status}`);
      // }

      // const result = await response.json();
      // console.log('API Response area:', result.Response.Data);
      // setbillingAreaDrop(result.Response.Data)

      // const selectedOptionValue = selectedOption.value
      // const selectedOptionLabel = selectedOption.label;
      // console.log("selectedOptionValue", selectedOptionValue);
      // console.log("selectedOptionLabel", selectedOptionLabel);
      // setCityCode(selectedOptionValue)
      // setCityName(selectedOptionLabel)
      // setupdateCityCode(selectedOptionValue)
      // setbillingBuildingDrop('')
      // setbilledarea('')
      // setbilledbuilding('')

    } catch (error) {
      console.error(error);
    }
  };

  // Handle area change
  const HandleAreaChange = async (selectedOption) => {
    try {
      if (!selectCity) {
        // Dependencies not selected, show error or handle validation
        console.error("Please select state and city first");
        return;
      }
      // console.log("Selected Area:", selectedOption);
      const areaCode = selectedOption.value;
      setSelectArea(selectedOption);
      // setupdateAreaCode(selectedOption.value)
      const apiUrl = process.env.REACT_APP_API_URL_1;
      const requestData = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: areaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log("API Response society on handle:", result.Response);
      setOptionSociety(result.Response);

      if (result.Message === "Society is not mapped.") {
        toast.warning(
          result.statusText || "Society is not Mapped ,Choose Another Area",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
        setSelectSociety("");
      } else {
        setSelectSociety("");
      }
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getWCR",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "cafNo": CafId ? CafId : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "token": "e7e916c2e449f6306b27dea2fb2dde46",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        // console.log("data", data);
        setWcrDetails(data.Response.Data);
      } catch (err) {
        console.error(err);
      }
    }

    fetchData()
  }, []);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getNP",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "cafNo": CafId ? CafId : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "token": "e7e916c2e449f6306b27dea2fb2dde46",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        // console.log("data", data);
        setNpDetails(data.Response.Data);
      } catch (err) {
        console.error(err);
      }
    }

    fetchData()
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getIR",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "cafNo": CafId ? CafId : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "token": "e7e916c2e449f6306b27dea2fb2dde46",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        // console.log("data", data);
        setIrDetails(data.Response.Data);
      } catch (err) {
        console.error(err);
      }
    }

    fetchData()
  }, []);




  //Main Create Button

  // console.log("sellerFileNameWithExtension",getSellerPicture?.sellerFileNameWithExtension);
  // console.log("sellerFileNameWithExtension",getNewCafUpdateRequestBody?.sellerImage?.sellerFileNameWithExtension);


  const handleSave = async () => {

    const regexPAN = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const regexTAN = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
    const regexGST = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;

    if (userdata.gstNo) {
      if (!regexGST.test(userdata.gstNo)) {
        toast.error(
          "Please enter GST in CAPITAL Letters and correct format (e.g., 12ABCDE1234A1A1 or 12ABCDE1234A1AA)",
          { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
        );
        return;
      }

      // Mapping from State Name to its corresponding GST Code (as per GST value table).
      const stateGSTMapping = {
        "Jammu & Kashmir": "01",
        "Himachal Pradesh": "02",
        "Punjab": "03",
        "Chandigarh": "04",
        "Uttarakhand": "05",
        "Haryana": "06",
        "Delhi": "07",
        "Rajasthan": "08",
        "Uttar Pradesh": "09",
        "Bihar": "10",
        "Sikkim": "11",
        "Arunachal Pradesh": "12",
        "Nagaland": "13",
        "Manipur": "14",
        "Mizoram": "15",
        "Tripura": "16",
        "Meghalaya": "17",
        "Assam": "18",
        "West Bengal": "19",
        "Jharkhand": "20",
        "Odisha": "21",
        "Chhattisgarh": "22",
        "Madhya Pradesh": "23",
        "Gujarat": "24",
        "Daman & Diu": "25",
        "Dadra & Nagar Haveli": "26",
        "Maharashtra": "27",
        "Andhra Pradesh": "28",  // Andhra Pradesh may also use '37' in certain cases.
        "Karnataka": "29",
        "Goa": "30",
        "Lakshadweep": "31",
        "Kerala": "32",
        "Tamil Nadu": "33",
        "Puducherry": "34",
        "Andaman & Nicobar Islands": "35",
        "Telangana": "36",
        "Ladakh": "38",
        "Others Territory": "97",
        "Center Jurisdiction": "99"
      };

      // If a state is selected via selectInstState, verify that the GST number starts with the state's GST code.
      // Assume selectInstState is an object with at least a 'name' property.
      if (userdata.StateId && userdata.State && stateGSTMapping[userdata.State]) {
        const expectedGSTPrefix = stateGSTMapping[userdata.State];
        const gstPrefix = userdata.gstNo.slice(0, 2); // Extract first two digits from the GST.
        if (gstPrefix !== expectedGSTPrefix) {
          toast.error(
            `GST number does not match the selected state's GST code. Expected prefix: ${expectedGSTPrefix}`,
            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
          );
          return;
        }
      }
    }

    // PAN Validation: if field is not empty, then validate format.
    if (userdata.panNo && !regexPAN.test(userdata.panNo)) {
      toast.error(
        "Please enter PAN in CAPITAL Letters and correct format (ABCDE1234A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    // TAN Validation: if field is not empty, then validate format.
    if (userdata.tanNo && !regexTAN.test(userdata.tanNo)) {
      toast.error(
        "Please enter TAN in CAPITAL Letters and correct format (ABCD12345A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    if (!userdata.ContactPerson) {
      toast.error("Please Enter Customer Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!gender) {
      toast.warning("Please Select Gender", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata?.ProfessionofSubscriber) {
      toast.warning("Please Enter Profession of Subscriber", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata?.DOBorDateofRegistration) {
      toast.warning("Please Enter DOB/Date of registration", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.BuildingNo) {
      toast.error("Please Enter Installation Building/Plot No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.Floor) {
      toast.error("Please Enter Installation Floor No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.InstPin) {
      toast.error("Please Enter Installation Pincode.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.contactName) {
      toast.error("Please Enter Contact Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billmail) {
      toast.error("Please Enter Billing Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billPhone) {
      toast.error("Please Enter Billing Phone No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billBuildingNo) {
      toast.error("Please Enter Billing Building/Plot No", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billFloor) {
      toast.error("Please Enter Billing Floor No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billPin) {
      toast.error("Please Enter Billing Pincode.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.authorName) {
      toast.error("Please Enter Author Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.authorFather) {
      toast.error("Please Enter Auth Father's/Husband's  Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.authResidentialAddress) {
      toast.error("Please Enter Auth Residential Address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.autherEmail) {
      toast.error("Please Enter Authorized Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.autherMobile) {
      toast.error("Please Enter Authorized Mobile No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.autherPinCode) {
      toast.error("Please Enter Authorized Pincode.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.techSupportEmail) {
      toast.error("Please Enter Technical Support Email.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billFloor) {
      toast.error("Please Enter Bill Floor", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.AreaId) {
      toast.error("Please Enter Bill Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!businessDays?.value) {
      toast.error("Please Select Busines Days", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!cusCategory?.value) {
      toast.error("Please Select Customer Category", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!customerWorkingHours?.value) {
      toast.error("Please Select Customer Working Hours", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!serviceProvider?.value) {
      toast.error("Please Select Existing Provider", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!otherFirewall?.value) {
      toast.error("Please Select FireWall", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (selectedFirmType != "6" && !userdata.PoLock) {
      toast.error("Please Enter PO Lock Date", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.PoNext) {
      toast.error("Please Enter PO Next Date", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!selectedCommMode?.value) {
      toast.error("Please Select Prefer Communication Mode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!selectedSubSegment?.value) {
      toast.error("Please Select Sub Business Segment", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }

    if (!selectVoip?.value) {
      toast.error("Please Select VOIP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (getSellerPicture?.sellerFileNameWithExtension == undefined || getNewCafUpdateRequestBody?.sellerImage?.sellerFileNameWithExtension == undefined) {
      toast.error("Seller Live Picture is Required.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }

    if (!getSellerPicture?.sellerFileNameWithExtension && !getNewCafUpdateRequestBody?.sellerImage?.sellerFileNameWithExtension) {
      toast.error("Seller Live Picture is Required.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }

    if (productsegment == "Managed Wi-Fi Business-S" || productsegment == "Managed Wi-Fi Business") {
      if (!userdata.CpeContactPersonName) {
        toast.error("Please CPE Contact Person Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.CpeContactPersonPhone) {
        toast.error("Please CPE Contact Person Phone", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.CpeDispatchAddress) {
        toast.error("Please CPE Dispatch Address", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.ssIdNomenclatureOne) {
        toast.error("Please SSID 1 Nomenclature", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userManagement.value) {
        toast.error("Please Select User Management Through Portal", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!reportReq.value) {
        toast.error("Please Select Report Required on UPM", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!dashboardReq.value) {
        toast.error("Please Select Dashboard Required", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
    }



    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const postData = {
        "Action": "createCafDzationB",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "authorSigDetails": {
          "authEmailID": userdata.autherEmail ? userdata.autherEmail : "",
          "authFatherORhusbandName": userdata.authorFather ? userdata.authorFather : "",
          "authLandmark": "0",
          "authMobileNumber": userdata.autherMobile ? userdata.autherMobile : "",
          "authName": userdata.authorName ? userdata.authorName : "",
          "authResidentialAddress": userdata.authResidentialAddress ? userdata.authResidentialAddress : "",
          "authcity": selectAuthCity ? selectAuthCity.value : "",
          "authcountry": selectAuthCountry ? selectAuthCountry.value : "",
          "authpostalCode": userdata.autherPinCode ? userdata.autherPinCode : "",
          "authstate": selectAuthState ? selectAuthState.value : "",
        },
        "billingAddress": {
          "billBuildingPlotFlatNumber": userdata.billBuildingNo ? userdata.billBuildingNo : "",
          "billBuildingType": "",
          "billContactName": userdata.contactName ? userdata.contactName : "",
          "billEmailId": userdata.billmail ? userdata.billmail : "",
          "billFloor": userdata.billFloor ? userdata.billFloor : "",
          "billLandmark": "0",
          "billLocality": "0",
          "billStreet": "0",
          "billarea": selectArea?.value ? selectArea?.value : selectBillArea?.value,
          "billbuilding": selectBuilding?.value ? selectBuilding?.value : selectBillBuilding?.value,
          "billcity": selectCity?.value ? selectCity?.value : selectBillCity?.value,
          "billcountry": "10001",
          "billmobileNo": userdata.billPhone ? userdata.billPhone : "",
          "billpostalCode": userdata.billPin ? userdata.billPin : "",
          "billstate": selectState.value ? selectState.value : selectBillState.value
        },
        "cafDetail": {
          "TechnicalSupportEmailID": userdata.techSupportEmail || "",
          "businesDays": businessDays ? businessDays.value : "",
          "businessSegment": "Business",
          // "UpTimesla": userdata.UpTimesla ? Number(userdata.UpTimesla) : "",
          "UpTimesla": userdata.UpTimesla != null && userdata.UpTimesla !== "" ? Number(userdata.UpTimesla) : 0,
          "compSelfPO": "2",
          "customerCategory": cusCategory ? cusCategory.value : "",
          "customerName": userdata.ContactPerson ? userdata.ContactPerson : "",
          "customerWorkingHours": customerWorkingHours.value ? customerWorkingHours.value : "",
          "existSircProvider": serviceProvider ? serviceProvider.value : "",
          "fireWall": otherFirewall ? otherFirewall.value : "",
          "gstNo": userdata?.gstNo || "",
          "isGST": userdata?.gstNo ? "569480000" : "569480001",
          "networkMonitorAlert": montiorDays ? montiorDays.value : "",
          "panNo": userdata?.panNo || "",
          "phoneNo": userdata.Mobilephone ? userdata.Mobilephone : "",
          "poLock": yyyymmddFormat(userdata.PoLock) ? yyyymmddFormat(userdata.PoLock) : "",
          "poNext": yyyymmddFormat(userdata.PoNext) ? yyyymmddFormat(userdata.PoNext) : "",
          "preferCommMode": selectedCommMode ? selectedCommMode.value : "",
          "subBusinessSegment": selectedSubSegment ? selectedSubSegment.value : "",
          "tanNo": userdata?.tanNo || "",
          "vOIP": selectVoip ? selectVoip.value : "",
          "latitude": String(Caflatitude) || "",
          "longitude": String(Caflongitude) || "",
          "SSID1Nomenclature": userdata.ssIdNomenclatureOne ? userdata.ssIdNomenclatureOne : "",
          "SSID2Nomenclature": userdata.ssIdNomenclatureTwo ? userdata.ssIdNomenclatureTwo : "",
          "RequiredBandwidthinMbps": userdata.reqBandwidth ? userdata.reqBandwidth : "",
          "SpecialRequest": userdata.specialReq ? userdata.specialReq : "",
          "UserManagementthroughPortal": userManagement?.value ? userManagement?.value : "",
          "ReportrequiredonUMP": reportReq?.value ? reportReq?.value : "",
          "DashboardRequired": dashboardReq?.value ? dashboardReq?.value : "",

          ProfessionofSubscriber: userdata?.ProfessionofSubscriber || "",
          Gender: gender || "",
          DOBorDateofRegistration: userdata?.DOBorDateofRegistration || ""
        },
        "companyId": compID ? compID : selectedCompany?.value || "",
        "groupId": selectGroup ? selectGroup.value : "",
        "installationAddress": {
          "billType": billType ? billType.value : "",
          "cpeContactPersonName": userdata.CpeContactPersonName ? userdata.CpeContactPersonName : "",
          "cpeContactPersonPhone": userdata.CpeContactPersonPhone ? userdata.CpeContactPersonPhone : "",
          "cpeDisSameInsta": useSameDataForCPE ? useSameDataForCPE : "",
          "cpeDispatchAddress": userdata.CpeDispatchAddress ? userdata.CpeDispatchAddress : "",
          "remarkCPE": userdata.RemarkCPE ? userdata.RemarkCPE : "",
          "instalBlock": "0",
          "instalBuildingPlotFlatNumber": userdata.BuildingNo ? userdata.BuildingNo : "",
          "instalBuildingType": "",
          "instalEmailId": userdata.Emailaddress ? userdata.Emailaddress : "",
          "instalFloor": userdata.Floor ? userdata.Floor : "",
          "instalLandmark": "0",
          "instalLocality": "0",
          "instalMobileNo": userdata.Mobilephone ? userdata.Mobilephone : "",
          "instalStreet": "0",
          "instalarea": userdata.AreaId ? userdata.AreaId : "",
          "instalbuilding": userdata.BuildingId ? userdata.BuildingId : "",
          "instalcity": userdata.CityId ? userdata.CityId : "",
          "instalcountry": "10001",
          "instalpostalCode": userdata.PostalCode ? userdata.PostalCode : "",
          "instalstate": userdata.StateId ? userdata.StateId : "",
          "product": userdata.Product ? userdata.Product : "",
          "productSegment": userdata.ProductSegment ? userdata.ProductSegment : "",

        },
        "oppurtunityID": OppId ? OppId : "",
        "password": sessionStorage.getItem('password'),
        "paymentDetail": {
          "OTC": userdata.UpfrontReqOTCAmount ? userdata.UpfrontReqOTCAmount : "",
          "amount": userdata.totalAmount ? userdata.totalAmount : "",
          "approvalCode": "0",
          "bankName": "0",
          "branchName": "0",
          "chequeDDNo": "0",
          "creditCardDigits": "0",
          "debitCardDigits": "0",
          "payInSlip": "",
          "paymentDate": "",
          "paymentStatus": "",
          "securityDeposit": "",
          "securityDepositType": "",
          "transactionId": "0",
          "rc": userdata.UpfrontReqRCAmount ? userdata.UpfrontReqRCAmount : ""
        },
        "documentRequired": {
          "aadharCard": false,
          "aadharCardPhotoId": false,
          "AadharNo": "",
          "bankPassbook": false,
          "centralStateGovtId": false,
          "centralStateGovtIdPhotoId": false,
          "CompanyId": compID ? compID : selectedCompany?.value || "",
          "creditCardStatement": false,
          "documentData": null,
          "drivingLicense": false,
          "drivingLicenseNo": "",
          "drivingLicensePhotoId": false,
          "electricityBill": false,
          "electricityIssueDate": "",
          // "FirmType": selectedFirmType?.value || "",
          "gasConnection": false,
          "gasConnectionIssueDate": "",
          "GroupId": selectGroup ? selectGroup.value : "",
          "panCardPhotoId": false,
          "passport": false,
          "PassportNo": "",
          "passportPhotoId": false,
          "rationCardPhotoId": false,
          "RelationshipId": selectRelationship ? selectRelationship.value : "",
          "rentAgreement": false,
          "telephoneBill": false,
          "telephoneIssueDate": "",
          "votercard": false,
          "votercardPhotoId": false,
          "VoterNo": "",
          "waterBill": false,
          "waterBillIssueDate": ""
        },
        "relationshipId": selectRelationship ? selectRelationship.value : "",
        customerImage: getNewCafUpdateRequestBody.customerImage,
        //  customerImage: {
        //     fileNameWithExtension: getCustomerPicture?.fileNameWithExtension || getNewCafUpdateRequestBody?.customerImage?.fileNameWithExtension,
        //     fileContent: getCustomerPicture?.fileContent ||  getNewCafUpdateRequestBody?.customerImage?.fileContent
        //   },

        sellerImage: getNewCafUpdateRequestBody.sellerImage,
        customerKYCdocument: getNewCafUpdateRequestBody.customerKYCdocument,
        "TechnicalSupportEmailID": userdata.techSupportEmail || "",
        "userName": sessionStorage.getItem('userName')
      }

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      };
      // console.log("API Response:", postData);

      const response = await fetch(apiUrl, requestOptions);

      const data = await response.json();

      // console.log("API Response:", data);
      if (data.Status == "Success") {
        toast.success("CAF Created Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

        navigate("/businessCaf");
        return;
      } else {
        toast.error(data?.Response?.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

        // navigate("/businessCaf");
        return;
      }
    } catch (error) {
      console.error("Error sending data:", error.message);
    } finally {
      setLoading(false);
    }

  };




  // {MAIN UPDATE BUTTON}
  const handleUpdate = async () => {

    const regexPAN = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const regexTAN = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
    const regexGST = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;

    if (userdata.gstNo) {
      if (!regexGST.test(userdata.gstNo)) {
        toast.error(
          "Please enter GST in CAPITAL Letters and correct format (e.g., 12ABCDE1234A1A1 or 12ABCDE1234A1AA)",
          { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
        );
        return;
      }

      // Mapping from State Name to its corresponding GST Code (as per GST value table).
      const stateGSTMapping = {
        "Jammu & Kashmir": "01",
        "Himachal Pradesh": "02",
        "Punjab": "03",
        "Chandigarh": "04",
        "Uttarakhand": "05",
        "Haryana": "06",
        "Delhi": "07",
        "Rajasthan": "08",
        "Uttar Pradesh": "09",
        "Bihar": "10",
        "Sikkim": "11",
        "Arunachal Pradesh": "12",
        "Nagaland": "13",
        "Manipur": "14",
        "Mizoram": "15",
        "Tripura": "16",
        "Meghalaya": "17",
        "Assam": "18",
        "West Bengal": "19",
        "Jharkhand": "20",
        "Odisha": "21",
        "Chhattisgarh": "22",
        "Madhya Pradesh": "23",
        "Gujarat": "24",
        "Daman & Diu": "25",
        "Dadra & Nagar Haveli": "26",
        "Maharashtra": "27",
        "Andhra Pradesh": "28",  // Andhra Pradesh may also use '37' in certain cases.
        "Karnataka": "29",
        "Goa": "30",
        "Lakshadweep": "31",
        "Kerala": "32",
        "Tamil Nadu": "33",
        "Puducherry": "34",
        "Andaman & Nicobar Islands": "35",
        "Telangana": "36",
        "Ladakh": "38",
        "Others Territory": "97",
        "Center Jurisdiction": "99"
      };

      // If a state is selected via selectInstState, verify that the GST number starts with the state's GST code.
      // Assume selectInstState is an object with at least a 'name' property.
      if (selectInstState && selectInstState.label && stateGSTMapping[selectInstState.label]) {
        const expectedGSTPrefix = stateGSTMapping[selectInstState.label];
        const gstPrefix = userdata.gstNo.slice(0, 2); // Extract first two digits from the GST.
        if (gstPrefix !== expectedGSTPrefix) {
          toast.error(
            `GST number does not match the selected state's GST code. Expected prefix: ${expectedGSTPrefix}`,
            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
          );
          return;
        }
      }
    }

    // PAN Validation: if field is not empty, then validate format.
    if (userdata.panNo && !regexPAN.test(userdata.panNo)) {
      toast.error(
        "Please enter PAN in CAPITAL Letters and correct format (ABCDE1234A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    // TAN Validation: if field is not empty, then validate format.
    if (userdata.tanNo && !regexTAN.test(userdata.tanNo)) {
      toast.error(
        "Please enter TAN in CAPITAL Letters and correct format (ABCD12345A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    if (!userdata.ContactPerson) {
      toast.error("Please Enter Customer Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!gender) {
      toast.warning("Please Select Gender", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata?.ProfessionofSubscriber) {
      toast.warning("Please Enter Profession of Subscriber", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata?.DOBorDateofRegistration) {
      toast.warning("Please Enter DOB/Date of registration", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.BuildingNo) {
      toast.error("Please Enter Installation Building/Plot No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.Floor) {
      toast.error("Please Enter Installation Floor No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.InstPin) {
      toast.error("Please Enter Installation Pincode.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.contactName) {
      toast.error("Please Enter Contact Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billmail) {
      toast.error("Please Enter Billing Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billPhone) {
      toast.error("Please Enter Billing Phone No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billBuildingNo) {
      toast.error("Please Enter Billing Building/Plot No", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billFloor) {
      toast.error("Please Enter Billing Floor No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billPin) {
      toast.error("Please Enter Billing Pincode.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.authorName) {
      toast.error("Please Enter Author Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.authorFather) {
      toast.error("Please Enter Auth Father's/Husband's  Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.authResidentialAddress) {
      toast.error("Please Enter Auth Residential Address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.autherEmail) {
      toast.error("Please Enter Authorized Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.autherMobile) {
      toast.error("Please Enter Authorized Mobile No.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.autherPinCode) {
      toast.error("Please Enter Authorized Pincode.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.techSupportEmail) {
      toast.error("Please Enter Technical Support Email.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.billFloor) {
      toast.error("Please Enter Bill Floor", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.AreaId) {
      toast.error("Please Enter Bill Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!businessDays?.value) {
      toast.error("Please Select Busines Days", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!cusCategory?.value) {
      toast.error("Please Select Customer Category", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!getSellerPicture?.sellerFileNameWithExtension || !getNewCafUpdateRequestBody?.sellerImage?.sellerFileNameWithExtension) {
      toast.error("Seller Live Picture is Required.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!customerWorkingHours?.value) {
      toast.error("Please Select Customer Working Hours", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!serviceProvider?.value) {
      toast.error("Please Select Existing Provider", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!otherFirewall?.value) {
      toast.error("Please Select FireWall", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (selectedFirmType != "6" && !userdata.PoLock) {
      toast.error("Please Enter PO Lock Date", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!userdata.PoNext) {
      toast.error("Please Enter PO Next Date", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!selectedCommMode?.value) {
      toast.error("Please Select Prefer Communication Mode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!selectedSubSegment?.value) {
      toast.error("Please Select Sub Business Segment", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    if (!selectVoip?.value) {
      toast.error("Please Select VOIP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }

    if (productsegment == "Managed Wi-Fi Business-S" || productsegment == "Managed Wi-Fi Business") {
      if (!userdata.CpeContactPersonName) {
        toast.error("Please CPE Contact Person Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.CpeContactPersonPhone) {
        toast.error("Please CPE Contact Person Phone", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.CpeDispatchAddress) {
        toast.error("Please CPE Dispatch Address", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.ssIdNomenclatureOne) {
        toast.error("Please SSID 1 Nomenclature", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userManagement.value) {
        toast.error("Please Select User Management Through Portal", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!reportReq.value) {
        toast.error("Please Select Report Required on UPM", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!dashboardReq.value) {
        toast.error("Please Select Dashboard Required", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
    }

    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const postData = {
        "Action": "updateCafDzationB",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "authorSigDetails": {
          "authEmailID": userdata.autherEmail ? userdata.autherEmail : getCafDetails?.authSigDetails.Auth_EmailId,
          "authFatherORhusbandName": userdata.authorFather ? userdata.authorFather : getCafDetails?.authSigDetails.Auth_Father,
          "authLandmark": "0",
          "authMobileNumber": userdata.autherMobile ? userdata.autherMobile : getCafDetails?.authSigDetails.Auth_MobileNo,
          "authName": userdata.authorName ? userdata.authorName : getCafDetails?.authSigDetails.Auth_Name,
          "authResidentialAddress": userdata.authResidentialAddress ? userdata.authResidentialAddress : getCafDetails?.authSigDetails.Auth_Resadd,
          "authcity": selectAuthCity ? selectAuthCity.value : selectBillCity?.value,
          "authcountry": selectAuthCountry ? selectAuthCountry.value : "10004",
          "authpostalCode": userdata.autherPinCode ? userdata.autherPinCode : getCafDetails?.authSigDetails.Auth_PinCode,
          "authstate": selectAuthState ? selectAuthState.value : getCafDetails?.authSigDetails.Auth_State,
        },
        "billingAddress": {
          "billBuildingPlotFlatNumber": userdata.billBuildingNo ? userdata.billBuildingNo : getCafDetails?.billingAddress?.Bill_BuildingNo,
          "billBuildingType": "1",
          "billContactName": userdata.contactName ? userdata.contactName : getCafDetails?.billingAddress?.Bill_ConatctName,
          "billEmailId": userdata.billmail ? userdata.billmail : getCafDetails?.billingAddress?.Bill_EmailId,
          "billFloor": userdata.billFloor ? userdata.billFloor : getCafDetails?.billingAddress?.Bill_Floor,
          "billLandmark": "",
          "billLocality": "",
          "billStreet": "",
          "billarea": selectBillArea?.value ? selectBillArea?.value : "",
          "billbuilding": selectBillBuilding?.value ? selectBillBuilding?.value : "",
          "billcity": selectBillCity?.value ? selectBillCity?.value : "",
          "billcountry": "10001",
          "billmobileNo": userdata.billPhone ? userdata.billPhone : getCafDetails?.billingAddress?.Bill_MobileNo,
          "billpostalCode": userdata.billPin ? userdata.billPin : getCafDetails?.billingAddress?.Bill_PinCode,
          "billstate": selectBillState?.value ? selectBillState?.value : ""
        },
        "cafDetail": {
          // "UpTimesla": userdata.UpTimesla ? userdata.UpTimesla : "",
          "UpTimesla": userdata.UpTimesla != null && userdata.UpTimesla !== "" ? Number(userdata.UpTimesla) : 0,
          "TechnicalSupportEmailID": userdata.techSupportEmail || "",
          "FirmType": selectedFirmType?.value || "",
          "cafNo": CafId,
          "businesDays": businessDays ? businessDays.value : "",
          "businessSegment": "Business",
          "compSelfPO": "2",
          "customerCategory": cusCategory ? cusCategory.value : "",
          "customerName": userdata.ContactPerson ? userdata.ContactPerson : "",
          "customerWorkingHours": customerWorkingHours.value ? customerWorkingHours.value : "",
          "existSircProvider": serviceProvider ? serviceProvider.value : "",
          "fireWall": otherFirewall ? otherFirewall.value : "",
          "gstNo": userdata?.gstNo || "",
          "isGST": userdata?.gstNo ? "569480000" : "569480001",
          "networkMonitorAlert": montiorDays ? montiorDays.value : "",
          "panNo": userdata?.panNo || "",
          "phoneNo": userdata.Mobilephone ? userdata.Mobilephone : "",
          "poLock": yyyymmddFormat(userdata.PoLock) ? yyyymmddFormat(userdata.PoLock) : "",
          "poNext": yyyymmddFormat(userdata.PoNext) ? yyyymmddFormat(userdata.PoNext) : "",
          "preferCommMode": selectedCommMode ? selectedCommMode.value : "",
          "subBusinessSegment": selectedSubSegment ? selectedSubSegment.value : "",
          "tanNo": userdata?.tanNo || "",
          "vOIP": selectVoip ? selectVoip.value : "",
          "latitude": String(Caflatitude) || "",
          "longitude": String(Caflongitude) || "",
          "SSID1Nomenclature": userdata.ssIdNomenclatureOne ? userdata.ssIdNomenclatureOne : "",
          "SSID2Nomenclature": userdata.ssIdNomenclatureTwo ? userdata.ssIdNomenclatureTwo : "",
          "RequiredBandwidthinMbps": userdata.reqBandwidth ? userdata.reqBandwidth : "",
          "SpecialRequest": userdata.specialReq ? userdata.specialReq : "",
          "UserManagementthroughPortal": userManagement?.value ? userManagement?.value : "",
          "ReportrequiredonUMP": reportReq?.value ? reportReq?.value : "",
          "DashboardRequired": dashboardReq?.value ? dashboardReq?.value : "",

          "ProfessionofSubscriber": userdata?.ProfessionofSubscriber || "",
          "Gender": gender || "",
          "DOBorDateofRegistration": userdata?.DOBorDateofRegistration || ""
        },
        "companyId": compID ? compID : selectedCompany?.value || "",
        "groupId": selectGroup ? selectGroup.value : "",
        "installationAddress": {
          "billType": billType ? billType.value : "",
          "cpeContactPersonName": userdata.CpeContactPersonName ? userdata.CpeContactPersonName : "",
          "cpeContactPersonPhone": userdata.CpeContactPersonPhone ? userdata.CpeContactPersonPhone : "",
          "cpeDisSameInsta": useSameDataForCPE ? useSameDataForCPE : "",
          "cpeDispatchAddress": userdata.CpeDispatchAddress ? userdata.CpeDispatchAddress : "",
          "remarkCPE": userdata.RemarkCPE ? userdata.RemarkCPE : "",
          "instalBlock": "",
          "instalBuildingPlotFlatNumber": userdata.BuildingNo ? userdata.BuildingNo : "",
          "instalBuildingType": "",
          "instalEmailId": userdata.Emailaddress ? userdata.Emailaddress : getCafDetails?.installationAddresses?.Inst_EmailId,
          "instalFloor": userdata.Floor ? userdata.Floor : "",
          "instalLandmark": "",
          "instalLocality": "",
          "instalMobileNo": userdata.Mobilephone ? userdata.Mobilephone : getCafDetails?.installationAddresses?.Inst_MobileNo,
          "instalStreet": "",
          "instalarea": userdata.AreaId ? userdata.AreaId : "",
          "instalbuilding": userdata.BuildingId ? userdata.BuildingId : "",
          "instalcity": userdata.CityId ? userdata.CityId : "",
          "instalcountry": "10001",
          "instalpostalCode": userdata.InstPin ? userdata.InstPin : "",
          "instalstate": userdata.StateId ? userdata.StateId : "",
          "product": userdata.Product ? userdata.Product : "",
          "productSegment": userdata.ProductSegment ? userdata.ProductSegment : "",

        },
        "oppurtunityID": OppId ? OppId : "",
        "password": sessionStorage.getItem('password'),
        "paymentDetail": {
          "OTC": userdata.UpfrontReqOTCAmount ? userdata.UpfrontReqOTCAmount : getCafDetails?.payments?.UpfrontRequestedOTCAmountIncTax,
          "amount": userdata.TotalAmount ? userdata.TotalAmount : "",
          "modeOfPayment": selectPaymentMode?.value ? selectPaymentMode?.value : "", //selectedPaySlipOption || getCafDetails?.payments.PayInSlip || "Online",
          "approvalCode": "0",
          // "bankName": selectBank?.value || getCafDetails?.payments?.BankName || "",
          "bankName": selectBank?.value || (bankOpts.find((option) => option?.label == getCafDetails?.payments?.BankName))?.value,
          "branchName": branchName || getCafDetails?.payments?.Branch || "",
          "chequeDDNo": chequeDDNo || getCafDetails?.payments?.ChequeDDNo || "",
          "chequeDDDate": chequeDate || yyyymmddFormat(getCafDetails?.payments?.ChequeDDDate) || "",
          "creditCardDigits": "0",
          "debitCardDigits": "0",
          "payInSlip": selectedPaySlipOption ? selectedPaySlipOption : "",
          "paymentDate": userdata.paymentDate ? userdata.paymentDate : "",
          "paymentStatus": "1",
          "securityDeposit": "0",
          "securityDepositType": "0",
          "transactionId": transactionrefid ? transactionrefid : "",
          "rc": userdata.UpfrontReqRCAmount ? userdata.UpfrontReqRCAmount : getCafDetails.payments?.UpfrontRequestedRCAmountIncTax,
        },
        "documentRequired": {
          "aadharCard": false,
          "aadharCardPhotoId": false,
          "AadharNo": "",
          "bankPassbook": false,
          "centralStateGovtId": false,
          "centralStateGovtIdPhotoId": false,
          "CompanyId": compID ? compID : selectedCompany?.value || "",
          "creditCardStatement": false,
          "documentData": null,
          "drivingLicense": false,
          "drivingLicenseNo": "",
          "drivingLicensePhotoId": false,
          "electricityBill": false,
          "electricityIssueDate": "",
          "FirmType": selectedFirmType?.value || "",
          "gasConnection": false,
          "gasConnectionIssueDate": "",
          "GroupId": selectGroup ? selectGroup.value : "",
          "panCardPhotoId": false,
          "passport": false,
          "PassportNo": "",
          "passportPhotoId": false,
          "rationCardPhotoId": false,
          "RelationshipId": selectRelationship ? selectRelationship.value : "",
          "rentAgreement": false,
          "telephoneBill": false,
          "telephoneIssueDate": "",
          "votercard": false,
          "votercardPhotoId": false,
          "VoterNo": "",
          "waterBill": false,
          "waterBillIssueDate": ""
        },
        "relationshipId": selectRelationship ? selectRelationship.value : "",
        customerImage: getNewCafUpdateRequestBody.customerImage,
        sellerImage: getNewCafUpdateRequestBody.sellerImage,
        customerKYCdocument: getNewCafUpdateRequestBody.customerKYCdocument,

        "userName": sessionStorage.getItem('userName')
      }

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      };

      const response = await fetch(apiUrl, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      // console.log("API Response of Update:", data);
      if (data.Status === "Success") {
        // console.log("sucnc");
        toast.success("CAF Updated Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        // navigate('/businessCaf')
        setTimeout(() => {
          // window.location.reload()
        }, 2000);


      } else {
        toast.error(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
      // Handle the API response here
    } catch (error) {
      console.error("Error sending data:", error);
    } finally {
      setLoading(false);
    }

  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getDedupeAlert",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "CafSafNo": CafId ? CafId : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "token": "e7e916c2e449f6306b27dea2fb2dde46",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        setDedupeDOAFlag(data.Response.DedupeDOAFlag)
      } catch (err) {
        console.error(err);
      }
    }

    fetchData()
  }, []);



  // useEffect(() => {
  //   const fetchPaymentAlert = async () => {
  //     // console.log("getCafNo", CafId);
  //     try {
  //       const apiUrl = process.env.REACT_APP_API_URL_3;
  //       const requestData = {
  //         "Action": "getPaymentAlertDigi",
  //         "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         "userName": sessionStorage.getItem('userName'),
  //         "password": sessionStorage.getItem('password'),
  //         "CafSafNo": CafId ? CafId : ""
  //       }
  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });
  //       const data = await response.json();
  //       setPaymentDOAFlag(data.Response.PaymentDOAFlag)
  //       // console.log("response", data.Response);
  //       // const datafetch = {
  //       //     "CafSafNo": "CAF_77820",
  //       //     "PaymentDOAFlag": "Yes",
  //       //     "StatusCode": 200,
  //       //     "Message": "Submit for approval as discount waiver added in the payment record."
  //       // }
  //       if (data.Response.PaymentDOAFlag == "Yes") {
  //         Swal.fire({
  //           // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //           html: `<div style="font-size: 15px;">Submit for Appoval as Upfront Discount added</div>`,
  //           showCancelButton: true,
  //           confirmButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">Yes</span>',
  //           cancelButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
  //           confirmButtonColor: "white",
  //           cancelButtonColor: "white",
  //           customClass: {
  //             popup: "custom-popup",
  //             confirmButton: "custom-confirm-button",
  //             cancelButton: "custom-cancel-button",
  //           },
  //         }).then(async (result) => {
  //           if (result.isConfirmed) {
  //             const { value: formValues } = await Swal.fire({
  //               title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Upfront Discount</div>`,
  //               // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
  //               html: `
  //                                   <input id="swal-input1" class="swal2-input">  `,
  //               focusConfirm: false,
  //               preConfirm: () => {
  //                 // return [document.getElementById("swal-input1").value];
  //                 const reason = document.getElementById("swal-input1").value.trim();
  //                 if (!reason) {
  //                   Swal.showValidationMessage("Reason is required.");
  //                   return;
  //                 }
  //                 return reason;
  //               }
  //             });
  //             if (formValues) {
  //               // Swal.fire(JSON.stringify(formValues));
  //               // console.log("formValues", formValues);
  //               try {
  //                 const apiUrl = process.env.REACT_APP_API_URL_3;
  //                 const requestData = {
  //                   "Action": "DOAForPaymentDigi",
  //                   "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                   "userName": sessionStorage.getItem('userName'),
  //                   "password": sessionStorage.getItem('password'),
  //                   "CafSafNo": CafId,
  //                   "IsDOARequired": "Yes",
  //                   "ReasonForPaymentDOA": formValues
  //                 }
  //                 const response = await fetch(apiUrl, {
  //                   method: "POST",
  //                   headers: {
  //                     "Content-Type": "application/json",
  //                   },
  //                   body: JSON.stringify(requestData),
  //                 });
  //                 const data = await response.json();
  //                 if (data.Status == "Success") {
  //                   try {
  //                     const apiUrl = process.env.REACT_APP_API_URL_3;
  //                     const requestData = {
  //                       "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                       "Action": "getDedupeAlert",
  //                       "userName": sessionStorage.getItem('userName'),
  //                       "password": sessionStorage.getItem('password'),
  //                       "CafSafNo": CafId
  //                     }
  //                     const response = await fetch(apiUrl, {
  //                       method: "POST",
  //                       headers: {
  //                         "Content-Type": "application/json",
  //                         // "token": "e7e916c2e449f6306b27dea2fb2dde46",
  //                       },
  //                       body: JSON.stringify(requestData),
  //                     });
  //                     const data = await response.json();
  //                     setDedupeDOAFlag(data.Response.DedupeDOAFlag)
  //                     if (data.Response.DedupeDOAFlag == "Yes") {
  //                       Swal.fire({
  //                         // html: '<div style="font-size: 15px;">De-dupe case , Do you want to procced ?</div>',
  //                         html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //                         showCancelButton: true,
  //                         confirmButtonText:
  //                           '<span style="font-size: 12px;color:rgb(148,101,170);">Procced</span>',
  //                         cancelButtonText:
  //                           '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
  //                         confirmButtonColor: "white",
  //                         cancelButtonColor: "white",
  //                         customClass: {
  //                           popup: "custom-popup",
  //                           confirmButton: "custom-confirm-button",
  //                           cancelButton: "custom-cancel-button",
  //                         },
  //                       }).then(async (result) => {
  //                         if (result.isConfirmed) {
  //                           try {
  //                             const apiUrl = process.env.REACT_APP_API_URL_3;
  //                             const requestData = {
  //                               Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                               Action: "DOAForDedupeAlert",
  //                               userName: sessionStorage.getItem('userName'),
  //                               password: sessionStorage.getItem('password'),
  //                               CafSafNo: CafId,
  //                               IsDOARequired: "Yes",
  //                             };

  //                             const response = await fetch(apiUrl, {
  //                               method: "POST",
  //                               headers: {
  //                                 "Content-Type": "application/json",
  //                               },
  //                               body: JSON.stringify(requestData),
  //                             });

  //                             if (!response.ok) {
  //                               throw new Error(`HTTP error! status: ${response.status}`);
  //                             }

  //                             const data = await response.json();
  //                             // console.log("API Response:", data);

  //                           } catch (error) {
  //                             console.error("Error during API call:", error.message);
  //                           }
  //                         }
  //                         else if ((result.dismiss === Swal.DismissReason.cancel)) {
  //                           Swal.fire({
  //                             html: '<div style="font-size: 15px;">Are you sure?</div>',
  //                             // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //                             showCancelButton: true,
  //                             confirmButtonText:
  //                               '<span style="font-size: 12px;color:rgb(148,101,170);">yes</span>',
  //                             cancelButtonText:
  //                               '<span style="font-size: 12px;color:rgb(148,101,170);">No</span>',
  //                             confirmButtonColor: "white",
  //                             cancelButtonColor: "white",
  //                             customClass: {
  //                               popup: "custom-popup",
  //                               confirmButton: "custom-confirm-button",
  //                               cancelButton: "custom-cancel-button",
  //                             },
  //                           }).then(async (result) => {
  //                             if (result.isConfirmed) {
  //                               try {
  //                                 const apiUrl = process.env.REACT_APP_API_URL_3;
  //                                 const requestData = {
  //                                   Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                                   Action: "DOAForDedupeAlert",
  //                                   userName: sessionStorage.getItem('userName'),
  //                                   password: sessionStorage.getItem('password'),
  //                                   CafSafNo: CafId,
  //                                   IsDOARequired: "No",
  //                                 };

  //                                 const response = await fetch(apiUrl, {
  //                                   method: "POST",
  //                                   headers: {
  //                                     "Content-Type": "application/json",
  //                                   },
  //                                   body: JSON.stringify(requestData),
  //                                 });

  //                                 if (!response.ok) {
  //                                   throw new Error(`HTTP error! status: ${response.status}`);
  //                                 }
  //                                 const data = await response.json();
  //                                 // console.log("API Response:", data);

  //                                 if (data.Response.StatusCode == "200") {
  //                                   navigate("/broadbandCAF");
  //                                 }
  //                               } catch (error) {
  //                                 console.error("Error during API call:", error.message);
  //                               }
  //                             }
  //                           });
  //                           // try {
  //                           //   const apiUrl = process.env.REACT_APP_API_URL_3;
  //                           //   const requestData = {
  //                           //     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                           //     Action: "DOAForDedupeAlert",
  //                           //     userName: sessionStorage.getItem('userName'),
  //                           //     password: sessionStorage.getItem('password'),
  //                           //     CafSafNo: CafId,
  //                           //     IsDOARequired: "No",
  //                           //   };

  //                           //   const response = await fetch(apiUrl, {
  //                           //     method: "POST",
  //                           //     headers: {
  //                           //       "Content-Type": "application/json",
  //                           //     },
  //                           //     body: JSON.stringify(requestData),
  //                           //   });

  //                           //   if (!response.ok) {
  //                           //     throw new Error(`HTTP error! status: ${response.status}`);
  //                           //   }
  //                           //   const data = await response.json();
  //                           //   console.log("API Response:", data);

  //                           //   if (data.Response.StatusCode == "200") {
  //                           //     navigate("/broadbandCAF");
  //                           //   }
  //                           // } catch (error) {
  //                           //   console.error("Error during API call:", error.message);
  //                           // }
  //                         }
  //                       })
  //                     }
  //                   } catch (error) {
  //                     console.error("Error fetching data:", error.message);
  //                   }
  //                 }
  //               } catch (error) {
  //                 console.error("Error fetching data:", error.message);
  //               }
  //             }
  //           } else if ((result.dismiss === Swal.DismissReason.cancel)) {
  //             try {
  //               const apiUrl = process.env.REACT_APP_API_URL_3;
  //               const requestData = {
  //                 "Action": "DOAForPaymentDigi",
  //                 "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                 "userName": sessionStorage.getItem('userName'),
  //                 "password": sessionStorage.getItem('password'),
  //                 "CafSafNo": CafId,
  //                 "IsDOARequired": "No",
  //                 "ReasonForPaymentDOA": ""
  //               }
  //               const response = await fetch(apiUrl, {
  //                 method: "POST",
  //                 headers: {
  //                   "Content-Type": "application/json",
  //                 },
  //                 body: JSON.stringify(requestData),
  //               });
  //               const data = await response.json();
  //               if (data.Status == "Success") {
  //                 navigate("/broadbandCAF");
  //               }
  //             } catch (error) {
  //               console.error("Error fetching data:", error.message);
  //             }
  //           }
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error.message);
  //     }
  //   };
  //   fetchPaymentAlert();
  // }, []);


  useEffect(() => {
    const fetchPaymentAlert = async () => {
      // console.log("getCafNo", CafId);
      try {
        const apiUrl = process.env.REACT_APP_API_URL_3;
        const requestData = {
          "Action": "getPaymentAlertDigi",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "CafSafNo": CafId ? CafId : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        setPaymentDOAFlag(data.Response.PaymentDOAFlag)
        // console.log("response", data.Response);
        // const datafetch = {
        //     "CafSafNo": "CAF_77820",
        //     "PaymentDOAFlag": "Yes",
        //     "StatusCode": 200,
        //     "Message": "Submit for approval as discount waiver added in the payment record."
        // }
        if (data.Response.PaymentDOAFlag == "Yes") {
          Swal.fire({
            // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
            html: `<div style="font-size: 15px;">Submit for Appoval as Upfront Discount added</div>`,
            showCancelButton: true,
            confirmButtonText:
              '<span style="font-size: 12px;color:rgb(148,101,170);">Yes</span>',
            cancelButtonText:
              '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
              popup: "custom-popup",
              confirmButton: "custom-confirm-button",
              cancelButton: "custom-cancel-button",
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              const { value: formValues } = await Swal.fire({
                title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Upfront Discount</div>`,
                // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
                html: `
                                    <input id="swal-input1" class="swal2-input">  `,
                focusConfirm: false,
                preConfirm: () => {
                  // return [document.getElementById("swal-input1").value];
                  const reason = document.getElementById("swal-input1").value.trim();
                  if (!reason) {
                    Swal.showValidationMessage("Reason is required.");
                    return;
                  }
                  return reason;
                }
              });
              if (formValues) {
                // Swal.fire(JSON.stringify(formValues));
                // console.log("formValues", formValues);
                try {
                  const apiUrl = process.env.REACT_APP_API_URL_3;
                  const requestData = {
                    "Action": "DOAForPaymentDigi",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "userName": sessionStorage.getItem('userName'),
                    "password": sessionStorage.getItem('password'),
                    "CafSafNo": CafId,
                    "IsDOARequired": "Yes",
                    "ReasonForPaymentDOA": formValues
                  }
                  const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                  });
                  const data = await response.json();
                  if (data.Status == "Success") {
                    // try {
                    //   const apiUrl = process.env.REACT_APP_API_URL_3;
                    //   const requestData = {
                    //     "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    //     "Action": "getDedupeAlert",
                    //     "userName": sessionStorage.getItem('userName'),
                    //     "password": sessionStorage.getItem('password'),
                    //     "CafSafNo": CafId
                    //   }
                    //   const response = await fetch(apiUrl, {
                    //     method: "POST",
                    //     headers: {
                    //       "Content-Type": "application/json",
                    //       // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                    //     },
                    //     body: JSON.stringify(requestData),
                    //   });
                    //   const data = await response.json();
                    //   setDedupeDOAFlag(data.Response.DedupeDOAFlag)
                    //   if (data.Response.DedupeDOAFlag == "Yes") {
                    //     Swal.fire({
                    //       // html: '<div style="font-size: 15px;">De-dupe case , Do you want to procced ?</div>',
                    //       html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
                    //       showCancelButton: true,
                    //       confirmButtonText:
                    //         '<span style="font-size: 12px;color:rgb(148,101,170);">Procced</span>',
                    //       cancelButtonText:
                    //         '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
                    //       confirmButtonColor: "white",
                    //       cancelButtonColor: "white",
                    //       customClass: {
                    //         popup: "custom-popup",
                    //         confirmButton: "custom-confirm-button",
                    //         cancelButton: "custom-cancel-button",
                    //       },
                    //     }).then(async (result) => {
                    //       if (result.isConfirmed) {
                    //         try {
                    //           const apiUrl = process.env.REACT_APP_API_URL_3;
                    //           const requestData = {
                    //             Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    //             Action: "DOAForDedupeAlert",
                    //             userName: sessionStorage.getItem('userName'),
                    //             password: sessionStorage.getItem('password'),
                    //             CafSafNo: CafId,
                    //             IsDOARequired: "Yes",
                    //           };

                    //           const response = await fetch(apiUrl, {
                    //             method: "POST",
                    //             headers: {
                    //               "Content-Type": "application/json",
                    //             },
                    //             body: JSON.stringify(requestData),
                    //           });

                    //           if (!response.ok) {
                    //             throw new Error(`HTTP error! status: ${response.status}`);
                    //           }

                    //           const data = await response.json();
                    //           // console.log("API Response:", data);

                    //         } catch (error) {
                    //           console.error("Error during API call:", error.message);
                    //         }
                    //       }
                    //       else if ((result.dismiss === Swal.DismissReason.cancel)) {
                    //         Swal.fire({
                    //           html: '<div style="font-size: 15px;">Are you sure?</div>',
                    //           // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
                    //           showCancelButton: true,
                    //           confirmButtonText:
                    //             '<span style="font-size: 12px;color:rgb(148,101,170);">yes</span>',
                    //           cancelButtonText:
                    //             '<span style="font-size: 12px;color:rgb(148,101,170);">No</span>',
                    //           confirmButtonColor: "white",
                    //           cancelButtonColor: "white",
                    //           customClass: {
                    //             popup: "custom-popup",
                    //             confirmButton: "custom-confirm-button",
                    //             cancelButton: "custom-cancel-button",
                    //           },
                    //         }).then(async (result) => {
                    //           if (result.isConfirmed) {
                    //             try {
                    //               const apiUrl = process.env.REACT_APP_API_URL_3;
                    //               const requestData = {
                    //                 Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    //                 Action: "DOAForDedupeAlert",
                    //                 userName: sessionStorage.getItem('userName'),
                    //                 password: sessionStorage.getItem('password'),
                    //                 CafSafNo: CafId,
                    //                 IsDOARequired: "No",
                    //               };

                    //               const response = await fetch(apiUrl, {
                    //                 method: "POST",
                    //                 headers: {
                    //                   "Content-Type": "application/json",
                    //                 },
                    //                 body: JSON.stringify(requestData),
                    //               });

                    //               if (!response.ok) {
                    //                 throw new Error(`HTTP error! status: ${response.status}`);
                    //               }
                    //               const data = await response.json();
                    //               // console.log("API Response:", data);

                    //               if (data.Response.StatusCode == "200") {
                    //                 navigate("/broadbandCAF");
                    //               }
                    //             } catch (error) {
                    //               console.error("Error during API call:", error.message);
                    //             }
                    //           }
                    //         });

                    //       }
                    //     })
                    //   }
                    // } catch (error) {
                    //   console.error("Error fetching data:", error.message);
                    // }

                    try {
                      const apiUrl = process.env.REACT_APP_API_URL_3;
                      const requestData = {
                        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        "Action": "getDedupeAlert",
                        "userName": sessionStorage.getItem('userName'),
                        "password": sessionStorage.getItem('password'),
                        "CafSafNo": CafId
                      }
                      const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                        },
                        body: JSON.stringify(requestData),
                      });
                      const data = await response.json();
                      setDedupeDOAFlag(data.Response.DedupeDOAFlag)
                      if (data.Response.DedupeDOAFlag == "Yes") {

                        try {
                          const apiUrl = process.env.REACT_APP_API_URL_3;
                          const requestData = {
                            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            Action: "DOAForDedupeAlert",
                            userName: sessionStorage.getItem('userName'),
                            password: sessionStorage.getItem('password'),
                            CafSafNo: CafId,
                            IsDOARequired: "Yes",
                          };

                          const response = await fetch(apiUrl, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestData),
                          });

                          if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                          }

                          const data = await response.json();
                          // console.log("API Response:", data);
                          if (data.Response.StatusCode == 200) {
                            toast.success(data.Response.Message, {
                              position: toast.POSITION.BOTTOM_CENTER,
                              autoClose: 1500,
                            });
                          } else {
                            toast.warning(data.Response.Message, {
                              position: toast.POSITION.BOTTOM_CENTER,
                              autoClose: 1500,
                            });
                          }

                        } catch (error) {
                          console.error("Error during API call:", error.message);
                        }

                      }
                    } catch (error) {
                      console.error("Error fetching data:", error.message);
                    }
                  } else {
                    toast.warning(data.Response.Message, {
                      position: toast.POSITION.BOTTOM_CENTER,
                      autoClose: 1500,
                    });
                  }
                } catch (error) {
                  console.error("Error fetching data:", error.message);
                }
              }
            } else if ((result.dismiss === Swal.DismissReason.cancel)) {
              try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                  "Action": "DOAForPaymentDigi",
                  "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                  "userName": sessionStorage.getItem('userName'),
                  "password": sessionStorage.getItem('password'),
                  "CafSafNo": CafId,
                  "IsDOARequired": "No",
                  "ReasonForPaymentDOA": ""
                }
                const response = await fetch(apiUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(requestData),
                });
                const data = await response.json();
                if (data.Status == "Success") {
                  navigate("/broadbandCAF");
                }
              } catch (error) {
                console.error("Error fetching data:", error.message);
              }
            }
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    fetchPaymentAlert();
  }, []);



  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const apiUrl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //         "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         "Action": "getDedupeAlert",
  //         "userName": sessionStorage.getItem('userName'),
  //         "password": sessionStorage.getItem('password'),
  //         "CafSafNo": CafId ? CafId : ""
  //       }
  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           // "token": "e7e916c2e449f6306b27dea2fb2dde46",
  //         },
  //         body: JSON.stringify(requestData),
  //       });
  //       const data = await response.json();
  //       if (data.Response.DedupeDOAFlag == "Yes") {
  //         Swal.fire({
  //           // html: '<div style="font-size: 15px;">De-dupe case , Do you want to procced ?</div>',
  //           html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //           showCancelButton: true,
  //           confirmButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">Procced</span>',
  //           cancelButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
  //           confirmButtonColor: "white",
  //           cancelButtonColor: "white",
  //           customClass: {
  //             popup: "custom-popup",
  //             confirmButton: "custom-confirm-button",
  //             cancelButton: "custom-cancel-button",
  //           },
  //         }).then(async (result) => {
  //           if (result.isConfirmed) {
  //             try {
  //               const apiUrl = process.env.REACT_APP_API_URL;
  //               const requestData = {
  //                 Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                 Action: "DOAForDedupeAlert",
  //                 userName: sessionStorage.getItem('userName'),
  //                 password: sessionStorage.getItem('password'),
  //                 CafSafNo: CafId ? CafId : "",
  //                 IsDOARequired: "Yes",
  //               };

  //               const response = await fetch(apiUrl, {
  //                 method: "POST",
  //                 headers: {
  //                   "Content-Type": "application/json",
  //                 },
  //                 body: JSON.stringify(requestData),
  //               });

  //               if (!response.ok) {
  //                 throw new Error(`HTTP error! status: ${response.status}`);
  //               }

  //               const data = await response.json();
  //               console.log("API Response:", data);

  //             } catch (error) {
  //               console.error("Error during API call:", error.message);
  //             }
  //           }
  //           else if ((result.dismiss === Swal.DismissReason.cancel)) {
  //             Swal.fire({
  //               html: '<div style="font-size: 15px;">Are You Sure?</div>',
  //               // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //               showCancelButton: true,
  //               confirmButtonText:
  //                 '<span style="font-size: 12px;color:rgb(148,101,170);">yes</span>',
  //               cancelButtonText:
  //                 '<span style="font-size: 12px;color:rgb(148,101,170);">No</span>',
  //               confirmButtonColor: "white",
  //               cancelButtonColor: "white",
  //               customClass: {
  //                 popup: "custom-popup",
  //                 confirmButton: "custom-confirm-button",
  //                 cancelButton: "custom-cancel-button",
  //               },
  //             }).then(async (result) => {
  //               if (result.isConfirmed) {
  //                 try {
  //                   const apiUrl = process.env.REACT_APP_API_URL_3;
  //                   const requestData = {
  //                     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                     Action: "DOAForDedupeAlert",
  //                     userName: sessionStorage.getItem('userName'),
  //                     password: sessionStorage.getItem('password'),
  //                     CafSafNo: CafId ? CafId : "",
  //                     IsDOARequired: "No",
  //                   };

  //                   const response = await fetch(apiUrl, {
  //                     method: "POST",
  //                     headers: {
  //                       "Content-Type": "application/json",
  //                     },
  //                     body: JSON.stringify(requestData),
  //                   });

  //                   if (!response.ok) {
  //                     throw new Error(`HTTP error! status: ${response.status}`);
  //                   }
  //                   const data = await response.json();
  //                   console.log("API Response:", data);

  //                   if (data.Response.StatusCode == "200") {
  //                     navigate("/broadbandCAF");
  //                   }
  //                 } catch (error) {
  //                   console.error("Error during API call:", error.message);
  //                 }
  //               }
  //             });

  //           }
  //         })
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error.message);
  //     }
  //   };
  //   fetchData();
  // }, []);


  // ****************API'S****************//





  useEffect(() => {
    const fetchBroadBandLead = async () => {
      // console.log("leadId", leadId);
      try {
        // const apiUrl = process.env.REACT_APP_API_URL_1;
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getLeads",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: leadId,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        setLoading(false);
        const result = await response.json();
        // console.log("API Response LeadCaf:", result);

        // alert('hlo2')
        // console.log("Lead res", result);

        // setCustomerDetails(result.Response);
        setcustomerGroup(result.Response[0].GroupId);
        // console.log("firest:", result.Response[0].CompanyId);
        setcustomerComp(result.Response[0].CompanyId);
        // console.log('firest:', result.Response.accountDetail.FirstName);
        setIsGst('0');
        setSalutate(result.Response[0].SalutationId);
        setFirstName(result.Response[0].Companyname);
        // console.log("result.Response.FirstName", result.Response[0].FirstName);
        // setLastName(result.Response[0].Companyname);
        setMobileNo(result.Response[0].MobileNo);
        setEmailId(result.Response[0].EmailId);
        setCafNO(result.Response[0].CAFId);
        const filterfirmType = firmtypeOpts.find((item) => item.value === String(result.Response[0].companyDetail.FirmType)).label;
        // setSelectedFirmType({
        //   label: filterfirmType,
        //   value: result.Response[0].companyDetail.FirmType,
        // });
        setSelectRelationship(result.Response[0].RelationshipId);
        // console.log(
        //   "result.Response[0].cafDetail.State",
        //   result.Response[0].installationAddress.InstallState
        // );
        setApiStateCode(result.Response[0].installationAddress.InstallState);
        setApiCityCode(result.Response[0].installationAddress.InstallCity);
        // console.log(
        //   "result.Response[0].installationAddress.InstallArea",
        //   result.Response[0].installationAddress.InstallArea
        // );
        setApiAreaCode(result.Response[0].installationAddress.InstallArea);
        // console.log(
        //   "result.Response[0].installationAddress.InstallSociety",
        //   result.Response[0].installationAddress.InstallSociety
        // );
        setApiSocietyCode(
          result.Response[0].installationAddress.InstallSociety
        );
        // fetchGetProduct(result.Response[0].installationAddress.InstallSociety);
        setApiFloorCode(result.Response[0].installationAddress.InstallFloor);
        setApiPinCode(result.Response[0].installationAddress.InstallPincode);
        setApiblockCode(result.Response[0].installationAddress.InstallPlotNo);
        // console.log("PRODNFDJD", result.Response[0].ProductName)
        // setApiProd(result.Response[0].ProductName)
        const OtpAuthStaus = result.Response[0].OTPAuthStatsu;
        const boolean = OtpAuthStaus.toString();
        setotpAuthStatus(boolean);
        // setCheckboxes(result.Response[0].documentRequired);
        // setpaymentStatus(result.Response[0].paymentDetail.PaymentStatus);
        setotc(result.Response[0].paymentDetail.OTC);
        setTan(result.Response[0].cafDetail.TANNo);
        setPan(result.Response[0].cafDetail.PANNo);

        setPaymentDetails(result.Response[0].paymentDetail);
        setPaymentMethod(result.Response[0].paymentDetail.PayInSlip);
        // console.log("paty", result.Response[0].paymentDetail.PayInSlip);
        // console.log("wqeqw", result.Response[0]);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    if (!CafId) {
      fetchBroadBandLead();
    }
  }, []);



  const fetchCompanyData = async () => {
    try {
      setLoader(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getCompany",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: "New Company",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      // console.log("conpany name :", data.Response.Data);
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((company) => ({
          label: `${company.Company_Name} (${company.Company_ID})`,
          value: company.Company_ID,
          group: `${company.Group_Name} (${company.Group_ID})`,
          groupId: company.Group_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoader(false);
    }
    return [];
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (CafId) return;
        setLoading(true);
        // console.log(searchParams.get("LeadId"));
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getopportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: searchParams.get("LeadId") || "",
          OppId: OppId ? OppId : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const responsedata = await response.json();
        // console.log("responsedata: ", responsedata);
        const responseData = responsedata?.Response?.Data?.[0];

        if (responsedata?.Status === "Success" && responseData) {
          setCustomerPicture({ fileNameWithExtension: responseData?.customerImage?.FileNameWithExtension })
          // setCustomerPicture({ fileNameWithExtension: responseData?.customerImage?.FileNameWithExtension, fileContent: responseData?.customerImage?.FileContent })
          setProductSegment(responsedata?.Response?.Data[0].ProductSegment)
          ////////////////
          const options = await fetchCompanyData("");
          // console.log(options);
          let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
          // console.log(defaultCompanyGroupObj);
          let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
          // console.log(defaultRelationship);

          setSelectedCompany({
            value: defaultCompanyGroupObj?.value,
            label: defaultCompanyGroupObj?.label,
          });

          setSelectGroup({
            value: defaultCompanyGroupObj?.groupId,
            label: defaultCompanyGroupObj?.group,
          });

          // console.log(defaultRelationship);

          if (defaultRelationship.Response?.Data) {
            let defaultRelationshipObj = defaultRelationship.Response?.Data?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
            // console.log(defaultRelationshipObj);
            setSelectRelationship({
              value: defaultRelationshipObj?.Relationship_ID,
              label: defaultRelationshipObj?.Relationship_Name
            });
          }
          setCompanyOptions(options);

          setSelectedSubSegment({
            value: responseData?.Subbusinesssegment,
            label: responseData?.Subbusinesssegment
          })
          const filterfirmType = firmtypeOpts.find((item) => item.value === String(responseData?.Firmtype))?.label;
          !CafId && setSelectedFirmType({
            label: filterfirmType,
            value: responseData?.Firmtype,
          });
          const filterOtherServiceProvider = ServiceProviders.find((item) => item.value === String(responseData?.Existingprovider))?.label;
          setServiceProvider(
            {
              label: filterOtherServiceProvider,
              value: responseData?.Existingprovider,
            }
          )
          const filterOtherFirewall = firewallOpts.find((item) => item.value === String(responseData?.Firewall))?.label;
          setOtherFirewall(
            {
              label: filterOtherFirewall,
              value: responseData?.Firewall,
            }
          )
          const filterOtherSelfpo = selfpoOpts.find((item) => item.value === String(responseData?.CompanySelf))?.label;
          setSelectSelfpo({
            label: filterOtherSelfpo,
            value: responseData?.CompanySelf,
          })

          ///////////////////////////////////



          const concatenatedAddress = `${responseData.BlockTowerNumber || ''} ${responseData.HousePlotFlatNo || ''} ${responseData.SocietyName || ''} ${responseData.Area || ''} ${responseData.City || ''} ${responseData.State || ''} ${responseData.Country || ''}`;
          // console.log("Concatenated Address:", concatenatedAddress);


          // console.log("responseData.Product", responseData.Product)
          let getBuilding = await api.getBuilding({ areaName: responseData.AreaId, areaCode: responseData?.AreaId })
          let defaultBuilding = getBuilding?.Response?.Data?.find((building) => building.BuildingCode == responseData?.BuildingId)
          // console.log("getBuilding?.Response?.Data", getBuilding?.Response?.Data);

          setUserData({
            Remarks: responseData?.Remarks || "",
            Redunancy: responseData?.Redunancy || false,
            Block: responseData?.Block || "",
            Status: responseData?.Status || "",
            Statuscode: responseData?.Statuscode || "",
            OppId: responseData?.OppId || "",
            LeadId: responseData?.LeadId || "",
            PriceList: responseData?.PriceList || "",
            Topic: responseData?.Topic || "",
            StateId: responseData?.StateId || "",
            CityId: responseData?.CityId || "",
            AreaId: responseData?.AreaId || "",
            BuildingId: responseData.BuildingId ? responseData.BuildingId : "",
            BuildingCode: "",
            SpecificArea: responseData?.SpecificArea || "",
            SpecificBuilding: responseData?.SpecificBuilding || "",
            Building_BuildingStatus: responseData ? responseData?.Building_BuildingStatus : "",
            NoOfUsers: responseData?.NoOfUsers || "",
            NoOfBeds: responseData?.NoOfBeds || "",
            // IndustryId: responseData?.IndustryId || "",
            ApprovalRequiredFlag: responseData?.ApprovalRequiredFlag || "",
            Reason: responseData?.Reason || "",
            Area: responseData?.Area || "",
            Businesssegment: responseData?.Businesssegment || "",
            State: responseData?.State || "",
            Salutation: responseData?.Salutation || "",

            PostalCode: responseData?.PostalCode || "",
            InstPin: responseData?.PostalCode || "",
            Mobilephone: responseData?.Mobilephone || "",
            Media: responseData?.Media || "",
            Lco: responseData?.Lco || null,
            // Industry: responseData?.Industry || "",
            Group: responseData?.Group || "",
            Floor: responseData?.Floor || "",
            TPFeasibilty: responseData?.TPFeasibilty || "",
            CreateAreaOrBuilding: responseData?.CreateAreaOrBuilding || false,

            Product: responseData?.Product || "",
            ProductSegment: responseData?.ProductSegment || "",
            FeasibilityRequired: responseData?.FeasibilityRequired || false,
            Existingprovider: responseData?.Existingprovider || "",
            Emailaddress: responseData?.Emailaddress || "",
            Country: responseData?.Country || "",
            Companyname: responseData?.Companyname || "",
            City: responseData?.City || "",
            leadname: responseData?.leadname || "",
            Buildingname: responseData?.Buildingname || "",
            BuildingNo: responseData?.BuildingNo || "",
            ContactPerson: responseData?.ContactPerson || "",
            CustomerSegment: responseData?.CustomerSegment || "",
            LastMileType: responseData?.LastMileType || "",
            UpTimesla: responseData?.UpTimesla || "",
            FirewallSetToExpire: responseData?.FirewallSetToExpire || "",
            CompanySelf: responseData?.CompanySelf || "",
            PoLock: yyyymmddFormat(responseData?.PoLock) || "",
            Price: responseData?.Price || "",
            OriginatingLead: responseData?.OriginatingLead || "",
            FirewallAwc: responseData?.FirewallAwc || "",
            PoNext: yyyymmddFormat(responseData?.PoNext) || "",
            Company: responseData?.Company || "",
            TotalAmount: responseData?.TotalAmount || "",
            VerticalID: responseData?.VerticalID || "",
            TypeOfOrder: responseData?.TypeOfOrder || "",
            PocClosureDate: responseData?.PocClosureDate || "",
            TurnOver: responseData?.TurnOver || "",
            SocietyName: responseData?.SocietyName || "",
            SocietyId: responseData?.SocietyId || "",
            SocietyStatus: responseData?.SocietyStatus || "",
            HousePlotFlatNo: responseData?.HousePlotFlatNo || "",
            BlockTowerNumber: responseData?.BlockTowerNumber || "",
            OTCAmount: responseData?.OTCAmount || "",
            SDAmount: responseData?.SDAmount || "",
            RCAmount: responseData?.RCAmount || "",
            IsPaymentLinkSendToCustomer: "",
            UpfrontApprovedSDAmount: "",
            UpfrontApprovedOTCAmount: "",
            UpfrontApprovedRCAmount: "",
            UpfrontReqSDAmount: "", // CafId ? "" : responseData?.UpfrontRequestedSDAmount,
            UpfrontReqOTCAmount: "",
            UpfrontReqRCAmount: "",
            ApprovedSDAmount: responseData?.ApprovedSDAmount || "",
            ApprovedOTCAmount: responseData?.ApprovedOTCAmountIncTax || "",
            ApprovedRCAmount: responseData?.ApprovedRCAmountIncTax || "",
            totalAmount: responseData?.TotalAmount || "",
          });
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerImage: { fileNameWithExtension: "customer_live_picture.jpg", fileContent: responseData?.customerImage || "" }
          }));

          fetchLatLong(concatenatedAddress);
          setFirstName(responseData.Companyname);
          setSelectIndustry({
            value: responseData.IndustryId,
            label: responseData.Industry,
          })
          setSelectedProductType({
            value: responseData.Product,
            label: responseData.Product,
          })

          const filterProductType = productdropdetails?.find((item) =>
            item.label === String(responseData.Product)
          ).value;

          // console.log("filterProductType", filterProductType)
          // console.log("responseData.Product", responseData)

          // setSelectState({
          //   value: responseData.StateId,
          //   label: responseData.State,
          // })
          // setLastName(responseData.Companyname);

        } else {
          // Handle unsuccessful response
          console.error("Error fetching opportunity data:", responseData?.Message);
        }
      } catch (error) {
        // Handle fetch error
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [getLeadId]);


  const yyyymmddFormat = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length !== 3) return "";
    if (parts[0].length === 4) {
      return dateStr; // Already in YYYY-MM-DD format
    } else {
      // Convert from DD-MM-YYYY to YYYY-MM-DD
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
  };



  useEffect(() => {
    const fetchBussinessCAF = async () => {
      setLoading(true)
      try {
        if (!CafId) return;

        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          Action: "getCafDZationB",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          cafNo: CafId,
          oppid: "",
          safNo: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        // console.log("firmtype:", result?.Response?.Data?.companyDetail.FirmType);
        sessionStorage.setItem("firmtype", result?.Response?.Data?.companyDetail?.FirmType || "");
        // setGetCafNo(result.Response.cafDetail.CafNo); sellerImage customerKYCdocument

        //  console.log({
        //     customerImage: { fileNameWithExtension: result.Response.Data.customerImage.FileNameWithExtension, fileContent: result.Response.Data.customerImage.FileContent },
        //     sellerImage: { fileNameWithExtension: result.Response.Data.sellerImage.SellerFileNameWithExtension, fileContent: result.Response.Data.sellerImage.SellerFileContent },
        //     customerKYCdocument: { fileNameWithExtension: result.Response.Data.customerKYCdocument.CustomerKYCfileNameWithExtension, fileContent: result.Response.Data.customerKYCdocument.CustomerKYCfileContent },
        //   });

        let KycDocName = (result?.Response?.Data?.customerKYCdocument?.CustomerKYCfileNameWithExtension)?.split("_").pop()?.split(".")[0];
        // console.log(KycDocName);        
        setSelectDocument(optionDocument.find((data) => data.label == KycDocName))
        setCustomerPicture({ fileNameWithExtension: result?.Response?.Data?.customerImage?.FileNameWithExtension })
        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          customerImage: { fileNameWithExtension: result?.Response?.Data?.customerImage?.FileNameWithExtension, fileContent: result?.Response?.Data?.customerImage?.FileContent },
          sellerImage: { sellerOTPAuthDate: "", sellerFileNameWithExtension: result?.Response?.Data?.sellerImage?.SellerFileNameWithExtension, sellerFileContent: result?.Response?.Data?.sellerImage?.SellerFileContent },
          customerKYCdocument: { customerKYCAddress: "", customerKYCfileNameWithExtension: result?.Response?.Data?.customerKYCdocument?.CustomerKYCfileNameWithExtension, customerKYCfileContent: result?.Response?.Data?.customerKYCdocument?.CustomerKYCfileContent },
        }));

        // console.log(cityAuthOption, result?.Response?.Data?.billingAddress.Bill_City);


        //////nnnnnnnnnnnn        
        // setSelectedFirmType(firmTypes.find((data) => data.value == result?.Response?.Data?.companyDetail?.FirmType))
        setCustomerWorkingHours(custmrworkhrsoptions.find((data) => data.value == result?.Response?.Data?.CustomerWorkingHours));
        setSelectedCommMode(CommModeOpts.find((data) => data.value == result?.Response?.Data?.PreferredCommMode));
        setMonitorDays(MonitorDaysOpts.find((data) => data.value == result?.Response?.Data?.NtwMonitAlert));
        setBusinessDays(BusDaysOpts.find((data) => data.value == result?.Response?.Data?.BusinessDays));
        setBillType(billtypeOpts.find((data) => data.value == result?.Response?.Data?.installationAddresses.Inst_BillType));
        setSelectVoip(voiOpts.find((data) => data.value == result?.Response?.Data?.installationAddresses.Inst_VoidPort));
        setCusCategory(customercatOpts.find((data) => data.value == result?.Response?.Data?.installationAddresses.Inst_CategoryofCustomer));
        setSelectAuthCity(cityAuthOption.find((data) => data.value == result?.Response?.Data?.authSigDetails.Auth_City));
        const getCity = await api.getCity(result?.Response?.Data?.billingAddress.Bill_State)
        // console.log(getCity?.Response?.Data, getCity?.Response?.Data?.find((data) => data.CityCode == (result?.Response?.Data.billingAddress.Bill_City)));
        const getBillCity = getCity?.Response?.Data?.find((data) => data.CityCode == (result?.Response?.Data.billingAddress.Bill_City))
        setSelectBillCity({
          label: getBillCity?.CityName,
          value: getBillCity?.CityCode
        });

        setSelectInstCity(cityAuthOption.find((data) => data.value == (result?.Response?.Data.installationAddresses.Inst_City)));
        setpaymentStatus(PaymentOpts.find((data) => data.value == result?.Response?.Data?.payments.PaymentStatus));
        let stateOpt = optionAuthState?.map((data) => ({
          value: data.code,
          label: data.name,
        }))
        setSelectAuthState(stateOpt?.find((data) => data.value == result?.Response?.Data?.authSigDetails.Auth_State));
        setSelectBillState(stateOpt?.find((data) => data.value == result?.Response?.Data?.billingAddress.Bill_State));
        setSelectInstState(stateOpt?.find((data) => data.value == result?.Response?.Data?.installationAddresses.Inst_State));
        setSelectPaymentMode(optionPayment?.find((data) => data.value == result?.Response?.Data?.payments.ModeOfPayment));
        setselectedPaySlipOption(filteredPayslipOpts?.find((data) => data.value == result?.Response?.Data?.payments.PayInSlip).value);
        // console.log(filteredPayslipOpts, result?.Response?.Data?.payments.PayInSlip);

        if (result?.Response?.Data?.payments.ModeOfPayment === "Offline") {
          // Show only Cheque, DD, NEFT, RTGS
          setFilteredPayslipOpts(
            payslipOpts.filter((option) =>
              ["1", "2", "4", "5"].includes(option.value)
            )
          );
        } else if (result?.Response?.Data?.payments.ModeOfPayment === "Online") {
          // Show all options except Cheque, DD, NEFT, RTGS
          setFilteredPayslipOpts(
            payslipOpts.filter(
              (option) => !["1", "2", "4", "5"].includes(option.value)
            )
          );
        } else {
          // Reset to show all options if no valid payment mode is selected
          setFilteredPayslipOpts(payslipOpts);
        }



        setCustomerDetails(result?.Response?.Data?.NetworkTechnology);
        setCafDetails(result?.Response?.Data)
        // console.log("paymentDetail?.ApprovedRCAmount", result?.Response?.Data?.payments.ApprovedOTCAmountIncTax);
        // console.log("UpfrontRequestedOTCAmountIncTax", result?.Response?.Data?.payments.UpfrontRequestedOTCAmountIncTax);
        let getAreaBill = await api.getArea({ cityName: "", cityCode: result?.Response?.Data.billingAddress?.Bill_City })
        let getAreaInst = await api.getArea({ cityName: "", cityCode: result?.Response?.Data.installationAddresses?.Inst_City })
        let getBuildingBill = await api.getBuilding({ areaName: "", areaCode: result?.Response?.Data.billingAddress?.Bill_Area })
        let getBuildingInst = await api.getBuilding({ areaName: "", areaCode: result?.Response?.Data.installationAddresses?.Inst_Area })

        let defaultBuildingBill = getBuildingBill?.Response?.Data?.find((building) => building.BuildingCode == result?.Response?.Data.billingAddress?.Bill_BuildingName)
        let defaultBuildingInst = getBuildingInst?.Response?.Data?.find((building) => building.BuildingCode == result?.Response?.Data.installationAddresses?.Inst_BuildingName)
        let defaultAreaBill = getAreaBill?.Response?.Data?.find((area) => area.AreaCode == result?.Response?.Data.billingAddress?.Bill_Area)
        let defaultAreaInst = getAreaInst?.Response?.Data?.find((area) => area.AreaCode == result?.Response?.Data.installationAddresses?.Inst_Area)
        // console.log(defaultBuildingBill, defaultAreaBill);
        setBuildingBill(defaultBuildingBill)
        setSelectBillBuilding({
          label: defaultBuildingBill?.BuildingName,
          value: defaultBuildingBill?.BuildingCode
        })

        setAreaBill(defaultAreaBill)
        setSelectBillArea({
          label: defaultAreaBill?.AreaName,
          value: defaultAreaBill?.AreaCode
        })

        setAreaInst(defaultAreaInst)
        setBuildingInst(defaultBuildingInst)
        // console.log("getBuildingInst", getBuildingInst);
        // console.log("getBuilding", defaultBuildingBill, defaultBuildingInst);

        if (result.Status == "Success" && result.Response) {
          // console.log(result.Response.Data.billingAddress);          

          const { accountDetail, paymentDetail, documentRequired, cafDetail, billingAddress, payments } = result.Response.Data;
          // console.log(result?.Response?.Data);
          const responseData = result?.Response?.Data;
          setGender(responseData?.Gender);
          setUserData({
            gstNo: responseData?.GstNumberDetial,
            panNo: responseData?.PanNo,
            tanNo: responseData?.TanNo,
            authorName: responseData?.authSigDetails?.Auth_Name,
            authorFather: responseData?.authSigDetails?.Auth_Father,
            authResidentialAddress: responseData?.authSigDetails?.Auth_Resadd,
            autherMobile: responseData?.authSigDetails?.Auth_MobileNo,
            autherEmail: responseData?.authSigDetails?.Auth_EmailId,
            autherPinCode: responseData?.authSigDetails?.Auth_PinCode,
            LastMileType: responseData?.LastMileType,
            BuildingNo: responseData?.installationAddresses?.Inst_BuildingNo,
            InstPin: responseData?.installationAddresses?.Inst_PinCode,

            StateId: responseData?.installationAddresses?.Inst_State || "",
            CityId: responseData?.installationAddresses?.Inst_City || "",
            AreaId: responseData?.installationAddresses?.Inst_Area || "",
            BuildingId: responseData?.installationAddresses?.Inst_BuildingName || "",
            BuildingNo: responseData?.installationAddresses?.Inst_BuildingNo || "0",
            Emailaddress: responseData?.installationAddresses?.Inst_EmailId || "",
            Mobilephone: responseData?.authSigDetails?.Auth_MobileNo || "",

            Floor: responseData?.installationAddresses?.Inst_InstallationFloor || "",

            Product: responseData?.Product || "",
            ProductSegment: responseData?.installationAddresses?.ProductSegment || "",
            Companyname: responseData?.CompanyName || "",
            ContactPerson: responseData?.CustomerName || "",
            contactName: responseData?.billingAddress?.Bill_ConatctName || "",
            billmail: responseData?.billingAddress?.Bill_EmailId || "",
            billPhone: responseData?.billingAddress?.Bill_MobileNo || "",
            billBuildingNo: responseData?.billingAddress?.Bill_BuildingNo || "",
            billFloor: responseData?.billingAddress?.Bill_Floor || "",
            billPin: responseData?.billingAddress?.Bill_PinCode || "",
            techSupportEmail: responseData?.TechnicalSupportEmailID || "",
            UpTimesla: responseData?.otherinformations?.UptimeSLA || "",
            PoLock: yyyymmddFormat(responseData?.otherinformations?.PoLock) || "",
            PoNext: yyyymmddFormat(responseData?.otherinformations?.PoNext) || "",
            CpeContactPersonName: responseData?.installationAddresses?.CpeContactPersonName || "",
            CpeContactPersonPhone: responseData?.installationAddresses?.CpeContactPersonPhone || "",
            CpeDispatchAddress: responseData?.installationAddresses?.CpeDispatchAddress || "",
            RemarkCPE: responseData?.installationAddresses?.RemarkCPE || "",
            ssIdNomenclatureOne: responseData?.SSID1Nomenclature || "",
            ssIdNomenclatureTwo: responseData?.SSID2Nomenclature || "",
            reqBandwidth: responseData?.RequiredBandwidthinMbps || "",
            specialReq: responseData?.SpecialRequest || "",
            ServiceId: responseData?.ServiceId,
            DOBorDateofRegistration: responseData?.DOBorDateofRegistration || "",
            ProfessionofSubscriber: responseData?.ProfessionofSubscriber || ""
          });

          setPaymentButton(result?.Response?.Data?.payments?.IsPaymentLinkSendToCustomer);
          setProductSegment(result?.Response?.Data?.installationAddresses?.ProductSegment)



          const options = await fetchCompanyData("");
          // console.log(options);
          let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
          // console.log(defaultCompanyGroupObj);
          let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
          // console.log(defaultRelationship);

          setSelectedCompany({
            value: defaultCompanyGroupObj?.value,
            label: defaultCompanyGroupObj?.label,
          });

          setSelectGroup({
            value: defaultCompanyGroupObj?.groupId,
            label: defaultCompanyGroupObj?.group,
          });

          // console.log(defaultRelationship);

          if (defaultRelationship.Response?.Data) {
            let defaultRelationshipObj = defaultRelationship.Response?.Data?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
            // console.log(defaultRelationshipObj);
            setSelectRelationship({
              value: defaultRelationshipObj?.Relationship_ID,
              label: defaultRelationshipObj?.Relationship_Name
            });
          }

          setCompanyOptions(options);

          setSelectedSubSegment({
            value: responseData?.SubBussinessSegment,
            label: responseData?.SubBussinessSegment
          })

          // setSelectIndustry({
          //   value: responseData?.companyDetail?.IndustryType,
          //   label: responseData?.companyDetail?.IndustryType,
          // })
          // console.log(responseData?.companyDetail?.IndustryType, industrydropdetails, industrydropdetails.find((data) => data.value == responseData?.companyDetail?.IndustryType));

          setSelectIndustry(industrydropdetails.find((data) => data.value == responseData?.companyDetail?.IndustryType))
          setSelectedProductType({
            value: responseData.Product,
            label: responseData.Product,
          })

          // const filterOtherFirewall = firewallOpts.find((item) => item.value === String(responseData?.otherinformations?.FireWall));
          // console.log(filterOtherFirewall);

          const filterReportReq = reportReqOpts.find((item) => item.value === String(responseData?.ReportrequiredonUMP))?.label;
          setReportReq(
            {
              label: filterReportReq,
              value: responseData?.ReportrequiredonUMP,
            }
          )

          const filterDashboardReq = DashboardReqOpts.find((item) => item.value === String(responseData?.DashboardRequired))?.label;
          setDashboardReq(
            {
              label: filterDashboardReq,
              value: responseData?.DashboardRequired,
            }
          )

          const filterUserManagement = userManagementOption.find((item) => item.value === String(responseData?.UserManagementthroughPortal))?.label;
          setUserManagement(
            {
              label: filterUserManagement,
              value: responseData?.UserManagementthroughPortal,
            }
          )



          setOtherFirewall(firewallOpts.find((item) => item.value === String(responseData?.otherinformations?.FireWall)))
          // const filterOtherServiceProvider = ServiceProviders.find((item) => item.value === String(responseData?.Existingprovider)).label;
          setServiceProvider(ServiceProviders.find((item) => item.value == String(responseData?.otherinformations?.ExistingServiceProvider)))

          const concatenatedAddress = `${responseData?.installationAddresses?.Inst_BuildingNo || ''} ${responseData?.installationAddresses?.Inst_InstallationFloor || ''} ${defaultAreaInst?.AreaName || ''} ${cityAuthOption?.find((data) => data.value == (responseData.installationAddresses.Inst_City))?.label || ''} ${stateOpt?.find((data) => data.value == result?.Response?.Data?.installationAddresses.Inst_State)?.label || ''} ${'India'}`;
          // console.log(concatenatedAddress);
          fetchLatLong(concatenatedAddress);

          const filterOtherSelfpo = selfpoOpts.find((item) => item.value === String(responseData?.otherinformations?.CompanySelfPo)).label;
          setSelectSelfpo({
            label: filterOtherSelfpo,
            value: responseData?.CompanySelf,
          })


          return;


        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBussinessCAF();
  }, [CafId, cityAuthOption.length > 0, industrydropdetails]);




  // {/* *********** END ********* */ }

  // {/* ***********for getBank datA API ********* */ }

  useEffect(() => {
    const fetchGetBank = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          Action: "getBank",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          cafNo: CafId,
          oppid: "",
          safNo: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        // console.log("API Response bank:", result);
        setBankDropDetails(result.Response.Data);
        // console.log("Bank", result.Response);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGetBank();
  }, []);

  // {/* ***********for getCompany datA API ********* */ }
  useEffect(() => {
    const fetchGetCompany = async () => {
      const storedUsername = sessionStorage.getItem("userName");
      // Concatenate 'IN\\' in front of the stored username
      const modifiedUsername = "IN\\" + storedUsername;
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL_1;

        const requestData = {
          Action: "getCompany",
          Authkey: "AdgT6SnjAkeLqlkE4",
          companyId: "",
          password: sessionStorage.getItem("password"),
          userName: modifiedUsername,
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        // console.log("API Response:", result);
        setCustomerdropdetails(result.Response);
        // console.log("companyget", result.Response);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchGetCompany();
  }, []);


  useEffect(() => {
    const fetchGetProduct = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getProductlist",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          oppid: OppId,
          reason: "",
          siteId: "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("result.Response:", result.Response.Data);

        if (result.Response && Array.isArray(result.Response.Data)) {
          setProductdropdetails(result.Response.Data);
          // setSelectArea([]);
        } else {
          console.error(
            "product data structure not recognized:",
            result.Response
          );
          setProductdropdetails([]);
        }
        // if (result.Status == "Success") {
        //   const productType = result.Response.Data.map(
        //     (option) => ({
        //       label: option.ProductId,
        //       value: option.ProductCode,
        //     })
        //   );
        //   setProductdropdetails(productType);
        // }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchGetProduct();
  }, []);



  const fetchGetRelation = async (compID) => {
    const storedUsername = sessionStorage.getItem("userName");
    // Concatenate 'IN\\' in front of the stored username
    const modifiedUsername = "IN\\" + storedUsername;
    // console.log("compID", compID);
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL_1;

      const requestData = {
        Action: "getRelationship",
        Authkey: "AdgT6SnjAkeLqlkE4",
        CompanyId: compID,
        password: sessionStorage.getItem("password"),
        userName: modifiedUsername,
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      // console.log("API Response Relation:", result);
      setReldropdetails(result.Response);
      // console.log("relationget", result.Response);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  {
    /* *********** END ********* */
  }
  // STATE,CITY,AREA,SOCIETY API
  const fetchData = async () => {
    try {
      // First API request
      const url1 = process.env.REACT_APP_API_URL;
      const requestData1 = {
        Action: "getSpecState",
        Authkey: "AdgT6SnjAkeLqlkE4",
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response1 = await fetch(url1, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData1),
      });

      if (!response1.ok) {
        throw new Error("Network response was not ok for request 1");
      }

      const responseData1 = await response1.json();
      // console.log("responseData1", responseData1);
      setOptionState(responseData1.Response);
      const SelectedApiState = responseData1.Response.find(
        (option) => option.StateCode == apiStateCode
      );
      // console.log("SelectedApiCity", SelectedApiState);
      setSelectState({
        value: SelectedApiState.StateCode,
        label: SelectedApiState.StateName,
      });

      // Second API request
      const url2 = process.env.REACT_APP_API_URL;
      const requestData2 = {
        Action: "getcity",
        Authkey: "AdgT6SnjAkeLqlkE4",
        stateCode: apiStateCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response2 = await fetch(url2, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData2),
      });

      if (!response2.ok) {
        throw new Error("Network response was not ok for request 2");
      }

      const responseData2 = await response2.json();
      // console.log("responseData2", responseData2.Response.CityCode);
      setOptionCity(responseData2.Response);
      const SelectedApiCity = responseData2.Response.find(
        (option) => option.CityCode == apiCityCode
      );
      // console.log("SelectedApiCity", SelectedApiCity);
      setSelectCity({
        value: SelectedApiCity.CityCode,
        label: SelectedApiCity.CityName,
      });
      // setupdateCityCode(SelectedApiCity.CityCode)

      // console.log("apicitycode", result.Response.Data[0].billingAddressSAF.Bill_City)
      const apicity = responseData2.Response.find(
        (option) => option.CityCode === apiCityCode
      );
      // console.log("apicity", apicity);
      setSelectCity({ value: apicity.CityCode, label: apicity.CityName });

      const apicityName = apicity.CityName;
      // Third API request
      const url3 = process.env.REACT_APP_API_URL;
      const requestData3 = {
        Action: "getarea",
        Authkey: "AdgT6SnjAkeLqlkE4",
        cityCode: apiCityCode,
        cityName: apicityName,
        restrictedarea: true,
        stateCode: "",
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response3 = await fetch(url3, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData3),
      });

      if (!response3.ok) {
        throw new Error("Network response was not ok for request 3");
      }

      const responseData3 = await response3.json();
      // console.log("responseData3", responseData3.Response);
      setOptionArea(responseData3.Response);
      const SelectedApiArea = responseData3.Response.find(
        (option) => option.AreaCode == apiAreaCode
      );
      // console.log("SelectedApiArea", SelectedApiArea);
      if (SelectedApiArea != apiAreaCode) {
        // toast.warning(responseData3.statusText || "Area is not Mapped", {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      }
      setSelectArea({
        value: SelectedApiArea.AreaName,
        label: SelectedApiArea.AreaName,
      });
      const apiarea = responseData3.Response.find(
        (option) => option.AreaCode === apiAreaCode
      );
      setSelectArea({ value: apiarea.AreaCode, label: apiarea.AreaName });
      const url4 = process.env.REACT_APP_API_URL;
      const requestData4 = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: apiAreaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response4 = await fetch(url4, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData4),
      });

      if (!response4.ok) {
        throw new Error("Network response was not ok for request 4");
      }

      const responseData4 = await response4.json();
      // console.log("responseData4.Status", responseData4.Status);
      if (responseData4.Status === "Failure" && apiAreaCode !== "") {

      } else {
        setOptionSociety(responseData4.Response);
        const apiSociety = responseData4.Response.find(
          (option) => option.SocietyCode === apiSocietyCode
        );
        // console.log("apiSociety", apiSociety);
        setSelectSociety({
          value: apiSociety.SocietyCode,
          label: apiSociety.SocietyName,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchData();
  }, [apiStateCode, apiCityCode, apiAreaCode]);


  const handleSendPaymentLink = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody =
      {
        Action: "sendPaymentLinkToCustomer",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        cafSafNo: CafId,
        sendPaymentLink: "Yes"
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responsedata = await response.json();
      // console.log("responsedata", responsedata);
      if (responsedata.Response.StatusCode == 200) {
        toast.success(responsedata.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }

    } catch (error) {
      // Handle fetch error
      console.error("Error fetching data:", error);
    }
  }





  // ================ NK =================
  const [selectedSubSegment, setSelectedSubSegment] = useState("");
  const [selectedCommMode, setSelectedCommMode] = useState("");
  const [businessDays, setBusinessDays] = useState();
  const [montiorDays, setMonitorDays] = useState();
  const [billType, setBillType] = useState("");
  const [getSurveyTaskData, setSurveyTaskData] = useState([]);
  const [getSurveyApprovedFlag, setSurveyApprovedFlag] = useState(true);

  const handleSelectSubSegment = (selected) => {
    // console.log("User selected sub business segment:", selected);
    setSelectedSubSegment(selected);
  };

  const handleSelectCommMode = (selected) => {
    // console.log("User selected mode:", selected);
    setSelectedCommMode(selected);
  };

  const handleSelectBDays = (selected) => {
    // console.log("User selected business days:", selected);
    setBusinessDays(selected);
  };

  const handleMonitor = (selected) => {
    // console.log("User selected network monitoring days:", selected);
    setMonitorDays(selected);
  };

  const handleBillType = (selected) => {
    setBillType(selected);
  };


  useEffect(() => {
    const fetchData = async () => {
      const getSurveyTaskData = await api.getSurveyTask(OppId);
      const preSalesData = await api.getPreTask(OppId);

      // console.log(userlicencegrid);
      // console.log([getSurveyTaskData?.Response]);
      const allSurveyApproved = getSurveyTaskData?.Response?.Data?.every(approval => approval.Status === "Approved");
      allSurveyApproved !== undefined && setSurveyApprovedFlag(allSurveyApproved);
      [getSurveyTaskData?.Response].length > 0 && setSurveyTaskData([getSurveyTaskData?.Response])
      // preSalesData?.Response?.Data?.length > 0 && setPreSalesTask(preSalesData?.Response?.Data)
    };

    fetchData();
  }, []);
  // ************ Survey task End***********//

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectBroadbandCafPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Business CAF</span>
          {/* {!statusNoCaf && (
            <button
              type="download"
              className="btn text-dark  mx-auto cstm-handler"
            >
              <i className="fa-solid fa-download"></i> Download
            </button>
          )} */}
        </div>
      </div>
      {/* ************Header end************ */}

      {loading && (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={load} alt="loading...."></img>
          </div>
        </div>
      )}

      <div className="container-fluid form-container">
        {/* **************Customer Details toggle******************* */}
        <div
          className="contact-toggle"
          onClick={() => handleIconClick("form1")}
        >
          <span className="toggle-text">Customer Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form1" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form1"
          >
            {/* *********Customer Details form******** */}

            <form className="contact-form p-2">
              {CafId && (<div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="CAF"
                  name="CAF No"
                  value={CafId}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>

                <label htmlFor="floatingInput" className="lock mt-2">
                  CAF No.
                </label>
              </div>)}

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1 "
                  id="Companyname"
                  name="Companyname"
                  value={userdata.Companyname}
                  readOnly={true}
                  style={{ background: "transparent" }}
                  onChange={formInputData}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="lock mt-2">
                  Company Name
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="CustomerName"
                  name="ContactPerson"
                  value={userdata.ContactPerson}
                  onChange={formInputData}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Customer Name
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Gender*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="ssss"
                  name="gender"
                  value={genderOptions.find(
                    (option) => option.value == (gender || getCafDigiHome?.cafDetail?.Gender)
                  )}
                  onChange={handleGender}
                  options={genderOptions}
                  styles={style}
                  isSearchable={true}
                />
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="gstNo"
                  name="ProfessionofSubscriber"
                  value={userdata?.ProfessionofSubscriber || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Profession of Subscriber*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="date"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="DOBorDateofRegistration"
                  name="DOBorDateofRegistration"
                  value={yyyymmddFormat(userdata?.DOBorDateofRegistration) || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                  max={new Date().toISOString().split("T")[0]}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  DOB/Date of registration*
                </label>
              </div>

              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="ServiceId"
                  name="ServiceId"
                  value={userdata.ServiceId || "NA"}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="lock mt-2">
                  Service ID
                </label>
              </div>

              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="networkTechnology"
                  name="networkTechnology"
                  value={
                    customerDetails === "111260000"
                      ? "GPON"
                      : customerDetails === "111260001"
                        ? "NON-GPON"
                        : "NA"
                  }
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="networkTechnology" className="lock mt-2">
                  Network Technology
                </label>
              </div>




              <div className="">
                <label className="select-search-label mt-1">Company*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="sssss"
                  name="Company"
                  isDisabled={true}
                  // value={compOptions.find(
                  //   (option) => option.label === selectedCompany
                  // )}
                  value={selectedCompany}
                  onChange={"handleCompChange"}
                  // options={companyOptions}
                  styles={style}
                  placeholder="Select Company"
                  isSearchable={true} // Add this line if you want to enable searching
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">Group*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="ssss"
                  name="ffff"
                  isDisabled={true}
                  // value={groupOptions.find(
                  //   (option) => option.label === selectGroup
                  // )}
                  value={selectGroup}
                  // onChange={"handleSelectGroup"}
                  options={groupOptions}
                  // styles={compcustomStyles}
                  styles={style}
                  placeholder="Select Group"
                  isSearchable={true} // Add this line if you want to enable searching
                />
              </div>



              {/* {console.log("selectRelationship",selectRelationship)} */}
              <div className="">
                <label className="select-search-label mt-1">
                  Relationship*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Relationship"
                  // options={relationOptions}
                  value={selectRelationship}
                  // value={relationOptions.find((option) => option.label === selectRelationship)}
                  onChange={"handleSelectRelationship"}
                  styles={style}
                  isDisabled={true}
                />

              </div>




              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="networkTechnology"
                  name="networkTechnology"
                  value={"Business"}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="networkTechnology" className="lock mt-2">
                  Business Segement*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Sub Business Segment*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="segment"
                  styles={style}
                  value={selectedSubSegment}
                  onChange={handleSelectSubSegment}
                  options={segments}
                  isDisabled={disableFileds}
                />
              </div>


              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="networkTechnology"
                  name="Product"
                  value="India"
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="networkTechnology" className="lock mt-2">
                  Country
                </label>
              </div>



              <div
                className="form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="campaignName"
                  name="campaignName"
                  value={userdata.LastMileType}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingSelect" className="lock mt-2">
                  Last mile type
                </label>
              </div>

              <div
                className="form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="campaignName"
                  name="Product"
                  value={userdata.Product}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingSelect" className="lock mt-2">
                  Product
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Preffered Communication Mode
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  aria-label="Floating label select example"
                  name="PreferredCommMode"
                  value={selectedCommMode}
                  styles={style}
                  onChange={handleSelectCommMode}
                  options={CommModeOpts}
                  isDisabled={disableFileds}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Customer Working Hours*
                </label>
                <Select
                  name="customerWorkingHours"
                  className=" basic-single form-control form-control-sm p-1"
                  placeholder="Select Option"
                  options={custmrworkhrsoptions}
                  value={customerWorkingHours}
                  styles={style}
                  onChange={(selectedOption) =>
                    setCustomerWorkingHours(selectedOption)
                  }
                  aria-label="Floating label select example"
                  isDisabled={disableFileds}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Business Days*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  aria-label="Floating label select example"
                  name="BusinessDays"
                  value={businessDays}
                  styles={style}
                  onChange={handleSelectBDays}
                  options={BusDaysOpts}
                  isDisabled={disableFileds}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Network Monitoring Alerts*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  aria-label="Floating label select example"
                  name="NetworkMonitoringDays"
                  value={montiorDays}
                  styles={style}
                  onChange={handleMonitor}
                  options={MonitorDaysOpts}
                  isDisabled={disableFileds}
                />
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="gstNo"
                  name="gstNo"
                  value={userdata?.gstNo || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  GST Number
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="panNo"
                  name="panNo"
                  value={userdata?.panNo || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PAN Number
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="tanNo"
                  name="tanNo"
                  value={userdata?.tanNo || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  TAN Number
                </label>
              </div>

              <div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInputCustomer"
                    type="file"
                    accept="image/*"
                    capture="camera"
                    onChange={handleFileChangeCustomer}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="picture"
                    name="livePicture"
                    value={getCustomerPicture.fileNameWithExtension}
                    accept="image/*"
                    capture="camera"
                    style={{ background: "transparent" }}
                    onClick={OpenCameraCustomer}
                    readOnly
                  />
                  <i
                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                    onClick={OpenCameraCustomer}
                  ></i>
                  <label htmlFor="floatingInput" className="paperclip mt-2">
                    Customer Live Picture*
                  </label>

                </div>

                {/* ============ Validate Customer Live Picture ============= */}
                {userName2?.toLowerCase() == "manager1" && getCustomerImageStatus != null && (
                  <div>
                    {(getCustomerImageStatus?.status == "success") ? (
                      <div className="d-flex align-items-center text-sm text-gray-500">
                        <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                          Image validated Successfully
                        </div>
                        <span className="text-success" >
                          <i className="fas fa-check-circle"></i>
                        </span>
                      </div>
                    ) : (
                      <div className="" style={{ opacity: ".70", fontSize: "14px", fontWeight: "300" }}>
                        {/* Guidelines note */}
                        <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                          <div className="form-control-sm text-danger" style={{ fontSize: "12px", fontWeight: "400" }}>
                            Note: Please follow the guidelines and try again.
                          </div>
                        </div>
                        {/* White Background Check */}
                        <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                          <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                            White Background Check
                          </div>
                          <span className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "text-success" : "text-danger"}>
                            <i className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                          </span>
                        </div>

                        {/* Face Presence & Framing Check */}
                        <div className="d-flex align-items-center text-sm text-gray-500">
                          <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                            Face Presence & Framing Check
                          </div>
                          <span className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "text-success" : "text-danger"} >
                            <i className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}

              </div>

              <div className="select-search-label text-center">
                <div className="mt-3">OR</div>
              </div>

              <div className="container my-4">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 btn-sm rounded-pill"
                      onClick={SendLinkForCustomerLivePicture}
                      disabled={getCustomerPicture.fileNameWithExtension}
                    >
                      Send Link For Customer Live Picture
                    </button>
                  </div>
                </div>
              </div>
            </form>

          </div>
        )}



        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form11")}
        >
          <span className="toggle-text">Seller Self Identification</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {activeForm === "form11" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form11"
          >
            {/* *********Seller Self Identification ******** */}
            <form className="contact-form p-2">
              <div className="input-box form-floating mb-3">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="otp"
                  name="otp"
                  maxLength="6"
                  pattern="[0-9]{10}"
                  value={userdata.otp}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    const sellerOtp = userdata.otp || "";
                    if (
                      isDigit ||
                      allowedKeys.includes(e.key) ||
                      (sellerOtp.length < 6 && e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}

                />
                <label htmlFor="floatingInput" className="mt-2">
                  Self Authentication Code*
                </label>

                {isOtpVerified !== null && (
                  <span
                    className={`position-absolute ${isOtpVerified ? "text-success" : "text-danger"}`}
                    style={{ top: "50%", right: "10px", transform: "translateY(-50%)" }}
                  >
                    <i className={isOtpVerified ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                  </span>
                )}
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative" }}
              >
                <input
                  id="cameraFileInputSeller"
                  type="file"
                  accept="image/*"
                  capture="camera"
                  onChange={handleFileChangeSeller}
                  style={{ display: "none" }}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="picture"
                  value={getSellerPicture?.sellerFileNameWithExtension || getNewCafUpdateRequestBody?.sellerImage?.sellerFileNameWithExtension}
                  accept="image/*"
                  capture="camera"
                  style={{ background: "transparent" }}
                  onClick={OpenCameraSeller}
                  readOnly
                  disabled={!isOtpVerified}
                />
                <i
                  className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                  onClick={OpenCameraSeller}
                ></i>
                <label htmlFor="floatingInput" className="paperclip mt-2">
                  Seller Live Picture*
                </label>
              </div>



              <div className="container my-4">
                <div className="row justify-content-center">
                  {/* Send/Resend Code Button */}
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 rounded-pill"
                      onClick={handleSendOtp}
                      disabled={isOtpVerified || isTimerActive} // Disable the button during the timer
                    >
                      {isTimerActive ? `Resend Code in ${timer}s` : getCodeFlag ? "Resend Code" : "Send Code"}
                    </button>
                  </div>

                  {/* Submit Code Button */}
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 rounded-pill"
                      onClick={handleVerifyOtp}
                      disabled={!getCodeFlag || isOtpVerified}
                    >
                      Submit Code
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}



        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form12")}
        >
          <span className="toggle-text">KYC Verification</span>
          <span className="float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form12" && (
          <div
            className="container shadow mb-3 bg-body rounded mt-4"
            id="form12"
          >
            <form className="contact-form p-2">
              {/* {console.log("filteredDocumentOptions", filteredDocumentOptions)} */}

              <div className="">
                <label className="select-search-label mt-1">
                  Select Document Type*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="Salutation"
                  placeholder="Select Document Type"
                  styles={style}
                  value={selectDocument}
                  isSearchable={false}
                  onChange={handleSelectFile}
                  options={filteredDocumentOptions.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                  isDisabled={CafId || kycDocStatus === "Success"}
                />
              </div>

              <div className="input-box form-floating mt-3" style={{ position: "relative" }}>
                <input
                  id="kycdoc"
                  type="file"
                  accept="image/*,application/pdf"
                  capture="environment"
                  onChange={handleFileChangekycDocOCR}
                  style={{ display: "none" }}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="picture"
                  // value={getNewCafUpdateRequestBody?.customerKYCdocument?.customerKYCfileNameWithExtension}
                  value={selectKycDoc || getNewCafUpdateRequestBody.customerKYCdocument.customerKYCfileNameWithExtension}
                  style={{ background: "transparent" }}
                  onClick={() => document.getElementById("kycdoc").click()}
                  readOnly
                  disabled={CafId || kycDocStatus === "Success"}
                />
                {kycDocStatus == "Success" ? <i className="fa-solid fa-check fa-paper-icon fa-locator" style={{ color: "#77c171" }} ></i> :
                  <i
                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                    onClick={() => document.getElementById("kycdoc").click()}
                  ></i>
                }

                <label htmlFor="floatingInput" className="paperclip mt-2">
                  KYC Document*
                </label>
              </div>





            </form>
          </div>
        )}


        {/* *********Company Details******** */}

        <div
          className="other-toggle mt-3"
          onClick={() => handleIconClick("CompanyDetails")}
        >
          <span className="toggle-text">Company Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "CompanyDetails" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form3"
          >
            {/* *********Other Information form******** */}
            <form className=" contact-form p-2">

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="fullName"
                  name="Companyname"
                  value={userdata.Companyname || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Company Name
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Industry Type*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="IndustryType"
                  name="IndustryType"
                  styles={style}
                  value={selectIndustry}
                  // isDisabled={true}
                  onChange={handleIndustryChnage}
                  options={industrydropdetails.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}

                />
              </div>

              {/* {console.log("selectIndustry", selectIndustry)} */}
              <div className="">
                <label className="select-search-label mt-1">
                  Product Type*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="firmType"
                  name="firmType"
                  placeholder="Select Product"
                  styles={style}
                  value={selectedProductType}
                  onChange={handleProductTypeChange}
                  options={productdropdetails?.map((data) => ({
                    value: data.ProductCode,
                    label: data.ProductId,
                  }))}
                />
              </div>


              {/* {console.log("selectedFirmType", selectedFirmType)} */}



              <div className="">
                <label className="select-search-label mt-1">Firm Type*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="firmType"
                  placeholder="Select Option"
                  name="firmType"
                  styles={style}
                  value={selectedFirmType}
                  onChange={handleFirmTypeChange} // Define the change handler function
                  options={firmTypes.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                // isDisabled = {disableFileds}
                />
              </div>

            </form>
          </div>
        )}


        {/* *********Installation Addresss toggle******** */}

        <div
          className="installation-toggle mt-3"
          onClick={() => handleIconClick("InstallationAddress")}
        >
          <span className="toggle-text">Installation Address</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "InstallationAddress" && (

          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/* *********Installation Addresss form******** */}
            <form className=" contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="fullName"
                  name="Emailaddress"
                  value={userdata.Emailaddress || ""}
                  onChange={formInputData}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Email ID*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="Mobilephone"
                  value={userdata.Mobilephone || getCafDetails?.installationAddresses?.Inst_MobileNo || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Mobile Phone*
                </label>
              </div>
              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="lastName"
                  name="leadname"
                  value={userdata.leadname || getCafDetails?.installationAddresses?.Inst_LeadName || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Lead Name
                </label>
              </div>
              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  value={userdata.LeadId || getCafDetails?.installationAddresses?.Inst_LeadId || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Lead Id*
                </label>
              </div>



              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select State"
                  className=" form-control input-text form-control-sm mt-1"
                  id="State"
                  name="State"
                  value={userdata.State || selectInstState?.label}
                  readOnly={true}
                  style={{ background: "transparent" }}

                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  State*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select City"
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  // value={installationAddress.Inst_City.find from citydropdetails}
                  // value={
                  //   (
                  //     installcitydrop.find(
                  //       (option) =>
                  //         option.CityCode === installationAddress.Inst_City
                  //     ) || {}
                  //   ).CityName || ""
                  // }
                  value={userdata.City || selectInstCity?.label}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  City*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select Area"
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  // value={installationAddress.Inst_Area}
                  // value={areadetails}
                  value={userdata.Area || getAreaInst?.AreaName}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Area*
                </label>
              </div>



              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select Building"
                  className=" form-control input-text form-control-sm mt-1"
                  id="BuildingId"
                  name="BuildingId"
                  // value={userdata.BuildingId}
                  value={userdata?.Buildingname || getBuildingInst?.BuildingName}

                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Building Name*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  value={userdata.Building_BuildingStatus || getCafDetails?.installationAddresses?.Inst_BuildingStatus || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Building Status*
                </label>
              </div>





              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="BuildingNo"
                  value={userdata.BuildingNo || ""}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                />

                {/* <i className="fa-solid fa-lock" style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}></i> */}
                <label htmlFor="floatingInput">Building No./Plot No.*</label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="Floor"
                  // value={buildFloor}
                  value={userdata.Floor || ""}
                  // readOnly={true}
                  style={{ background: "transparent" }}
                  onChange={handleChange}
                />
                {/* <i className="fa-solid fa-lock text-secondary" style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}></i> */}
                <label htmlFor="floatingInput">Floor*</label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="PostalCode"
                  name="InstPin"
                  value={userdata.InstPin || ""}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="[0-9]{10}"
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);

                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (userdata.InstPin.length < 6 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                  style={{ background: "transparent" }}
                />

                <label htmlFor="floatingInput">Pin Code*</label>
              </div>


              <div className="">
                <label className="select-search-label mt-1">
                  VOIP Port Activation*
                </label>

                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="firstName"
                  styles={style}
                  value={selectVoip}
                  onChange={handleVoipPort}
                  options={voiOpts}
                  isDisabled={disableFileds}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">Bill Type*</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="billType"
                  name="billType"
                  value={billType}
                  onChange={handleBillType}
                  options={billtypeOpts}
                  styles={style}
                  isDisabled={disableFileds}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Category of Customer*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  name="customerCategory"
                  styles={style}
                  value={cusCategory}
                  onChange={handleCustomerCategoryChange}
                  options={customercatOpts}
                  isDisabled={disableFileds}
                />
              </div>


              {/* <div className="">
                <label className="select-search-label mt-1">
                  Does CPE Dispatch Details same as Installation address?
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  name="cpeDispatchSame"
                  styles={style}
                  value={cpeDispatchSame}
                  onChange={handleCpeDispatchSameChange}
                  options={CpeDispatchSameOpts}

                />
              </div> */}



            </form>
          </div>
        )}

        {/* ************* Billing Address ****************** */}

        <div
          className="billing-toggle mt-3"
          onClick={() => handleIconClick("BillingAddress")}
        >
          <span className="toggle-text">Billing Address</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "BillingAddress" && (
          <div className=" container-fluid">
            <div>
              <span>Same as Installation Address</span>
              <span className="" style={{ marginLeft: "40px" }}>
                <input
                  type="checkbox"
                  checked={useSameData}
                  onChange={handleCheckboxChange}
                />
              </span>
            </div>
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form"
            >
              {/* *********Billing Addresss form******** */}
              <form className="contact-form p-2">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="contactName"
                    name="contactName"
                    value={userdata.contactName || ""}
                    onChange={handleChange}
                    disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Contact Name*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="techSupportEmail"
                    name="techSupportEmail"
                    value={userdata.techSupportEmail || ""}
                    onChange={handleChange}
                    // disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Technical Support Email ID*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billmail"
                    name="billmail"
                    value={userdata.billmail || ""}
                    onChange={handleChange}
                    disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Billing Email ID*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billPhone"
                    name="billPhone"
                    value={userdata.billPhone || ""}
                    onChange={handleChange}
                    disabled={disableFileds}
                    maxLength="10"
                    pattern="[0-9]{10}"
                    // onKeyDown={(e) => {
                    //   const allowedKeys = [
                    //     "Backspace",
                    //     "Delete",
                    //     "ArrowLeft",
                    //     "ArrowRight",
                    //     "Tab",
                    //   ];
                    //   const isDigit = /\d/.test(e.key);
                    //   if (
                    //     (isDigit || allowedKeys.includes(e.key)) &&
                    //     (userdata.billPhone.length < 10 || e.key === "Backspace")
                    //   ) {
                    //     return true;
                    //   } else {
                    //     e.preventDefault();
                    //   }
                    // }}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Phone No.*
                  </label>
                </div>

                <div
                  className="input-box form-floating "
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="BillNationality"
                    name="BillNationality"
                    value={userdata.BillNationality || "Indian"}
                    onChange={handleChange}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Nationality
                  </label>
                </div>



                {/* <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select State"
                    className=" form-control input-text form-control-sm mt-1"
                    id="State"
                    name="billedState"
                    value={userdata.billedState || selectBillState?.label}
                    readOnly={true}
                    style={{ background: "transparent" }}

                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    State*
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select City"
                    className=" form-control input-text form-control-sm mt-1"
                    id="billCity"
                    name="billCity"
                    value={userdata.billCity || selectBillCity?.label}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    City*
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select Area"
                    className=" form-control input-text form-control-sm mt-1"
                    id="billArea"
                    name="billArea"
                    value={userdata.billArea || getAreaBill?.AreaName}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    Area*
                  </label>
                </div>

                <div
                  className="input-box form-floating "
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select Building"
                    className=" form-control input-text form-control-sm mt-1"
                    id="billBuildingId"
                    name="billBuildingId"
                    // value={userdata.billBuildingId || getCafDetails?.billingAddress?.Bill_BuildingName}
                    value={userdata?.BillBuildingname || getBuildingInst?.BuildingName}

                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    Building Name*
                  </label>
                </div> */}


                <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustrySeg"
                    placeholder="Select State"
                    isSearchable={false}
                    styles={style}
                    value={selectBillState}
                    onChange={handleSelectBillState}
                    options={optionStateOne.map((data) => ({
                      value: data.code,
                      label: data.name,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">City*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="City"
                    placeholder="Select City"
                    isSearchable
                    styles={style}
                    // value={cityType.find(
                    //   (city) => city.CityCode === selectCity.value
                    // )}
                    value={selectBillCity}
                    onChange={handleSelectBillCity}
                    options={cityType.map((data) => ({
                      value: data.CityCode,
                      label: data.CityName,
                    }))}
                  />
                </div>

                <div className="search-area" style={{ position: "relative" }}>
                  <label className="select-search-label mt-1">Area*</label>
                  <Select
                    options={areaBillList.map((area) => ({
                      value: area.AreaCode,
                      label: `${area.AreaName} (${area.AreaCode})`,
                    }))}
                    className="form-control form-control-sm p-1 custom-select"
                    placeholder="Search Area"
                    isSearchable
                    styles={style}
                    value={selectBillArea || selectArea}
                    onChange={handleSelectBillArea}
                  />
                  <i
                    className="fas fa-search text-secondary"
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "63%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>


                <div className="search-area" style={{ position: "relative" }}>
                  <label className="select-search-label mt-1">Building Name*</label>
                  <Select
                    options={billBuildingList.map((building) => ({
                      value: building.BuildingCode,
                      label: `${building.BuildingName} (${building.BuildingCode})`,
                    }))}
                    className="form-control form-control-sm p-1 custom-select"
                    placeholder="Search Area"
                    isSearchable
                    styles={style}
                    value={selectBillBuilding || selectBuilding}
                    onChange={(selectedOption) =>
                      setSelectBillBuilding(selectedOption)
                    }
                  />
                  <i
                    className="fas fa-search text-secondary"
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "63%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billBuildingNo"
                    name="billBuildingNo"
                    value={userdata.billBuildingNo || ""}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                  />

                  {/* <i className="fa-solid fa-lock" style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}></i> */}
                  <label htmlFor="floatingInput">Building No./Plot No.*</label>
                </div>



                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billFloor"
                    name="billFloor"
                    value={userdata.billFloor || ""}
                    disabled={disableFileds}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Floor*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="billPin"
                    value={userdata.billPin || ""}
                    disabled={disableFileds}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                    maxLength="6"
                    pattern="[0-9]{10}"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key))
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />

                  <label htmlFor="floatingInput" className="mt-2">
                    Pin Code*
                  </label>
                </div>
              </form>
            </div>
          </div>

        )}


        {/* *********CPE Dispatch Details toggle******** */}
        {/* {console.log("productsegment", productsegment)} */}
        {(productsegment == "Managed Wi-Fi Business-S" || productsegment == "Managed Wi-Fi Business") &&
          <div
            className="paymentdetails-toggle mt-3"
            onClick={() => handleIconClick("form6")}
          >
            <span className="toggle-text">CPE Dispatch Details:</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>}

        {activeForm === "form6" && (
          <div className=" container-fluid">
            <div>
              <span>Does CPE Dispatch Details same as Installation address?</span>
              <span className="" style={{ marginLeft: "40px" }}>
                <input
                  type="checkbox"
                  checked={useSameDataForCPE}
                  onChange={handleCheckboxChangeForCPE}
                />
              </span>
            </div>

            {/* {console.log("useSameDataForCPE",useSameDataForCPE)} */}

            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form6"
            >
              {/* *********CPE Dispatch Details******** */}
              <form className="contact-form p-2">

                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="CpeContactPersonName"
                    name="CpeContactPersonName"
                    value={userdata.CpeContactPersonName}
                    onChange={handleChange}
                  // readOnly
                  />
                  <label htmlFor="floatingInput">CPE Contact Person Name*</label>
                </div>


                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="CpeContactPersonPhone"
                    name="CpeContactPersonPhone"
                    value={userdata.CpeContactPersonPhone}
                    onChange={handleChange}
                  // readOnly
                  />
                  <label htmlFor="floatingInput">CPE Contact Person Phone No.*</label>
                </div>

                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="CpeDispatchAddress"
                    name="CpeDispatchAddress"
                    value={userdata.CpeDispatchAddress}
                    onChange={handleChange}
                  // readOnly
                  />
                  <label htmlFor="floatingInput">CPE Dispatch Address*</label>
                </div>

                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="RemarkCPE"
                    name="RemarkCPE"
                    value={userdata.RemarkCPE}
                    onChange={handleChange}
                  // readOnly
                  />
                  <label htmlFor="floatingInput">CPE Remarks*</label>
                </div>
              </form>
            </div>
          </div>
        )}


        {/* *********MS Wi-Fi details  toggle******** */}
        {(productsegment == "Managed Wi-Fi Business-S" || productsegment == "Managed Wi-Fi Business") &&
          <div
            className="paymentdetails-toggle mt-3"
            onClick={() => handleIconClick("form5")}
          >
            <span className="toggle-text">MS Wi-Fi details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>}


        {activeForm === "form5" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form5">
            <form className="contact-form p-2">

              <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="ssIdNomenclatureOne"
                  name="ssIdNomenclatureOne"
                  value={userdata.ssIdNomenclatureOne}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput">SSID 1 Nomenclature*</label>
              </div>


              <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="ssIdNomenclatureTwo"
                  name="ssIdNomenclatureTwo"
                  value={userdata.ssIdNomenclatureTwo}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput">SSID 2 Nomenclature*</label>
              </div>

              <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="reqBandwidth"
                  name="reqBandwidth"
                  value={userdata.reqBandwidth}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput">Required Bandwidth (in Mbps)</label>
              </div>

              <div className="input-box form-floating" style={{ position: "relative", paddingTop: "4px" }}>
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="specialReq"
                  name="specialReq"
                  value={userdata.specialReq}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput">Special Request</label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  User Management through Portal*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  name="userManagement"
                  styles={style}
                  value={userManagement}
                  onChange={handleUserManagementChange}
                  options={userManagementOption}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Report required on UMP*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  name="reportReq"
                  styles={style}
                  value={reportReq}
                  onChange={handleReportReqChange}
                  options={reportReqOpts}

                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Dashboard Required*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  name="dashboardReq"
                  styles={style}
                  value={dashboardReq}
                  onChange={handleDashboardReqChange}
                  options={DashboardReqOpts}

                />
              </div>


              <div className="mt-3 bg-body rounded mt-4 p-3">
                {/* Table Header with Plus Icon on Right */}
                <div className="d-flex w-100 align-items-center mb-2">
                  <h6 className="mb-0 text-nowrap flex-grow-1">User licence grid:</h6>
                  {selectIndustry.label != "PG" &&
                    <FaPlus
                      className="text-success"
                      type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-whatever="@mdo"
                      style={{ cursor: "pointer", fontSize: "1.0rem", marginRight: "5px" }}
                    // onClick={addRow}
                    />}
                </div>

                {/* Bootstrap Table */}
                <div className="table-responsive small">
                  <table className="table table-border table-sm table-striped small">
                    <thead className="table-secondary text-center small">
                      <tr>
                        <th>ID</th>
                        <th>User Type</th>
                        <th>No. of licences required </th>
                        <th>Speed Per User</th>
                        <th>Data Volume(in GB)</th>
                        <th>Plan Vilidity/Data Volume </th>
                        <th>Device per user</th>
                        <th>Login Machanism</th>
                        <th>Actions</th>
                      </tr>

                    </thead>
                    <tbody className="text-center small">
                      {getUserlicencegridData?.length > 0 ? getUserlicencegridData?.map((row, index) => (
                        <tr key={index} className="py-1">
                          <td>{index + 1}</td>
                          <td>{getUserTypeOptions.find((data) => data.value == row?.UserType)?.label}</td>
                          <td>{row.NoofUserLicensesrequired}</td>
                          <td>{getSpeedPerUserOptions?.find((data) => data.value == row?.SpeedPerUser)?.label}</td>
                          <td>{row?.DataVolumeinGB}</td>
                          <td>{row.DevicesperUser}</td>
                          <td>{row.v}</td>
                          <td>{row.col6}</td>
                          <td>
                            <FaEdit
                              className="text-success mx-2"
                              style={{ cursor: "pointer", fontSize: "0.9rem" }}
                            // onClick={() => update(row.id)}
                            />
                            {/* <FaTrash
                                  className="text-danger"
                                  style={{ cursor: "pointer", fontSize: "0.9rem" }}
                                  onClick={() => deleteRow(row.id)}
                                /> */}
                          </td>
                        </tr>
                      )) :
                        <tr>
                          <td colSpan="10" className="text-center text-muted">
                            No data found
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>



              <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">New User Licence Grid</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <form>
                        <div class="mb-2">
                          <label for="recipient-name" class="col-form-label">User Type*</label>
                          <Select
                            className="basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            placeholder="Select Option"
                            name="dashboardReq"
                            styles={style}
                            value={userType}
                            onChange={handleUserType}
                            options={userTypeOption.map((data) => ({
                              value: data.value,
                              label: data.label,
                            }))}
                          />
                        </div>
                        <div class="mb-2">
                          <label for="recipient-name" class="col-form-label">No. of User Licences Required*</label>
                          <input type="text"
                            class="form-control"
                            id="noUserLicences"
                            name="noUserLicences"
                            value={userdata.noUserLicences}
                            onChange={handleChange}
                          />
                        </div>
                        <div class="mb-2">
                          <label for="recipient-name" class="col-form-label">Speed Per User*</label>
                          <Select
                            className="basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            placeholder="Select Option"
                            name="dashboardReq"
                            styles={style}
                            value={speedPerUser}
                            onChange={handleSpeedPerUser}
                            options={speedPerUserOption.map((data) => ({
                              value: data.value,
                              label: data.label,
                            }))}
                          />
                        </div>
                        <div class="mb-2">
                          <label for="recipient-name" class="col-form-label">Plan Validity/Data Volume Criteria*</label>
                          <Select
                            className="basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            placeholder="Select Option"
                            name="dashboardReq"
                            styles={style}
                            value={planValidity}
                            onChange={handlePlanValidity}
                            options={planValidityOption.map((data) => ({
                              value: data.value,
                              label: data.label,
                            }))}
                          />
                        </div>

                        <div class="mb-2">
                          <label for="recipient-name" class="col-form-label">Data Valume (in Gb)*</label>
                          <input type="text"
                            class="form-control"
                            id="dataValume"
                            name="dataValume"
                            value={userdata.dataValume}
                            onChange={handleChange}
                          />
                        </div>

                        <div class="mb-2">
                          <label for="recipient-name" class="col-form-label">Devices per User*</label>
                          <input type="text"
                            class="form-control"
                            id="devicesPerUser"
                            name="devicesPerUser"
                            value={userdata.devicesPerUser}
                            onChange={handleChange}
                          />
                        </div>

                        <div class="mb-2">
                          <label for="recipient-name" class="col-form-label">Login Mechanism*</label>
                          <Select
                            className="basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            placeholder="Select Option"
                            name="dashboardReq"
                            styles={style}
                            value={loginMechanism}
                            onChange={handleLoginMechanism}
                            options={loginMechanismOption.map((data) => ({
                              value: data.value,
                              label: data.label,
                            }))}
                          />
                        </div>

                      </form>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button type="button" class="btn btn-primary" onClick={handleUserLicenceGrid}>Submit</button>
                    </div>
                  </div>
                </div>
              </div>

            </form>

          </div>
        )}


        {/* *********Authorised Signatory  toggle******** */}

        <div
          className="authSign-toggle mt-3"
          onClick={() => handleIconClick("AuthorisedSignatoryDetails")}
        >
          <span className="toggle-text">Authorised Signatory Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "AuthorisedSignatoryDetails" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form"
          >
            {/* *********Authorised Signatory form******** */}
            <form className="contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="authorName"
                  name="authorName"
                  value={userdata.authorName || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Name*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="authorFather"
                  name="authorFather"
                  value={userdata.authorFather || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Father's/Husband's Name*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="authResidentialAddress"
                  name="authResidentialAddress"
                  value={userdata.authResidentialAddress || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Residential Address*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="autherMobile"
                  value={userdata.autherMobile || ""}
                  onChange={handleChange}
                  maxLength="10"
                  pattern="[0-9]{10}"
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const mobileNumber = userdata.autherMobile || "";
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (mobileNumber.length < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Mobile No*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="mail"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="autherEmail"
                  value={userdata.autherEmail || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Email ID*
                </label>
              </div>


              <div className="">
                <label className="select-search-label mt-1">Country</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select Country"
                  styles={style}
                  isSearchable={false}
                  value={selectAuthCountry || "Indian"}
                  onChange={handleSelectAuthCountry}
                  options={optionCountry.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">State</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select State"
                  isSearchable={false}
                  styles={style}
                  value={selectAuthState}
                  onChange={handleSelectAuthState}
                  options={optionAuthState.map((data) => ({
                    value: data.code,
                    label: data.name,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">City</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="City"
                  placeholder="Select City"
                  isSearchable
                  styles={style}
                  value={selectAuthCity}
                  onChange={handleSelectAuthCity}
                  options={cityAuthOption.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>



              <div className="">
                <label className="select-search-label mt-1">Nationality</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="Natinality"
                  placeholder="Select Natinality"
                  styles={style}
                  isSearchable={false}
                  value={selectAuthNatinality}
                  onChange={handleSelectAuthNatinality}
                  options={optionNatinality.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>



              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="autherPinCode"
                  name="autherPinCode"
                  value={userdata.autherPinCode || ""}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="[0-9]{10}"
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                // onKeyDown={(e) => {
                //   const allowedKeys = [
                //     "Backspace",
                //     "Delete",
                //     "ArrowLeft",
                //     "ArrowRight",
                //     "Tab",
                //   ];
                //   const pinCode = userdata.autherPinCode || "";
                //   const isDigit = /\d/.test(e.key);
                //   if (
                //     (isDigit || allowedKeys.includes(e.key)) &&
                //     (pinCode.length < 6 || e.key === "Backspace")
                //   ) {
                //     return true;
                //   } else {
                //     e.preventDefault();
                //   }
                // }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Pincode*
                </label>
              </div>
            </form>
          </div>
        )}



        {/* *********Other Information toggle******** */}

        <div
          className="other-toggle mt-3"
          onClick={() => handleIconClick("form2")}
        >
          <span className="toggle-text">Other Information</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form2" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form2"
          >
            {/* *********Other Information form******** */}
            <form className=" contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="fullName"
                  name="UpTimesla"
                  value={userdata.UpTimesla}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                  disabled={disableFileds}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Uptime SLA Commited (%)*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="date"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="PoLock"
                  name="PoLock"
                  value={yyyymmddFormat(userdata.PoLock)}
                  // min={getCurrentDate()}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PO Lock in Duration*
                </label>
              </div>


              <div className="input-box form-floating">
                <input
                  type="date"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="PoNext"
                  name="PoNext"
                  value={yyyymmddFormat(userdata.PoNext)}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PO Next Renewal Date*
                </label>
              </div>
              <div className="">
                <label htmlFor="floatingSelect" className="select-search-label mt-1">
                  Existing Service Provider*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="existingServiceProvider"
                  name="existingServiceProvider"
                  styles={style}
                  value={serviceProvider}
                  onChange={handleServiceProviderChange}
                  options={ServiceProviders}
                // isDisabled={disableFileds}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Firewall (if Any)*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="firewall"
                  styles={style}
                  value={otherFirewall}
                  onChange={handleFirewall}
                  options={firewallOpts}
                // isDisabled={disableFileds}
                />
              </div>

              {otherFirewall && otherFirewall.value === "1" && (
                <div className="input-box form-floating">
                  <input
                    type="date"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="FirewallSetToExpire"
                    name="FirewallSetToExpire"
                    value={yyyymmddFormat(userdata.FirewallSetToExpire)}
                    onChange={handleChange}
                    disabled={disableFileds}
                    style={{ background: 'transparent' }}


                  />
                  <label htmlFor="paymentDate" className="mt-2">
                    Firewall AMC Expiry Date
                  </label>
                </div>
              )}

              <div className="">
                <label className="select-search-label mt-1">
                  Company Self PO (ERP)*
                </label>
                <Select
                  className="basic-single form-control form-control-sm "
                  classNamePrefix="select"
                  id="floatingSelect"
                  placeholder="Select Option"
                  aria-label="Floating label select example"
                  name="selfpo"
                  value={selectSelfpo}
                  onChange={handleSelfPo}
                  styles={style}
                  options={selfpoOpts}
                  isDisabled={disableFileds}
                />
              </div>
            </form>
          </div>
        )}





        {/* *********Payment Details  toggle******** */}

        <div
          className="paymentdetails-toggle mt-3"
          onClick={() => handleIconClick("form4")}
        >
          <span className="toggle-text">Payment Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form4" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/* *********Payment Details  Form******** */}
            <form className="contact-form p-2">

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedRCAmount"
                  value={(CafId ? getCafDetails?.payments?.ApprovedRCAmountIncTax : userdata.ApprovedRCAmount) || "NA"}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                      //   &&  (basePriceDis < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Approved RC Amount(Inc Tax)
                </label>
              </div>

              {/* {console.log("getCafDigiHome?.paymentDetail?.ApprovedRCAmount", getCafDigiHome?.paymentDetail?.ApprovedRCAmount)} */}

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqRCAmount"
                  value={userdata.UpfrontReqRCAmount || (CafId ? getCafDetails.payments?.UpfrontRequestedRCAmountIncTax : "")}
                  onChange={handleChange}
                  // disabled={CafId}
                  disabled={getCafDetails?.payments?.IsPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2 upfont-textStyle">
                  Upfront Requested RC Amount(Inc Tax)
                </label>
              </div>

              {/* {console.log("userdata.UpfrontReqRCAmount", userdata.UpfrontReqRCAmount)} */}



              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedRCAmount"
                  value={CafId ? getCafDetails?.payments?.UpfrontApprovedRCAmount : ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Approved RC Amount(Inc Tax)
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedOTCAmount"
                  value={(CafId ? getCafDetails?.payments?.ApprovedOTCAmountIncTax : userdata.ApprovedOTCAmount) || ""}
                  // onChange={handleOTCChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Approved OTC Amount(Inc Tax)
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqOTCAmount"
                  value={userdata.UpfrontReqOTCAmount || getCafDetails?.payments?.UpfrontRequestedOTCAmountIncTax || ""}
                  onChange={handleChange}
                  disabled={getCafDetails?.payments?.IsPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Requested OTC Amount(Inc Tax)
                </label>
              </div>


              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedOTCAmount"
                  value={CafId ? getCafDetails?.payments?.UpfrontApprovedOTCAmount : ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Approved OTC Amount(Inc Tax)
                </label>
              </div>

              {/* ====== SD Amount ======== */}
              {["Managed Wi-Fi Business", "Managed Wi-Fi Business-S"].includes(productsegment) && (
                <div>
                  <div className="input-box form-floating ">
                    <input
                      type="tel"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="ApprovedSDAmount"
                      value={userdata.ApprovedSDAmount || getCafDetails?.payments?.ApprovedSDAmount || ""}
                      onChange={handleChange}
                      disabled={true}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput cstm-otc" className="mt-2">
                      Approved SD Amount(Inc Tax)
                    </label>
                  </div>

                  <div className="input-box form-floating ">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="UpfrontReqSDAmount"
                      value={userdata.UpfrontReqSDAmount || getCafDetails?.payments?.UpfrontRequestedSDAmount || ""}
                      onChange={handleChange}
                      disabled={isPaymentLinkSendToCustomer == "Yes"}
                      style={{ background: "transparent" }}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (
                          (isDigit || allowedKeys.includes(e.key))
                        ) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput cstm-otc" className="mt-2">
                      Upfront Requested SD Amount(Inc Tax)
                    </label>
                  </div>

                  <div className="input-box form-floating ">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="UpfrontApprovedOTCAmount"
                      value={userdata.UpfrontApprovedSDAmount || getCafDetails?.payments?.UpfrontApprovedSDAmount || ""}
                      onChange={handleChange}
                      disabled={true}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput cstm-otc" className="mt-2">
                      Upfront Approved SD Amount(Inc Tax)
                    </label>
                  </div>
                </div>
              )}

              {CafId &&
                <>
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="lastName"
                      name="lastName"
                      value={(CafId ? getCafDetails.payments?.TotalAmount : userdata.totalAmount) || ""}
                      onChange={handleTotalAmt}
                      disabled={true}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Total Amount*
                    </label>
                  </div>

                  {/* <div
                    className="input-box form-floating"
                    style={{ position: "relative", paddingTop: "4px" }}
                  >
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="fullName"
                      name="fullName"
                      value={paymentDetails.PaymentId || getCafDetails?.payments.PaymentId}
                      readOnly={true}
                      style={{ background: "transparent" }}
                    />
                    <i
                      className="fa-solid fa-lock text-secondary"
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                    <label htmlFor="floatingInput" className="lock">
                      Payment ID
                    </label>
                  </div> */}

                  <div className="">
                    <label className="select-search-label mt-1">
                      Payment Mode*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="Salutation"
                      placeholder="Select Option"
                      styles={style}
                      value={selectPaymentMode}
                      isSearchable={false}
                      onChange={handlePaymentMode}
                      options={optionPayment.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                      isDisabled={paymentStatus.label == "Payment Received" || getCafDetails.payments?.TotalAmount == "0.0000"}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">Pay-In-Slip*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="payslip"
                      name="payslipnethod"
                      styles={style}
                      value={filteredPayslipOpts.find(
                        (option) => option.value == (selectedPaySlipOption || getCafDetails?.payments.PayInSlip)
                      )}
                      onChange={handlePaySlipChange}
                      options={filteredPayslipOpts}
                      isDisabled={paymentStatus.label == "Payment Received" || getCafDetails.payments?.TotalAmount == "0.0000"}
                    />
                  </div>

                  {/* {console.log("selectedPaySlipOption",selectedPaySlipOption)} */}

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={userdata.paymentDoaStatus || getCafDetails.paymentDOAstatus || "NA"}
                      // onChange={handleGstNumber}
                      disabled={disableFileds}
                      maxLength="15"
                      readOnly
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">Upfront Approval Status</label>
                  </div>

                  {/* <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={Securitydep || getCafDetails?.payments.SecurityDeposit}
                      onChange={handleSecurityDepo}
                      disabled={disableFileds}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Security Deposit*
                    </label>
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">
                      Security Deposit Type*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="securityType"
                      name="securityType"
                      styles={style}
                      value={SecuritypeOpts.find(
                        (option) => option.value === (Securitydeptype || getCafDetails?.payments.SecurityDepositType)
                      )}
                      onChange={handleSecType}
                      options={SecuritypeOpts}
                      isDisabled={disableFileds}
                    />
                  </div> */}

                  {/* new Paydetail nk */}
                  {/* {selectedPaySlipOption === "4" || selectedPaySlipOption === "5" || selectedPaySlipOption === "7" || selectedPaySlipOption === "8" || selectedPaySlipOption === "11" || selectedPaySlipOption === "12" || selectedPaySlipOption === "13" ? (
                  <div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="transactionReferenceID"
                        name="transactionReferenceID"
                        value={transactionrefid || getCafDetails?.payments.TransactionReferenceId}
                        onChange={handleTransactionRefID}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="transactionReferenceID" className="mt-2">
                        Transaction Reference ID*
                      </label>
                    </div>


                    <div className="input-box form-floating">
                      <input
                        // type="date"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        value={getCafDetails?.payments.PaymentDate}
                        // onChange={handleCardPaymentDate}
                        // min={getCurrentDate()}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="paymentDate" className="mt-2">
                        Payment Date*
                      </label>
                    </div>
                  </div>) : (
                  <div>
                    <div className="">
                      <select
                        className="form-select form-control input-text form-control-sm"
                        id="firstName"
                        name="firstName"
                        value={selectBank}
                        onChange={handleBankChange}
                      >
                        <option value="">Select Bank</option>

                        {BankDropDetails.map((bank, index) => (
                          <option key={index} value={bank.Bankname}>
                            {bank.Bankname}
                          </option>
                        ))
                        }

                      </select>
                      <label className="select-search-label mt-1">
                        Bank Name*
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="firstName"
                        name="firstName"
                        placeholder="Select Bank Name"
                        styles={style}
                        value={bankOpts.find((option) => option.label === selectBank?.label)}
                        onChange={handleBankChange}
                        options={bankOpts}
                        isDisabled={disableFileds}
                      />
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        value={branchName}
                        onChange={handleBranchChange}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Branch*
                      </label>
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id="firstName"
                        name="firstName"
                        value={chequeDDNo}
                        onChange={handleChequeNo}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Cheque/DD no.*
                      </label>
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="date"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id="firstName"
                        name="firstName"
                        value={chequeDate}
                        onChange={handleChequeDate}
                        disabled={disableFileds}
                        // min={getCurrentDate()}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Cheque/DD Date.*
                      </label>
                    </div>
                  </div>
                )} */}

                  {/* {console.log(selectedPaySlipOption)} */}
                  {/* new Paydetail nk end*/}
                  {selectedPaySlipOption === "4" || selectedPaySlipOption === "5" || selectedPaySlipOption === "7" ||
                    selectedPaySlipOption === "8" || selectedPaySlipOption === "11" || selectedPaySlipOption === "12" ||
                    selectedPaySlipOption === "13" ? (
                    /* Render NEFT or RTGS section */
                    <div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="transactionReferenceID"
                          name="transactionReferenceID"
                          value={transactionrefid || getCafDetails?.payments.TransactionReferenceId || ""}
                          onChange={handleTransactionRefID}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="transactionReferenceID" className="mt-2">
                          Transaction Reference ID*
                        </label>
                      </div>


                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id=""
                          name="paymentDate"
                          value={userdata.paymentDate || yyyymmddFormat(getCafDetails?.payments.PaymentDate)}
                          onChange={handleChange}
                          // min={getCurrentDate()}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="paymentDate" className="mt-2">
                          Payment Date*
                        </label>
                      </div>
                    </div>
                  ) : selectedPaySlipOption === "7" || selectedPaySlipOption === "8" ? (
                    /* Render Credit Card, Debit Card, Ezetap section */
                    <div>

                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder=""
                          className=" form-control input-text form-control-sm"
                          id=""
                          name=""
                          // value={selectedDatePayment}
                          // onChange={handleCardPaymentDate}
                          // min={getCurrentDate()}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="paymentDate">Payment Date*</label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="approvalCode"
                          name="approvalCode"
                          value={approvalCode}
                          onChange={handleApprovalCode}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="approvalCode" className="mt-2">
                          Approval Code*
                        </label>
                      </div>
                      {selectedPaySlipOption === "7" && (
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder=""
                            className="form-control input-text form-control-sm mt-1"
                            id="creditCardLast4Digits"
                            name="creditCardLast4Digits"
                            value={creditDetails}
                            onChange={handleCreditdetails}
                            disabled={disableFileds}
                            style={{ background: "transparent" }}
                          />
                          <label htmlFor="creditCardLast4Digits" className="mt-2">
                            Credit Card Last 4 Digit No.*
                          </label>
                        </div>
                      )}
                      {selectedPaySlipOption === "8" && (
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder=""
                            className="form-control input-text form-control-sm mt-1"
                            id="creditCardLast4Digits"
                            name="creditCardLast4Digits"
                            // value={debitDetails}
                            // onChange={handleDebditdetails}
                            disabled={disableFileds}
                            style={{ background: "transparent" }}
                          />
                          <label htmlFor="creditCardLast4Digits" className="mt-2">
                            Debit Card Last 4 Digit No.*
                          </label>
                        </div>
                      )}
                    </div>
                  ) : selectedPaySlipOption === "1" || selectedPaySlipOption === "2" || selectedPaySlipOption === "12" ? (
                    /* Render Cheque, DD, Ezetap Cheque section */
                    <div>
                      {/* <div className="">
                        <select
                          className="form-select form-control input-text form-control-sm"
                          id="firstName"
                          name="firstName"
                          value={selectBank}
                          onChange={handleBankChange}
                        >
                          <option value="">Select Bank</option>

                          {BankDropDetails.map((bank, index) => (
                            <option key={index} value={bank.Bankname}>
                              {bank.Bankname}
                            </option>
                          ))
                          }

                        </select>
                        <label className="select-search-label mt-1">
                          Bank Name*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          id="firstName"
                          name="firstName"
                          placeholder="Select Bank Name"
                          styles={style}
                          value={bankOpts.find((option) => option.label === selectBank?.label)}
                          onChange={handleBankChange}
                          options={bankOpts}
                          isDisabled={disableFileds}
                        />
                      </div> */}

                      <div>
                        <div className="">
                          <label className="select-search-label mt-1">
                            Bank Name*
                          </label>
                          <Select
                            className=" basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            id="firstName"
                            name="BankName"
                            placeholder="Select Bank Name"
                            styles={style}
                            value={bankOpts.find(
                              (option) => option.value == (selectBank?.value || (bankOpts.find((option) => option?.label == getCafDetails?.payments?.BankName))?.value)
                            )} // Set the value based on your state
                            onChange={handleBankChange} // Define the change handler function
                            options={bankOpts}
                            isDisabled={disableFileds}
                          />
                        </div>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id=""
                          name=""
                          value={branchName || getCafDetails?.payments?.Branch || ""}
                          onChange={handleBranchChange}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Branch*
                        </label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id="firstName"
                          name="chequeDDNo"
                          value={chequeDDNo || getCafDetails?.payments?.ChequeDDNo || ""}
                          onChange={handleChequeNo}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Cheque/DD no.*
                        </label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id="firstName"
                          name="firstName"
                          value={chequeDate || yyyymmddFormat(getCafDetails?.payments?.ChequeDDDate) || ""}
                          onChange={handleChequeDate}
                          disabled={disableFileds}
                          // min={getCurrentDate()}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Cheque/DD Date.*
                        </label>
                      </div>
                    </div>
                  ) : null}



                  <div className="">
                    <label className="select-search-label mt-1">
                      Payment Status*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      id="firstName"
                      name="firstName"
                      placeholder="Select Payment Status"
                      // value={PaymentOpts.find(
                      //   (option) => option.value === (paymentStatus || getCafDigiHome?.paymentDetail?.PaymentStatus || "NA")
                      // )}
                      value={paymentStatus}
                      styles={style}
                      onChange={handlePaymentStatus}
                      options={PaymentOpts.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                      isDisabled={true}
                    />
                  </div>


                </>}

              {/* {!CafId &&
                <div className="input-box form-floating ">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="RCAmount"
                    value={userdata.RCAmount || getCafDigiHome?.paymentDetail?.RCAmount || "NA"}
                    onChange={handleChange}
                    disabled={disableFileds}

                    pattern="[0-9]{10}"
                    style={{ background: "transparent" }}
                    maxLength="10"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (RCAmount.length < 10 || allowedKeys.includes(e.key))
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput cstm-otc" className="mt-2">
                    RC Amount*
                  </label>
                </div> } */}



              <>

                {/* {selectedPaySlipOption === "5" ||
                  selectedPaySlipOption === "4" ? (
                  <div>
                    <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="transactionReferenceID"
                          name="transactionReferenceID"
                          value={transactionrefid}
                          onChange={handleTransactionRefID}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="transactionReferenceID" className="mt-2">
                          Transaction Reference ID*
                        </label>
                      </div>

                    <div className="input-box form-floating">
                      <input
                        type="date"
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        value={selectedDate}
                        placeholder="Select Date"
                        onChange={handleDateChange}
                        // min={getCurrentDate()}
                        style={{ background: "transparent" }}
                        disabled={paymentLinkSentToCustomer == "Yes"}

                      />
                      <label htmlFor="paymentDate" className="mt-2">Payment Date*</label>
                    </div>
                  </div>
                ) : selectedPaySlipOption === "7" ||
                  selectedPaySlipOption === "8" ||
                  selectedPaySlipOption === "11" ? (
                  <div>
                    <div className="input-box form-floating">
                      <input
                        type="date"
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        placeholder="Select Date"
                        value={selectedDate}
                        onChange={handleDateChange}
                        min={getCurrentDate()}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="paymentDate" className="mt-2">Payment Date*</label>
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="transactionReferenceID"
                        name="transactionReferenceID"
                        value={transactionrefid}
                        onChange={handleTransactionRefID}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="transactionReferenceID" className="mt-2">
                        Transaction Reference ID*
                      </label>
                    </div>
                    {selectedPaySlipOption !== "11" && (
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="approvalCode"
                          name="approvalCode"
                          value={approvalCode}
                          onChange={handleApprovalCode}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="approvalCode" className="mt-2">Approval Code*</label>
                      </div>
                    )}
                    {selectedPaySlipOption !== "11" && (
                      <div className="input-box form-floating">
                        <input
                          type="tel"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="creditCardLast4Digits"
                          name="creditCardLast4Digits"
                          value={creditDetails}
                          onChange={handleCreditdetails}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}

                          pattern="[0-9]{10}"
                          maxLength="4"
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ];
                            const isDigit = /\d/.test(e.key);
                            if (
                              (isDigit || allowedKeys.includes(e.key)) &&
                              (creditDetails.length < 4 ||
                                allowedKeys.includes(e.key))
                            ) {
                              return true;
                            } else {
                              e.preventDefault();
                            }
                          }}
                        />
                        <label htmlFor="creditCardLast4Digits" className="mt-2">
                          Card Last 4 Digit No*
                        </label>
                      </div>
                    )}
                  </div>
                ) : null} */}



                {/* <div className="">
                    <label className="select-search-label mt-1">GST*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      name="dnc"
                      styles={style}
                      placeholder="Select Option"
                      value={GstOpts.find((option) => option.value === isGst)}
                      onChange={(selectedOption) =>
                        handleIsGst(selectedOption.value)
                      }
                      options={GstOpts}
                      isDisabled={disableFileds}
                    />
                  </div> */}

                {/* Render GSTnumBER IF not no  */}
                {/* {isGst === "569480000" && (
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="firstName"
                        name="firstName"
                        value={GstNumber}
                        onChange={handleGstNumber}
                        disabled={disableFileds}
                        maxLength="15"
                      />
                      <label htmlFor="floatingInput" className="mt-2">GST Number*</label>
                    </div>
                  )} */}

              </>


              {/* {!CafId &&
                <div className="input-box form-floating ">
                  <input
                    type="tel"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="OTCAmount"
                    value={userdata.OTCAmount || getCafDigiHome?.paymentDetail?.OTCAmount || "NA"}
                    onChange={handleOTCChange}
                    disabled={disableFileds}

                    pattern="[0-9]{10}"
                    style={{ background: "transparent" }}
                    maxLength="10"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (otc.length < 10 || allowedKeys.includes(e.key))
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput cstm-otc" className="mt-2">
                    OTC Amount*
                  </label>
                </div>} */}





              {/* 
              {!CafId &&
                <div className="input-box form-floating ">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="SDAmount"
                    value={userdata.SDAmount || getCafDigiHome?.paymentDetail?.SDAmount || "NA"}
                    onChange={handleChange}
                    disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput cstm-otc" className="mt-2">
                    SD Amount*
                  </label>
                </div>} */}

              {/* <div className="input-box form-floating ">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedSDAmount"
                  value={userdata.ApprovedSDAmount || getCafDigiHome?.paymentDetail?.ApprovedSDAmount || ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Approved SD Amount
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqSDAmount"
                  value={userdata.UpfrontReqSDAmount || getCafDigiHome?.paymentDetail?.UpfrontApprovedRCAmount || ""}
                  onChange={handleChange}
                  disabled={isPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Upfront Requested SD Amount
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedOTCAmount"
                  value={userdata.UpfrontApprovedSDAmount || getCafDigiHome?.paymentDetail?.UpfrontApprovedSDAmount || ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Upfront Approved SD Amount
                </label>
              </div> */}




              {CafId &&
                <>
                  <div className="input-box form-floating ">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="IsPaymentLinkSendToCustomer"
                      value={getCafDetails?.payments?.IsPaymentLinkSendToCustomer || ""}
                      onChange={handleChange}
                      disabled
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput cstm-otc" className="mt-2">
                      Is Payment LinkSend To Customer
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={userdata.dDupStatus || getCafDetails.DedupeDOAstatus}
                      // onChange={handleGstNumber}
                      disabled={true}
                      maxLength="15"
                      readOnly
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">De-dupe Status </label>
                  </div>
                </>}


              {/* {console.log("paymentButton", paymentButton)} */}


              {paymentButton == "Yes" && paymentStatus.label !== "Payment Received" && (
                <div className=" text-center mt-5 mb-3">
                  <button
                    type="button"
                    className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                    onClick={handleSendPaymentLink}
                  >
                    Send payment link
                  </button>
                </div>
              )}

            </form>
          </div>
        )}




        {/* *********Document  toggle******** */}

        {CafId && (
          <div
            className="doc-toggle mt-3"
            hidden={docHide}
            onClick={manageDocClick}
          >
            <span className="toggle-text">Order Documents</span>
            <span className="float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
        )}


        {/* ********* Survey Task ******** */}
        {selectIndustry?.label == "PG" && (userdata?.ProductSegment == "Managed Wi-Fi Business-S" || userdata?.ProductSegment == "Managed Wi-Fi Business") && (
          <div
            className="Remarks-toggle mt-3"
            onClick={() => handleIconClick("SurveyTask")}
          >
            <span className="toggle-text">Survey Task</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
        )}

        {activeForm === "SurveyTask" && (
          <div
            className="container shadow mb-3 bg-body rounded mt-4"
            id="form7"
          >
            <div className="input-box form-floating p-3 select-search-label">
              {getSurveyTaskData?.length > 0 && getSurveyTaskData[0]?.SurveyTaskID !== null ? getSurveyTaskData?.map((data, index) => (
                <div className="mt-2" key={index}>
                  <strong>Survey Task ID: {data?.SurveyTaskID || "NA"}</strong>
                  <div>Contact Person Name: {data?.CustomerName || "NA"}</div>
                  <div>Created BY: {data?.CreatedBy || "NA"}</div>
                  <div>Status: <span style={{ color: data?.Status === "Open" ? "red" : data?.Status === "Approved" ? "green" : "black" }}>{data?.Status || "NA"}</span></div>
                </div>
              )) : <div>No Survey Task Found.</div>}
            </div>

          </div>
        )}

        {/* *********WCR Details  toggle******** */}

        {/* {!wcrFlag && ( */}
        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form9")}
        >
          <span className="toggle-text">Wiring Completion Reports</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* )} */}

        {activeForm === "form9" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form9"
          >
            {/* *********WCR form******** */}
            <div className="input-box form-floating p-3 select-search-label">
              {wcrDetails?.length > 0 ? wcrDetails?.map((data, index) => (
                <div className="input-box form-floating p-2" key={index}>
                  <strong>WCR ID : {data?.WcrID || "NA"}</strong>
                  <div>Owner : {data?.Owner || "NA"}</div>
                  <div>Route Type : {data?.RouteType || "NA"}</div>
                  <div>Pod Name : {data?.PodName || "NA"}</div>
                  {/* <div>Pod Code : {data?.PodCode || "NA"}</div> */}
                  <div>Zone : {data?.Zone || "NA"}</div>
                  <div>Created On : {data?.CreatedOn || "NA"}</div>
                  <div>WCR Status : {data?.WcrStatus || "NA"}</div>
                </div>
              )) : <div>No WCR records found.</div>}
            </div>
          </div>
        )}

        {/* *********Np Details  toggle******** */}

        {/* {!npFlag && ( */}
        <div
          className="np-toggle mt-3"
          onClick={() => handleIconClick("form10")}
        >
          <span className="toggle-text">Network Provisionings</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* )} */}

        {activeForm === "form10" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form10"
          >
            <div className="input-box form-floating p-3 select-search-label">
              {npDetails?.length > 0 ? npDetails?.map((data, index) => (
                <div className="input-box form-floating p-2" key={index}>
                  <strong>Provisioning ID : {data?.NpId || "NA"}</strong>
                  <div>Network Technology : {data?.Ntw_Technology || "NA"}</div>
                  <div>Owner : {data?.Owner || "NA"}</div>
                  <div>Pod Name : {data?.PodName} </div>
                  <div>Route Type : {data?.RouteType || "NA"}</div>
                  <div>Zone : {data?.Zone || "NA"}</div>
                  <div>Provisioning Status : {data?.ProvisioningStatus || "NA"}</div>
                </div>
              )) : <div>No Network Provisioning records found.</div>}
            </div>

          </div>
        )}

        {/* *********IR Details  toggle******** */}


        <div
          className="IR-toggle mt-3"
          onClick={() => handleIconClick("form15")}
        >
          <span className="toggle-text">Installation Reports</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>


        {activeForm === "form15" && (
          <div
            className="container shadow mb-3 bg-body rounded mt-4"
            id="form15"
          >
            {/* *********IR form******** */}
            <div className="input-box form-floating p-3 select-search-label">
              {irDetails?.length > 0 ? irDetails?.map((data, index) => (
                <div className="" key={index}>
                  <strong>Installation Id : {data?.IRId || "NA"}</strong>
                  <div>Network Technology : {data?.Ntw_Technology || "NA"}</div>
                  <div>Owner : {data?.Owner || "NA"}</div>
                  <div>Pod Name : {data?.PodName} </div>
                  <div>Route Type : {data?.RouteType || "NA"}</div>
                  <div>Zone : {data?.Zone || "NA"}</div>
                  <div>IR Status : {data?.IrStatus || "NA"}</div>
                  <div>Installation Date  : {data?.InstallationDate || "NA"}</div>
                </div>
              )) : <div className="">No IR records found.</div>}
            </div>


          </div>
        )}





        {/* *********POA/POI Details  toggle******** */}



        {/* *********OTP  Form******** */}
        {/* {otpAuthStatus === "false" && (
            <div
              className="check-toggle mt-3"
              onClick={() => handleIconClick("form8")}
            >
              <span className="toggle-text">OTP</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
          )} */}

        {activeForm === "form8" && otpAuthStatus === "false" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form8"
          ></div>
        )}

        {otpAuthStatus === "false" && (
          <div className="text-center mb-3 mt-3">
            {/* {!showOtpPage ? (
              <button
                type="submit"
                className="btn text-light  bg-dark mx-auto rounded-pill submit-btn "
                onClick={handleVerifyOtpClick}
              >
                Verify OTP
              </button>
            ) : (
              renderOtpVerificationForm()
            )} */}
          </div>
        )}

        <div className=" " style={{ marginTop: "50px", marginBottom: "40px" }}>
          {CafId && (
            <div className="text-center">
              <button
                type="update"
                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                onClick={handleUpdate}

              >
                Update
              </button>
            </div>
          )}

          {kycDocStatus == "Success" && !CafId && (
            <div className="text-center">
              <button
                type="button"
                className="btn text-light bg-dark mx-auto submit-btn rounded-pill"
                onClick={handleSave}
              // disabled={kycDocStatus !== "Success"}
              >
                Create
              </button>
            </div>
          )}


        </div>

      </div>

    </>
  );
};



export default BusinessCAFmanageForm;
